import { jsx as ot, jsxs as an } from "react/jsx-runtime";
import dt, { useState as ln, useMemo as Yt, useEffect as ds, useContext as hs, useRef as un, useDebugValue as jn, createElement as gs, useCallback as zn, Suspense as $s } from "react";
import { Input as zr, Button as ms, Modal as bs, theme as Le } from "antd";
import ys, { isValidPhoneNumber as vs } from "react-phone-number-input";
import { MapProps as Yn } from "@sezenta/antd-schema-form";
var Wt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _n(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function ws(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function s() {
      if (this instanceof s) {
        var c = [null];
        c.push.apply(c, arguments);
        var l = Function.bind.apply(e, c);
        return new l();
      }
      return e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var c = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(n, s, c.get ? c : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), n;
}
var pn = { exports: {} }, oe = {}, Wn;
function _s() {
  if (Wn)
    return oe;
  Wn = 1, Object.defineProperty(oe, "__esModule", { value: !0 });
  var t, e = dt, n = (t = e) && typeof t == "object" && "default" in t ? t.default : t;
  function s() {
    return (s = Object.assign ? Object.assign.bind() : function(h) {
      for (var b = 1; b < arguments.length; b++) {
        var m = arguments[b];
        for (var E in m)
          Object.prototype.hasOwnProperty.call(m, E) && (h[E] = m[E]);
      }
      return h;
    }).apply(this, arguments);
  }
  var c = [], l = !1, u = function() {
    if (l)
      for (var h; h = c.shift(); )
        h();
  }, a = 0, d = n.forwardRef(function(h, b) {
    var m = h.onLoad, E = h.onReady, $ = h.scriptUrl, v = h.minHeight, S = v === void 0 ? 500 : v, A = h.style, f = A === void 0 ? {} : A, y = e.useRef(h.editorId || "editor-" + ++a), q = e.useRef(!1), k = e.useState(null), _ = k[0], N = k[1], D = e.useCallback(function() {
      if (!q.current) {
        q.current = !0;
        var C = h.options || {}, U = "email";
        C.displayMode != null && (U = C.displayMode, h.projectId && (C.projectId = h.projectId), h.tools && (C.tools = h.tools), h.appearance && (C.appearance = h.appearance), h.locale && (C.locale = h.locale), N(unlayer.createEditor(s({}, C, { id: y.current, displayMode: U, source: { name: "react-email-editor", version: "1.7.8" } }))));
      }
    }, [y.current, h.appearance, h.locale, h.options, h.projectId, h.tools]), z = e.useCallback(function(C, U) {
      _?.addEventListener(C, U);
    }, [_]), nt = e.useCallback(function(C, U) {
      _?.removeEventListener(C, U);
    }, [_]), Et = e.useCallback(function(C, U) {
      _?.registerCallback(C, U);
    }, [_]), kt = e.useCallback(function(C) {
      _?.loadDesign(C);
    }, [_]), Dt = e.useCallback(function(C) {
      _?.saveDesign(C);
    }, [_]), bt = e.useCallback(function(C, U) {
      _?.exportHtml(C, U);
    }, [_]), R = e.useCallback(function(C) {
      _?.exportImage(C);
    }, [_]), W = e.useCallback(function(C) {
      _?.setMergeTags(C);
    }, [_]), X = e.useCallback(function(C) {
      _?.loadBlank(C);
    }, [_]);
    return e.useEffect(function() {
      (function(C, U) {
        if (U === void 0 && (U = "https://editor.unlayer.com/embed.js?2"), function(Q) {
          c.push(Q);
        }(C), function(Q) {
          var O = document.querySelectorAll("script"), Y = !1;
          return O.forEach(function(ft) {
            ft.src.includes(Q) && (Y = !0);
          }), Y;
        }(U))
          u();
        else {
          var tt = document.createElement("script");
          tt.setAttribute("src", U), tt.onload = function() {
            l = !0, u();
          }, document.head.appendChild(tt);
        }
      })(D, $);
    }, [D, $]), e.useEffect(function() {
      if (_) {
        for (var C = 0, U = Object.entries(h); C < U.length; C++) {
          var tt = U[C], Q = tt[0], O = tt[1];
          /^on/.test(Q) && Q !== "onLoad" && Q !== "onReady" && z(Q, O);
        }
        m && m(), E && _.addEventListener("editor:ready", E);
      }
    }, [_, z, m, E, h]), e.useImperativeHandle(b, function() {
      return { saveDesign: Dt, exportHtml: bt, setMergeTags: W, editor: _, loadDesign: kt, registerCallback: Et, addEventListener: z, loadBlank: X, exportImage: R, removeEventListener: nt };
    }, [Dt, bt, W, _, kt, Et, z, X, R, nt]), n.createElement("div", { style: { flex: 1, display: "flex", minHeight: S } }, n.createElement("div", { id: y.current, style: s({}, f, { flex: 1 }) }));
  });
  return oe.EmailEditor = d, oe.default = d, oe;
}
var se = {}, Jn;
function Es() {
  if (Jn)
    return se;
  Jn = 1, Object.defineProperty(se, "__esModule", { value: !0 });
  function t(R) {
    return R && typeof R == "object" && "default" in R ? R.default : R;
  }
  var e = dt, n = t(e);
  function s() {
    return s = Object.assign ? Object.assign.bind() : function(R) {
      for (var W = 1; W < arguments.length; W++) {
        var X = arguments[W];
        for (var C in X)
          Object.prototype.hasOwnProperty.call(X, C) && (R[C] = X[C]);
      }
      return R;
    }, s.apply(this, arguments);
  }
  var c = "react-email-editor", l = "1.7.8", u = "Unlayer's Email Editor Component for React.js", a = "dist/index.js", d = "dist/index.d.ts", h = [
    "dist",
    "src"
  ], b = {
    node: ">=10"
  }, m = {
    start: "tsdx watch",
    build: "tsdx build",
    test: "tsdx test",
    "test:watch": "tsdx test --watch",
    "test:coverage": "tsdx test --coverage",
    lint: "tsdx lint",
    prepare: "tsdx build",
    release: "npm run build && npm publish",
    "netlify-build": "cd demo && npm install && npm run build"
  }, E = {
    react: ">=15"
  }, $ = {
    hooks: {
      "pre-commit": "tsdx lint"
    }
  }, v = {
    "@rollup/plugin-replace": "^5.0.2",
    "@testing-library/react": "^13.4.0",
    "@types/react": "^18.0.27",
    "@types/react-dom": "^18.0.10",
    husky: "^8.0.3",
    react: "^18.2.0",
    "react-dom": "^18.2.0",
    tsdx: "^0.14.1",
    tslib: "^2.4.1",
    typescript: "^4.9.4"
  }, S = "", A = "https://github.com/unlayer/react-email-editor#readme", f = "MIT", y = "https://github.com/unlayer/react-email-editor.git", q = [
    "react-component"
  ], k = {
    name: c,
    version: l,
    description: u,
    main: a,
    typings: d,
    files: h,
    engines: b,
    scripts: m,
    peerDependencies: E,
    husky: $,
    devDependencies: v,
    author: S,
    homepage: A,
    license: f,
    repository: y,
    keywords: q
  }, _ = "https://editor.unlayer.com/embed.js?2", N = [], D = !1, z = function(W) {
    var X = document.querySelectorAll("script"), C = !1;
    return X.forEach(function(U) {
      U.src.includes(W) && (C = !0);
    }), C;
  }, nt = function(W) {
    N.push(W);
  }, Et = function() {
    if (D)
      for (var W; W = N.shift(); )
        W();
  }, kt = function(W, X) {
    if (X === void 0 && (X = _), nt(W), z(X))
      Et();
    else {
      var C = document.createElement("script");
      C.setAttribute("src", X), C.onload = function() {
        D = !0, Et();
      }, document.head.appendChild(C);
    }
  }, Dt = 0, bt = /* @__PURE__ */ n.forwardRef(function(R, W) {
    var X = R.onLoad, C = R.onReady, U = R.scriptUrl, tt = R.minHeight, Q = tt === void 0 ? 500 : tt, O = R.style, Y = O === void 0 ? {} : O, ft = e.useRef(R.editorId || "editor-" + ++Dt), yt = e.useRef(!1), gt = e.useState(null), B = gt[0], vt = gt[1], st = e.useCallback(function() {
      if (!yt.current) {
        yt.current = !0;
        var o = R.options || {};
        R.projectId && (o.projectId = R.projectId), R.tools && (o.tools = R.tools), R.appearance && (o.appearance = R.appearance), R.locale && (o.locale = R.locale);
        var p = "email";
        o.displayMode !== void 0 && (p = o.displayMode), vt(unlayer.createEditor(s({}, o, {
          id: ft.current,
          displayMode: p,
          source: {
            name: k.name,
            version: k.version
          }
        })));
      }
    }, [ft.current, R.appearance, R.locale, R.options, R.projectId, R.tools]), wt = e.useCallback(function(o, p) {
      B?.addEventListener(o, p);
    }, [B]), xt = e.useCallback(function(o, p) {
      B?.removeEventListener(o, p);
    }, [B]), ct = e.useCallback(function(o, p) {
      B?.registerCallback(o, p);
    }, [B]), It = e.useCallback(function(o) {
      B?.loadDesign(o);
    }, [B]), ut = e.useCallback(function(o) {
      B?.saveDesign(o);
    }, [B]), Gt = e.useCallback(function(o, p) {
      B?.exportHtml(o, p);
    }, [B]), me = e.useCallback(function(o) {
      B?.exportImage(o);
    }, [B]), i = e.useCallback(function(o) {
      B?.setMergeTags(o);
    }, [B]), r = e.useCallback(function(o) {
      B?.loadBlank(o);
    }, [B]);
    return e.useEffect(function() {
      kt(st, U);
    }, [st, U]), e.useEffect(function() {
      if (B) {
        for (var o = 0, p = Object.entries(R); o < p.length; o++) {
          var g = p[o], w = g[0], x = g[1];
          /^on/.test(w) && w !== "onLoad" && w !== "onReady" && wt(w, x);
        }
        X && X(), C && B.addEventListener("editor:ready", C);
      }
    }, [B, wt, X, C, R]), e.useImperativeHandle(W, function() {
      return {
        saveDesign: ut,
        exportHtml: Gt,
        setMergeTags: i,
        editor: B,
        loadDesign: It,
        registerCallback: ct,
        addEventListener: wt,
        loadBlank: r,
        exportImage: me,
        removeEventListener: xt
      };
    }, [ut, Gt, i, B, It, ct, wt, r, me, xt]), n.createElement("div", {
      style: {
        flex: 1,
        display: "flex",
        minHeight: Q
      }
    }, n.createElement("div", {
      id: ft.current,
      style: s({}, Y, {
        flex: 1
      })
    }));
  });
  return se.EmailEditor = bt, se.default = bt, se;
}
process.env.NODE_ENV === "production" ? pn.exports = _s() : pn.exports = Es();
var xs = pn.exports;
const qs = /* @__PURE__ */ _n(xs);
var Fe = { exports: {} };
const Ss = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
};
var Xn = Ss, Ts = As;
function As(t) {
  if (t >= 55296 && t <= 57343 || t > 1114111)
    return "�";
  t in Xn && (t = Xn[t]);
  var e = "";
  return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
}
const ks = "Á", Ds = "á", Ls = "Ă", Cs = "ă", Ns = "∾", Rs = "∿", Is = "∾̳", Bs = "Â", Os = "â", Us = "´", Ps = "А", Fs = "а", Vs = "Æ", Ms = "æ", Hs = "⁡", Gs = "𝔄", js = "𝔞", zs = "À", Ys = "à", Ws = "ℵ", Js = "ℵ", Xs = "Α", Zs = "α", Qs = "Ā", Ks = "ā", tc = "⨿", ec = "&", nc = "&", rc = "⩕", oc = "⩓", sc = "∧", cc = "⩜", ic = "⩘", ac = "⩚", lc = "∠", uc = "⦤", pc = "∠", fc = "⦨", dc = "⦩", hc = "⦪", gc = "⦫", $c = "⦬", mc = "⦭", bc = "⦮", yc = "⦯", vc = "∡", wc = "∟", _c = "⊾", Ec = "⦝", xc = "∢", qc = "Å", Sc = "⍼", Tc = "Ą", Ac = "ą", kc = "𝔸", Dc = "𝕒", Lc = "⩯", Cc = "≈", Nc = "⩰", Rc = "≊", Ic = "≋", Bc = "'", Oc = "⁡", Uc = "≈", Pc = "≊", Fc = "Å", Vc = "å", Mc = "𝒜", Hc = "𝒶", Gc = "≔", jc = "*", zc = "≈", Yc = "≍", Wc = "Ã", Jc = "ã", Xc = "Ä", Zc = "ä", Qc = "∳", Kc = "⨑", ti = "≌", ei = "϶", ni = "‵", ri = "∽", oi = "⋍", si = "∖", ci = "⫧", ii = "⊽", ai = "⌅", li = "⌆", ui = "⌅", pi = "⎵", fi = "⎶", di = "≌", hi = "Б", gi = "б", $i = "„", mi = "∵", bi = "∵", yi = "∵", vi = "⦰", wi = "϶", _i = "ℬ", Ei = "ℬ", xi = "Β", qi = "β", Si = "ℶ", Ti = "≬", Ai = "𝔅", ki = "𝔟", Di = "⋂", Li = "◯", Ci = "⋃", Ni = "⨀", Ri = "⨁", Ii = "⨂", Bi = "⨆", Oi = "★", Ui = "▽", Pi = "△", Fi = "⨄", Vi = "⋁", Mi = "⋀", Hi = "⤍", Gi = "⧫", ji = "▪", zi = "▴", Yi = "▾", Wi = "◂", Ji = "▸", Xi = "␣", Zi = "▒", Qi = "░", Ki = "▓", ta = "█", ea = "=⃥", na = "≡⃥", ra = "⫭", oa = "⌐", sa = "𝔹", ca = "𝕓", ia = "⊥", aa = "⊥", la = "⋈", ua = "⧉", pa = "┐", fa = "╕", da = "╖", ha = "╗", ga = "┌", $a = "╒", ma = "╓", ba = "╔", ya = "─", va = "═", wa = "┬", _a = "╤", Ea = "╥", xa = "╦", qa = "┴", Sa = "╧", Ta = "╨", Aa = "╩", ka = "⊟", Da = "⊞", La = "⊠", Ca = "┘", Na = "╛", Ra = "╜", Ia = "╝", Ba = "└", Oa = "╘", Ua = "╙", Pa = "╚", Fa = "│", Va = "║", Ma = "┼", Ha = "╪", Ga = "╫", ja = "╬", za = "┤", Ya = "╡", Wa = "╢", Ja = "╣", Xa = "├", Za = "╞", Qa = "╟", Ka = "╠", tl = "‵", el = "˘", nl = "˘", rl = "¦", ol = "𝒷", sl = "ℬ", cl = "⁏", il = "∽", al = "⋍", ll = "⧅", ul = "\\", pl = "⟈", fl = "•", dl = "•", hl = "≎", gl = "⪮", $l = "≏", ml = "≎", bl = "≏", yl = "Ć", vl = "ć", wl = "⩄", _l = "⩉", El = "⩋", xl = "∩", ql = "⋒", Sl = "⩇", Tl = "⩀", Al = "ⅅ", kl = "∩︀", Dl = "⁁", Ll = "ˇ", Cl = "ℭ", Nl = "⩍", Rl = "Č", Il = "č", Bl = "Ç", Ol = "ç", Ul = "Ĉ", Pl = "ĉ", Fl = "∰", Vl = "⩌", Ml = "⩐", Hl = "Ċ", Gl = "ċ", jl = "¸", zl = "¸", Yl = "⦲", Wl = "¢", Jl = "·", Xl = "·", Zl = "𝔠", Ql = "ℭ", Kl = "Ч", tu = "ч", eu = "✓", nu = "✓", ru = "Χ", ou = "χ", su = "ˆ", cu = "≗", iu = "↺", au = "↻", lu = "⊛", uu = "⊚", pu = "⊝", fu = "⊙", du = "®", hu = "Ⓢ", gu = "⊖", $u = "⊕", mu = "⊗", bu = "○", yu = "⧃", vu = "≗", wu = "⨐", _u = "⫯", Eu = "⧂", xu = "∲", qu = "”", Su = "’", Tu = "♣", Au = "♣", ku = ":", Du = "∷", Lu = "⩴", Cu = "≔", Nu = "≔", Ru = ",", Iu = "@", Bu = "∁", Ou = "∘", Uu = "∁", Pu = "ℂ", Fu = "≅", Vu = "⩭", Mu = "≡", Hu = "∮", Gu = "∯", ju = "∮", zu = "𝕔", Yu = "ℂ", Wu = "∐", Ju = "∐", Xu = "©", Zu = "©", Qu = "℗", Ku = "∳", tp = "↵", ep = "✗", np = "⨯", rp = "𝒞", op = "𝒸", sp = "⫏", cp = "⫑", ip = "⫐", ap = "⫒", lp = "⋯", up = "⤸", pp = "⤵", fp = "⋞", dp = "⋟", hp = "↶", gp = "⤽", $p = "⩈", mp = "⩆", bp = "≍", yp = "∪", vp = "⋓", wp = "⩊", _p = "⊍", Ep = "⩅", xp = "∪︀", qp = "↷", Sp = "⤼", Tp = "⋞", Ap = "⋟", kp = "⋎", Dp = "⋏", Lp = "¤", Cp = "↶", Np = "↷", Rp = "⋎", Ip = "⋏", Bp = "∲", Op = "∱", Up = "⌭", Pp = "†", Fp = "‡", Vp = "ℸ", Mp = "↓", Hp = "↡", Gp = "⇓", jp = "‐", zp = "⫤", Yp = "⊣", Wp = "⤏", Jp = "˝", Xp = "Ď", Zp = "ď", Qp = "Д", Kp = "д", tf = "‡", ef = "⇊", nf = "ⅅ", rf = "ⅆ", of = "⤑", sf = "⩷", cf = "°", af = "∇", lf = "Δ", uf = "δ", pf = "⦱", ff = "⥿", df = "𝔇", hf = "𝔡", gf = "⥥", $f = "⇃", mf = "⇂", bf = "´", yf = "˙", vf = "˝", wf = "`", _f = "˜", Ef = "⋄", xf = "⋄", qf = "⋄", Sf = "♦", Tf = "♦", Af = "¨", kf = "ⅆ", Df = "ϝ", Lf = "⋲", Cf = "÷", Nf = "÷", Rf = "⋇", If = "⋇", Bf = "Ђ", Of = "ђ", Uf = "⌞", Pf = "⌍", Ff = "$", Vf = "𝔻", Mf = "𝕕", Hf = "¨", Gf = "˙", jf = "⃜", zf = "≐", Yf = "≑", Wf = "≐", Jf = "∸", Xf = "∔", Zf = "⊡", Qf = "⌆", Kf = "∯", td = "¨", ed = "⇓", nd = "⇐", rd = "⇔", od = "⫤", sd = "⟸", cd = "⟺", id = "⟹", ad = "⇒", ld = "⊨", ud = "⇑", pd = "⇕", fd = "∥", dd = "⤓", hd = "↓", gd = "↓", $d = "⇓", md = "⇵", bd = "̑", yd = "⇊", vd = "⇃", wd = "⇂", _d = "⥐", Ed = "⥞", xd = "⥖", qd = "↽", Sd = "⥟", Td = "⥗", Ad = "⇁", kd = "↧", Dd = "⊤", Ld = "⤐", Cd = "⌟", Nd = "⌌", Rd = "𝒟", Id = "𝒹", Bd = "Ѕ", Od = "ѕ", Ud = "⧶", Pd = "Đ", Fd = "đ", Vd = "⋱", Md = "▿", Hd = "▾", Gd = "⇵", jd = "⥯", zd = "⦦", Yd = "Џ", Wd = "џ", Jd = "⟿", Xd = "É", Zd = "é", Qd = "⩮", Kd = "Ě", th = "ě", eh = "Ê", nh = "ê", rh = "≖", oh = "≕", sh = "Э", ch = "э", ih = "⩷", ah = "Ė", lh = "ė", uh = "≑", ph = "ⅇ", fh = "≒", dh = "𝔈", hh = "𝔢", gh = "⪚", $h = "È", mh = "è", bh = "⪖", yh = "⪘", vh = "⪙", wh = "∈", _h = "⏧", Eh = "ℓ", xh = "⪕", qh = "⪗", Sh = "Ē", Th = "ē", Ah = "∅", kh = "∅", Dh = "◻", Lh = "∅", Ch = "▫", Nh = " ", Rh = " ", Ih = " ", Bh = "Ŋ", Oh = "ŋ", Uh = " ", Ph = "Ę", Fh = "ę", Vh = "𝔼", Mh = "𝕖", Hh = "⋕", Gh = "⧣", jh = "⩱", zh = "ε", Yh = "Ε", Wh = "ε", Jh = "ϵ", Xh = "≖", Zh = "≕", Qh = "≂", Kh = "⪖", t1 = "⪕", e1 = "⩵", n1 = "=", r1 = "≂", o1 = "≟", s1 = "⇌", c1 = "≡", i1 = "⩸", a1 = "⧥", l1 = "⥱", u1 = "≓", p1 = "ℯ", f1 = "ℰ", d1 = "≐", h1 = "⩳", g1 = "≂", $1 = "Η", m1 = "η", b1 = "Ð", y1 = "ð", v1 = "Ë", w1 = "ë", _1 = "€", E1 = "!", x1 = "∃", q1 = "∃", S1 = "ℰ", T1 = "ⅇ", A1 = "ⅇ", k1 = "≒", D1 = "Ф", L1 = "ф", C1 = "♀", N1 = "ﬃ", R1 = "ﬀ", I1 = "ﬄ", B1 = "𝔉", O1 = "𝔣", U1 = "ﬁ", P1 = "◼", F1 = "▪", V1 = "fj", M1 = "♭", H1 = "ﬂ", G1 = "▱", j1 = "ƒ", z1 = "𝔽", Y1 = "𝕗", W1 = "∀", J1 = "∀", X1 = "⋔", Z1 = "⫙", Q1 = "ℱ", K1 = "⨍", tg = "½", eg = "⅓", ng = "¼", rg = "⅕", og = "⅙", sg = "⅛", cg = "⅔", ig = "⅖", ag = "¾", lg = "⅗", ug = "⅜", pg = "⅘", fg = "⅚", dg = "⅝", hg = "⅞", gg = "⁄", $g = "⌢", mg = "𝒻", bg = "ℱ", yg = "ǵ", vg = "Γ", wg = "γ", _g = "Ϝ", Eg = "ϝ", xg = "⪆", qg = "Ğ", Sg = "ğ", Tg = "Ģ", Ag = "Ĝ", kg = "ĝ", Dg = "Г", Lg = "г", Cg = "Ġ", Ng = "ġ", Rg = "≥", Ig = "≧", Bg = "⪌", Og = "⋛", Ug = "≥", Pg = "≧", Fg = "⩾", Vg = "⪩", Mg = "⩾", Hg = "⪀", Gg = "⪂", jg = "⪄", zg = "⋛︀", Yg = "⪔", Wg = "𝔊", Jg = "𝔤", Xg = "≫", Zg = "⋙", Qg = "⋙", Kg = "ℷ", t$ = "Ѓ", e$ = "ѓ", n$ = "⪥", r$ = "≷", o$ = "⪒", s$ = "⪤", c$ = "⪊", i$ = "⪊", a$ = "⪈", l$ = "≩", u$ = "⪈", p$ = "≩", f$ = "⋧", d$ = "𝔾", h$ = "𝕘", g$ = "`", $$ = "≥", m$ = "⋛", b$ = "≧", y$ = "⪢", v$ = "≷", w$ = "⩾", _$ = "≳", E$ = "𝒢", x$ = "ℊ", q$ = "≳", S$ = "⪎", T$ = "⪐", A$ = "⪧", k$ = "⩺", D$ = ">", L$ = ">", C$ = "≫", N$ = "⋗", R$ = "⦕", I$ = "⩼", B$ = "⪆", O$ = "⥸", U$ = "⋗", P$ = "⋛", F$ = "⪌", V$ = "≷", M$ = "≳", H$ = "≩︀", G$ = "≩︀", j$ = "ˇ", z$ = " ", Y$ = "½", W$ = "ℋ", J$ = "Ъ", X$ = "ъ", Z$ = "⥈", Q$ = "↔", K$ = "⇔", tm = "↭", em = "^", nm = "ℏ", rm = "Ĥ", om = "ĥ", sm = "♥", cm = "♥", im = "…", am = "⊹", lm = "𝔥", um = "ℌ", pm = "ℋ", fm = "⤥", dm = "⤦", hm = "⇿", gm = "∻", $m = "↩", mm = "↪", bm = "𝕙", ym = "ℍ", vm = "―", wm = "─", _m = "𝒽", Em = "ℋ", xm = "ℏ", qm = "Ħ", Sm = "ħ", Tm = "≎", Am = "≏", km = "⁃", Dm = "‐", Lm = "Í", Cm = "í", Nm = "⁣", Rm = "Î", Im = "î", Bm = "И", Om = "и", Um = "İ", Pm = "Е", Fm = "е", Vm = "¡", Mm = "⇔", Hm = "𝔦", Gm = "ℑ", jm = "Ì", zm = "ì", Ym = "ⅈ", Wm = "⨌", Jm = "∭", Xm = "⧜", Zm = "℩", Qm = "Ĳ", Km = "ĳ", tb = "Ī", eb = "ī", nb = "ℑ", rb = "ⅈ", ob = "ℐ", sb = "ℑ", cb = "ı", ib = "ℑ", ab = "⊷", lb = "Ƶ", ub = "⇒", pb = "℅", fb = "∞", db = "⧝", hb = "ı", gb = "⊺", $b = "∫", mb = "∬", bb = "ℤ", yb = "∫", vb = "⊺", wb = "⋂", _b = "⨗", Eb = "⨼", xb = "⁣", qb = "⁢", Sb = "Ё", Tb = "ё", Ab = "Į", kb = "į", Db = "𝕀", Lb = "𝕚", Cb = "Ι", Nb = "ι", Rb = "⨼", Ib = "¿", Bb = "𝒾", Ob = "ℐ", Ub = "∈", Pb = "⋵", Fb = "⋹", Vb = "⋴", Mb = "⋳", Hb = "∈", Gb = "⁢", jb = "Ĩ", zb = "ĩ", Yb = "І", Wb = "і", Jb = "Ï", Xb = "ï", Zb = "Ĵ", Qb = "ĵ", Kb = "Й", ty = "й", ey = "𝔍", ny = "𝔧", ry = "ȷ", oy = "𝕁", sy = "𝕛", cy = "𝒥", iy = "𝒿", ay = "Ј", ly = "ј", uy = "Є", py = "є", fy = "Κ", dy = "κ", hy = "ϰ", gy = "Ķ", $y = "ķ", my = "К", by = "к", yy = "𝔎", vy = "𝔨", wy = "ĸ", _y = "Х", Ey = "х", xy = "Ќ", qy = "ќ", Sy = "𝕂", Ty = "𝕜", Ay = "𝒦", ky = "𝓀", Dy = "⇚", Ly = "Ĺ", Cy = "ĺ", Ny = "⦴", Ry = "ℒ", Iy = "Λ", By = "λ", Oy = "⟨", Uy = "⟪", Py = "⦑", Fy = "⟨", Vy = "⪅", My = "ℒ", Hy = "«", Gy = "⇤", jy = "⤟", zy = "←", Yy = "↞", Wy = "⇐", Jy = "⤝", Xy = "↩", Zy = "↫", Qy = "⤹", Ky = "⥳", tv = "↢", ev = "⤙", nv = "⤛", rv = "⪫", ov = "⪭", sv = "⪭︀", cv = "⤌", iv = "⤎", av = "❲", lv = "{", uv = "[", pv = "⦋", fv = "⦏", dv = "⦍", hv = "Ľ", gv = "ľ", $v = "Ļ", mv = "ļ", bv = "⌈", yv = "{", vv = "Л", wv = "л", _v = "⤶", Ev = "“", xv = "„", qv = "⥧", Sv = "⥋", Tv = "↲", Av = "≤", kv = "≦", Dv = "⟨", Lv = "⇤", Cv = "←", Nv = "←", Rv = "⇐", Iv = "⇆", Bv = "↢", Ov = "⌈", Uv = "⟦", Pv = "⥡", Fv = "⥙", Vv = "⇃", Mv = "⌊", Hv = "↽", Gv = "↼", jv = "⇇", zv = "↔", Yv = "↔", Wv = "⇔", Jv = "⇆", Xv = "⇋", Zv = "↭", Qv = "⥎", Kv = "↤", tw = "⊣", ew = "⥚", nw = "⋋", rw = "⧏", ow = "⊲", sw = "⊴", cw = "⥑", iw = "⥠", aw = "⥘", lw = "↿", uw = "⥒", pw = "↼", fw = "⪋", dw = "⋚", hw = "≤", gw = "≦", $w = "⩽", mw = "⪨", bw = "⩽", yw = "⩿", vw = "⪁", ww = "⪃", _w = "⋚︀", Ew = "⪓", xw = "⪅", qw = "⋖", Sw = "⋚", Tw = "⪋", Aw = "⋚", kw = "≦", Dw = "≶", Lw = "≶", Cw = "⪡", Nw = "≲", Rw = "⩽", Iw = "≲", Bw = "⥼", Ow = "⌊", Uw = "𝔏", Pw = "𝔩", Fw = "≶", Vw = "⪑", Mw = "⥢", Hw = "↽", Gw = "↼", jw = "⥪", zw = "▄", Yw = "Љ", Ww = "љ", Jw = "⇇", Xw = "≪", Zw = "⋘", Qw = "⌞", Kw = "⇚", t0 = "⥫", e0 = "◺", n0 = "Ŀ", r0 = "ŀ", o0 = "⎰", s0 = "⎰", c0 = "⪉", i0 = "⪉", a0 = "⪇", l0 = "≨", u0 = "⪇", p0 = "≨", f0 = "⋦", d0 = "⟬", h0 = "⇽", g0 = "⟦", $0 = "⟵", m0 = "⟵", b0 = "⟸", y0 = "⟷", v0 = "⟷", w0 = "⟺", _0 = "⟼", E0 = "⟶", x0 = "⟶", q0 = "⟹", S0 = "↫", T0 = "↬", A0 = "⦅", k0 = "𝕃", D0 = "𝕝", L0 = "⨭", C0 = "⨴", N0 = "∗", R0 = "_", I0 = "↙", B0 = "↘", O0 = "◊", U0 = "◊", P0 = "⧫", F0 = "(", V0 = "⦓", M0 = "⇆", H0 = "⌟", G0 = "⇋", j0 = "⥭", z0 = "‎", Y0 = "⊿", W0 = "‹", J0 = "𝓁", X0 = "ℒ", Z0 = "↰", Q0 = "↰", K0 = "≲", t_ = "⪍", e_ = "⪏", n_ = "[", r_ = "‘", o_ = "‚", s_ = "Ł", c_ = "ł", i_ = "⪦", a_ = "⩹", l_ = "<", u_ = "<", p_ = "≪", f_ = "⋖", d_ = "⋋", h_ = "⋉", g_ = "⥶", $_ = "⩻", m_ = "◃", b_ = "⊴", y_ = "◂", v_ = "⦖", w_ = "⥊", __ = "⥦", E_ = "≨︀", x_ = "≨︀", q_ = "¯", S_ = "♂", T_ = "✠", A_ = "✠", k_ = "↦", D_ = "↦", L_ = "↧", C_ = "↤", N_ = "↥", R_ = "▮", I_ = "⨩", B_ = "М", O_ = "м", U_ = "—", P_ = "∺", F_ = "∡", V_ = " ", M_ = "ℳ", H_ = "𝔐", G_ = "𝔪", j_ = "℧", z_ = "µ", Y_ = "*", W_ = "⫰", J_ = "∣", X_ = "·", Z_ = "⊟", Q_ = "−", K_ = "∸", tE = "⨪", eE = "∓", nE = "⫛", rE = "…", oE = "∓", sE = "⊧", cE = "𝕄", iE = "𝕞", aE = "∓", lE = "𝓂", uE = "ℳ", pE = "∾", fE = "Μ", dE = "μ", hE = "⊸", gE = "⊸", $E = "∇", mE = "Ń", bE = "ń", yE = "∠⃒", vE = "≉", wE = "⩰̸", _E = "≋̸", EE = "ŉ", xE = "≉", qE = "♮", SE = "ℕ", TE = "♮", AE = " ", kE = "≎̸", DE = "≏̸", LE = "⩃", CE = "Ň", NE = "ň", RE = "Ņ", IE = "ņ", BE = "≇", OE = "⩭̸", UE = "⩂", PE = "Н", FE = "н", VE = "–", ME = "⤤", HE = "↗", GE = "⇗", jE = "↗", zE = "≠", YE = "≐̸", WE = "​", JE = "​", XE = "​", ZE = "​", QE = "≢", KE = "⤨", tx = "≂̸", ex = "≫", nx = "≪", rx = `
`, ox = "∄", sx = "∄", cx = "𝔑", ix = "𝔫", ax = "≧̸", lx = "≱", ux = "≱", px = "≧̸", fx = "⩾̸", dx = "⩾̸", hx = "⋙̸", gx = "≵", $x = "≫⃒", mx = "≯", bx = "≯", yx = "≫̸", vx = "↮", wx = "⇎", _x = "⫲", Ex = "∋", xx = "⋼", qx = "⋺", Sx = "∋", Tx = "Њ", Ax = "њ", kx = "↚", Dx = "⇍", Lx = "‥", Cx = "≦̸", Nx = "≰", Rx = "↚", Ix = "⇍", Bx = "↮", Ox = "⇎", Ux = "≰", Px = "≦̸", Fx = "⩽̸", Vx = "⩽̸", Mx = "≮", Hx = "⋘̸", Gx = "≴", jx = "≪⃒", zx = "≮", Yx = "⋪", Wx = "⋬", Jx = "≪̸", Xx = "∤", Zx = "⁠", Qx = " ", Kx = "𝕟", tq = "ℕ", eq = "⫬", nq = "¬", rq = "≢", oq = "≭", sq = "∦", cq = "∉", iq = "≠", aq = "≂̸", lq = "∄", uq = "≯", pq = "≱", fq = "≧̸", dq = "≫̸", hq = "≹", gq = "⩾̸", $q = "≵", mq = "≎̸", bq = "≏̸", yq = "∉", vq = "⋵̸", wq = "⋹̸", _q = "∉", Eq = "⋷", xq = "⋶", qq = "⧏̸", Sq = "⋪", Tq = "⋬", Aq = "≮", kq = "≰", Dq = "≸", Lq = "≪̸", Cq = "⩽̸", Nq = "≴", Rq = "⪢̸", Iq = "⪡̸", Bq = "∌", Oq = "∌", Uq = "⋾", Pq = "⋽", Fq = "⊀", Vq = "⪯̸", Mq = "⋠", Hq = "∌", Gq = "⧐̸", jq = "⋫", zq = "⋭", Yq = "⊏̸", Wq = "⋢", Jq = "⊐̸", Xq = "⋣", Zq = "⊂⃒", Qq = "⊈", Kq = "⊁", tS = "⪰̸", eS = "⋡", nS = "≿̸", rS = "⊃⃒", oS = "⊉", sS = "≁", cS = "≄", iS = "≇", aS = "≉", lS = "∤", uS = "∦", pS = "∦", fS = "⫽⃥", dS = "∂̸", hS = "⨔", gS = "⊀", $S = "⋠", mS = "⊀", bS = "⪯̸", yS = "⪯̸", vS = "⤳̸", wS = "↛", _S = "⇏", ES = "↝̸", xS = "↛", qS = "⇏", SS = "⋫", TS = "⋭", AS = "⊁", kS = "⋡", DS = "⪰̸", LS = "𝒩", CS = "𝓃", NS = "∤", RS = "∦", IS = "≁", BS = "≄", OS = "≄", US = "∤", PS = "∦", FS = "⋢", VS = "⋣", MS = "⊄", HS = "⫅̸", GS = "⊈", jS = "⊂⃒", zS = "⊈", YS = "⫅̸", WS = "⊁", JS = "⪰̸", XS = "⊅", ZS = "⫆̸", QS = "⊉", KS = "⊃⃒", tT = "⊉", eT = "⫆̸", nT = "≹", rT = "Ñ", oT = "ñ", sT = "≸", cT = "⋪", iT = "⋬", aT = "⋫", lT = "⋭", uT = "Ν", pT = "ν", fT = "#", dT = "№", hT = " ", gT = "≍⃒", $T = "⊬", mT = "⊭", bT = "⊮", yT = "⊯", vT = "≥⃒", wT = ">⃒", _T = "⤄", ET = "⧞", xT = "⤂", qT = "≤⃒", ST = "<⃒", TT = "⊴⃒", AT = "⤃", kT = "⊵⃒", DT = "∼⃒", LT = "⤣", CT = "↖", NT = "⇖", RT = "↖", IT = "⤧", BT = "Ó", OT = "ó", UT = "⊛", PT = "Ô", FT = "ô", VT = "⊚", MT = "О", HT = "о", GT = "⊝", jT = "Ő", zT = "ő", YT = "⨸", WT = "⊙", JT = "⦼", XT = "Œ", ZT = "œ", QT = "⦿", KT = "𝔒", tA = "𝔬", eA = "˛", nA = "Ò", rA = "ò", oA = "⧁", sA = "⦵", cA = "Ω", iA = "∮", aA = "↺", lA = "⦾", uA = "⦻", pA = "‾", fA = "⧀", dA = "Ō", hA = "ō", gA = "Ω", $A = "ω", mA = "Ο", bA = "ο", yA = "⦶", vA = "⊖", wA = "𝕆", _A = "𝕠", EA = "⦷", xA = "“", qA = "‘", SA = "⦹", TA = "⊕", AA = "↻", kA = "⩔", DA = "∨", LA = "⩝", CA = "ℴ", NA = "ℴ", RA = "ª", IA = "º", BA = "⊶", OA = "⩖", UA = "⩗", PA = "⩛", FA = "Ⓢ", VA = "𝒪", MA = "ℴ", HA = "Ø", GA = "ø", jA = "⊘", zA = "Õ", YA = "õ", WA = "⨶", JA = "⨷", XA = "⊗", ZA = "Ö", QA = "ö", KA = "⌽", tk = "‾", ek = "⏞", nk = "⎴", rk = "⏜", ok = "¶", sk = "∥", ck = "∥", ik = "⫳", ak = "⫽", lk = "∂", uk = "∂", pk = "П", fk = "п", dk = "%", hk = ".", gk = "‰", $k = "⊥", mk = "‱", bk = "𝔓", yk = "𝔭", vk = "Φ", wk = "φ", _k = "ϕ", Ek = "ℳ", xk = "☎", qk = "Π", Sk = "π", Tk = "⋔", Ak = "ϖ", kk = "ℏ", Dk = "ℎ", Lk = "ℏ", Ck = "⨣", Nk = "⊞", Rk = "⨢", Ik = "+", Bk = "∔", Ok = "⨥", Uk = "⩲", Pk = "±", Fk = "±", Vk = "⨦", Mk = "⨧", Hk = "±", Gk = "ℌ", jk = "⨕", zk = "𝕡", Yk = "ℙ", Wk = "£", Jk = "⪷", Xk = "⪻", Zk = "≺", Qk = "≼", Kk = "⪷", tD = "≺", eD = "≼", nD = "≺", rD = "⪯", oD = "≼", sD = "≾", cD = "⪯", iD = "⪹", aD = "⪵", lD = "⋨", uD = "⪯", pD = "⪳", fD = "≾", dD = "′", hD = "″", gD = "ℙ", $D = "⪹", mD = "⪵", bD = "⋨", yD = "∏", vD = "∏", wD = "⌮", _D = "⌒", ED = "⌓", xD = "∝", qD = "∝", SD = "∷", TD = "∝", AD = "≾", kD = "⊰", DD = "𝒫", LD = "𝓅", CD = "Ψ", ND = "ψ", RD = " ", ID = "𝔔", BD = "𝔮", OD = "⨌", UD = "𝕢", PD = "ℚ", FD = "⁗", VD = "𝒬", MD = "𝓆", HD = "ℍ", GD = "⨖", jD = "?", zD = "≟", YD = '"', WD = '"', JD = "⇛", XD = "∽̱", ZD = "Ŕ", QD = "ŕ", KD = "√", tL = "⦳", eL = "⟩", nL = "⟫", rL = "⦒", oL = "⦥", sL = "⟩", cL = "»", iL = "⥵", aL = "⇥", lL = "⤠", uL = "⤳", pL = "→", fL = "↠", dL = "⇒", hL = "⤞", gL = "↪", $L = "↬", mL = "⥅", bL = "⥴", yL = "⤖", vL = "↣", wL = "↝", _L = "⤚", EL = "⤜", xL = "∶", qL = "ℚ", SL = "⤍", TL = "⤏", AL = "⤐", kL = "❳", DL = "}", LL = "]", CL = "⦌", NL = "⦎", RL = "⦐", IL = "Ř", BL = "ř", OL = "Ŗ", UL = "ŗ", PL = "⌉", FL = "}", VL = "Р", ML = "р", HL = "⤷", GL = "⥩", jL = "”", zL = "”", YL = "↳", WL = "ℜ", JL = "ℛ", XL = "ℜ", ZL = "ℝ", QL = "ℜ", KL = "▭", tC = "®", eC = "®", nC = "∋", rC = "⇋", oC = "⥯", sC = "⥽", cC = "⌋", iC = "𝔯", aC = "ℜ", lC = "⥤", uC = "⇁", pC = "⇀", fC = "⥬", dC = "Ρ", hC = "ρ", gC = "ϱ", $C = "⟩", mC = "⇥", bC = "→", yC = "→", vC = "⇒", wC = "⇄", _C = "↣", EC = "⌉", xC = "⟧", qC = "⥝", SC = "⥕", TC = "⇂", AC = "⌋", kC = "⇁", DC = "⇀", LC = "⇄", CC = "⇌", NC = "⇉", RC = "↝", IC = "↦", BC = "⊢", OC = "⥛", UC = "⋌", PC = "⧐", FC = "⊳", VC = "⊵", MC = "⥏", HC = "⥜", GC = "⥔", jC = "↾", zC = "⥓", YC = "⇀", WC = "˚", JC = "≓", XC = "⇄", ZC = "⇌", QC = "‏", KC = "⎱", tN = "⎱", eN = "⫮", nN = "⟭", rN = "⇾", oN = "⟧", sN = "⦆", cN = "𝕣", iN = "ℝ", aN = "⨮", lN = "⨵", uN = "⥰", pN = ")", fN = "⦔", dN = "⨒", hN = "⇉", gN = "⇛", $N = "›", mN = "𝓇", bN = "ℛ", yN = "↱", vN = "↱", wN = "]", _N = "’", EN = "’", xN = "⋌", qN = "⋊", SN = "▹", TN = "⊵", AN = "▸", kN = "⧎", DN = "⧴", LN = "⥨", CN = "℞", NN = "Ś", RN = "ś", IN = "‚", BN = "⪸", ON = "Š", UN = "š", PN = "⪼", FN = "≻", VN = "≽", MN = "⪰", HN = "⪴", GN = "Ş", jN = "ş", zN = "Ŝ", YN = "ŝ", WN = "⪺", JN = "⪶", XN = "⋩", ZN = "⨓", QN = "≿", KN = "С", tR = "с", eR = "⊡", nR = "⋅", rR = "⩦", oR = "⤥", sR = "↘", cR = "⇘", iR = "↘", aR = "§", lR = ";", uR = "⤩", pR = "∖", fR = "∖", dR = "✶", hR = "𝔖", gR = "𝔰", $R = "⌢", mR = "♯", bR = "Щ", yR = "щ", vR = "Ш", wR = "ш", _R = "↓", ER = "←", xR = "∣", qR = "∥", SR = "→", TR = "↑", AR = "­", kR = "Σ", DR = "σ", LR = "ς", CR = "ς", NR = "∼", RR = "⩪", IR = "≃", BR = "≃", OR = "⪞", UR = "⪠", PR = "⪝", FR = "⪟", VR = "≆", MR = "⨤", HR = "⥲", GR = "←", jR = "∘", zR = "∖", YR = "⨳", WR = "⧤", JR = "∣", XR = "⌣", ZR = "⪪", QR = "⪬", KR = "⪬︀", t2 = "Ь", e2 = "ь", n2 = "⌿", r2 = "⧄", o2 = "/", s2 = "𝕊", c2 = "𝕤", i2 = "♠", a2 = "♠", l2 = "∥", u2 = "⊓", p2 = "⊓︀", f2 = "⊔", d2 = "⊔︀", h2 = "√", g2 = "⊏", $2 = "⊑", m2 = "⊏", b2 = "⊑", y2 = "⊐", v2 = "⊒", w2 = "⊐", _2 = "⊒", E2 = "□", x2 = "□", q2 = "⊓", S2 = "⊏", T2 = "⊑", A2 = "⊐", k2 = "⊒", D2 = "⊔", L2 = "▪", C2 = "□", N2 = "▪", R2 = "→", I2 = "𝒮", B2 = "𝓈", O2 = "∖", U2 = "⌣", P2 = "⋆", F2 = "⋆", V2 = "☆", M2 = "★", H2 = "ϵ", G2 = "ϕ", j2 = "¯", z2 = "⊂", Y2 = "⋐", W2 = "⪽", J2 = "⫅", X2 = "⊆", Z2 = "⫃", Q2 = "⫁", K2 = "⫋", tI = "⊊", eI = "⪿", nI = "⥹", rI = "⊂", oI = "⋐", sI = "⊆", cI = "⫅", iI = "⊆", aI = "⊊", lI = "⫋", uI = "⫇", pI = "⫕", fI = "⫓", dI = "⪸", hI = "≻", gI = "≽", $I = "≻", mI = "⪰", bI = "≽", yI = "≿", vI = "⪰", wI = "⪺", _I = "⪶", EI = "⋩", xI = "≿", qI = "∋", SI = "∑", TI = "∑", AI = "♪", kI = "¹", DI = "²", LI = "³", CI = "⊃", NI = "⋑", RI = "⪾", II = "⫘", BI = "⫆", OI = "⊇", UI = "⫄", PI = "⊃", FI = "⊇", VI = "⟉", MI = "⫗", HI = "⥻", GI = "⫂", jI = "⫌", zI = "⊋", YI = "⫀", WI = "⊃", JI = "⋑", XI = "⊇", ZI = "⫆", QI = "⊋", KI = "⫌", tB = "⫈", eB = "⫔", nB = "⫖", rB = "⤦", oB = "↙", sB = "⇙", cB = "↙", iB = "⤪", aB = "ß", lB = "	", uB = "⌖", pB = "Τ", fB = "τ", dB = "⎴", hB = "Ť", gB = "ť", $B = "Ţ", mB = "ţ", bB = "Т", yB = "т", vB = "⃛", wB = "⌕", _B = "𝔗", EB = "𝔱", xB = "∴", qB = "∴", SB = "∴", TB = "Θ", AB = "θ", kB = "ϑ", DB = "ϑ", LB = "≈", CB = "∼", NB = "  ", RB = " ", IB = " ", BB = "≈", OB = "∼", UB = "Þ", PB = "þ", FB = "˜", VB = "∼", MB = "≃", HB = "≅", GB = "≈", jB = "⨱", zB = "⊠", YB = "×", WB = "⨰", JB = "∭", XB = "⤨", ZB = "⌶", QB = "⫱", KB = "⊤", t3 = "𝕋", e3 = "𝕥", n3 = "⫚", r3 = "⤩", o3 = "‴", s3 = "™", c3 = "™", i3 = "▵", a3 = "▿", l3 = "◃", u3 = "⊴", p3 = "≜", f3 = "▹", d3 = "⊵", h3 = "◬", g3 = "≜", $3 = "⨺", m3 = "⃛", b3 = "⨹", y3 = "⧍", v3 = "⨻", w3 = "⏢", _3 = "𝒯", E3 = "𝓉", x3 = "Ц", q3 = "ц", S3 = "Ћ", T3 = "ћ", A3 = "Ŧ", k3 = "ŧ", D3 = "≬", L3 = "↞", C3 = "↠", N3 = "Ú", R3 = "ú", I3 = "↑", B3 = "↟", O3 = "⇑", U3 = "⥉", P3 = "Ў", F3 = "ў", V3 = "Ŭ", M3 = "ŭ", H3 = "Û", G3 = "û", j3 = "У", z3 = "у", Y3 = "⇅", W3 = "Ű", J3 = "ű", X3 = "⥮", Z3 = "⥾", Q3 = "𝔘", K3 = "𝔲", tO = "Ù", eO = "ù", nO = "⥣", rO = "↿", oO = "↾", sO = "▀", cO = "⌜", iO = "⌜", aO = "⌏", lO = "◸", uO = "Ū", pO = "ū", fO = "¨", dO = "_", hO = "⏟", gO = "⎵", $O = "⏝", mO = "⋃", bO = "⊎", yO = "Ų", vO = "ų", wO = "𝕌", _O = "𝕦", EO = "⤒", xO = "↑", qO = "↑", SO = "⇑", TO = "⇅", AO = "↕", kO = "↕", DO = "⇕", LO = "⥮", CO = "↿", NO = "↾", RO = "⊎", IO = "↖", BO = "↗", OO = "υ", UO = "ϒ", PO = "ϒ", FO = "Υ", VO = "υ", MO = "↥", HO = "⊥", GO = "⇈", jO = "⌝", zO = "⌝", YO = "⌎", WO = "Ů", JO = "ů", XO = "◹", ZO = "𝒰", QO = "𝓊", KO = "⋰", tU = "Ũ", eU = "ũ", nU = "▵", rU = "▴", oU = "⇈", sU = "Ü", cU = "ü", iU = "⦧", aU = "⦜", lU = "ϵ", uU = "ϰ", pU = "∅", fU = "ϕ", dU = "ϖ", hU = "∝", gU = "↕", $U = "⇕", mU = "ϱ", bU = "ς", yU = "⊊︀", vU = "⫋︀", wU = "⊋︀", _U = "⫌︀", EU = "ϑ", xU = "⊲", qU = "⊳", SU = "⫨", TU = "⫫", AU = "⫩", kU = "В", DU = "в", LU = "⊢", CU = "⊨", NU = "⊩", RU = "⊫", IU = "⫦", BU = "⊻", OU = "∨", UU = "⋁", PU = "≚", FU = "⋮", VU = "|", MU = "‖", HU = "|", GU = "‖", jU = "∣", zU = "|", YU = "❘", WU = "≀", JU = " ", XU = "𝔙", ZU = "𝔳", QU = "⊲", KU = "⊂⃒", tP = "⊃⃒", eP = "𝕍", nP = "𝕧", rP = "∝", oP = "⊳", sP = "𝒱", cP = "𝓋", iP = "⫋︀", aP = "⊊︀", lP = "⫌︀", uP = "⊋︀", pP = "⊪", fP = "⦚", dP = "Ŵ", hP = "ŵ", gP = "⩟", $P = "∧", mP = "⋀", bP = "≙", yP = "℘", vP = "𝔚", wP = "𝔴", _P = "𝕎", EP = "𝕨", xP = "℘", qP = "≀", SP = "≀", TP = "𝒲", AP = "𝓌", kP = "⋂", DP = "◯", LP = "⋃", CP = "▽", NP = "𝔛", RP = "𝔵", IP = "⟷", BP = "⟺", OP = "Ξ", UP = "ξ", PP = "⟵", FP = "⟸", VP = "⟼", MP = "⋻", HP = "⨀", GP = "𝕏", jP = "𝕩", zP = "⨁", YP = "⨂", WP = "⟶", JP = "⟹", XP = "𝒳", ZP = "𝓍", QP = "⨆", KP = "⨄", tF = "△", eF = "⋁", nF = "⋀", rF = "Ý", oF = "ý", sF = "Я", cF = "я", iF = "Ŷ", aF = "ŷ", lF = "Ы", uF = "ы", pF = "¥", fF = "𝔜", dF = "𝔶", hF = "Ї", gF = "ї", $F = "𝕐", mF = "𝕪", bF = "𝒴", yF = "𝓎", vF = "Ю", wF = "ю", _F = "ÿ", EF = "Ÿ", xF = "Ź", qF = "ź", SF = "Ž", TF = "ž", AF = "З", kF = "з", DF = "Ż", LF = "ż", CF = "ℨ", NF = "​", RF = "Ζ", IF = "ζ", BF = "𝔷", OF = "ℨ", UF = "Ж", PF = "ж", FF = "⇝", VF = "𝕫", MF = "ℤ", HF = "𝒵", GF = "𝓏", jF = "‍", zF = "‌", YF = {
  Aacute: ks,
  aacute: Ds,
  Abreve: Ls,
  abreve: Cs,
  ac: Ns,
  acd: Rs,
  acE: Is,
  Acirc: Bs,
  acirc: Os,
  acute: Us,
  Acy: Ps,
  acy: Fs,
  AElig: Vs,
  aelig: Ms,
  af: Hs,
  Afr: Gs,
  afr: js,
  Agrave: zs,
  agrave: Ys,
  alefsym: Ws,
  aleph: Js,
  Alpha: Xs,
  alpha: Zs,
  Amacr: Qs,
  amacr: Ks,
  amalg: tc,
  amp: ec,
  AMP: nc,
  andand: rc,
  And: oc,
  and: sc,
  andd: cc,
  andslope: ic,
  andv: ac,
  ang: lc,
  ange: uc,
  angle: pc,
  angmsdaa: fc,
  angmsdab: dc,
  angmsdac: hc,
  angmsdad: gc,
  angmsdae: $c,
  angmsdaf: mc,
  angmsdag: bc,
  angmsdah: yc,
  angmsd: vc,
  angrt: wc,
  angrtvb: _c,
  angrtvbd: Ec,
  angsph: xc,
  angst: qc,
  angzarr: Sc,
  Aogon: Tc,
  aogon: Ac,
  Aopf: kc,
  aopf: Dc,
  apacir: Lc,
  ap: Cc,
  apE: Nc,
  ape: Rc,
  apid: Ic,
  apos: Bc,
  ApplyFunction: Oc,
  approx: Uc,
  approxeq: Pc,
  Aring: Fc,
  aring: Vc,
  Ascr: Mc,
  ascr: Hc,
  Assign: Gc,
  ast: jc,
  asymp: zc,
  asympeq: Yc,
  Atilde: Wc,
  atilde: Jc,
  Auml: Xc,
  auml: Zc,
  awconint: Qc,
  awint: Kc,
  backcong: ti,
  backepsilon: ei,
  backprime: ni,
  backsim: ri,
  backsimeq: oi,
  Backslash: si,
  Barv: ci,
  barvee: ii,
  barwed: ai,
  Barwed: li,
  barwedge: ui,
  bbrk: pi,
  bbrktbrk: fi,
  bcong: di,
  Bcy: hi,
  bcy: gi,
  bdquo: $i,
  becaus: mi,
  because: bi,
  Because: yi,
  bemptyv: vi,
  bepsi: wi,
  bernou: _i,
  Bernoullis: Ei,
  Beta: xi,
  beta: qi,
  beth: Si,
  between: Ti,
  Bfr: Ai,
  bfr: ki,
  bigcap: Di,
  bigcirc: Li,
  bigcup: Ci,
  bigodot: Ni,
  bigoplus: Ri,
  bigotimes: Ii,
  bigsqcup: Bi,
  bigstar: Oi,
  bigtriangledown: Ui,
  bigtriangleup: Pi,
  biguplus: Fi,
  bigvee: Vi,
  bigwedge: Mi,
  bkarow: Hi,
  blacklozenge: Gi,
  blacksquare: ji,
  blacktriangle: zi,
  blacktriangledown: Yi,
  blacktriangleleft: Wi,
  blacktriangleright: Ji,
  blank: Xi,
  blk12: Zi,
  blk14: Qi,
  blk34: Ki,
  block: ta,
  bne: ea,
  bnequiv: na,
  bNot: ra,
  bnot: oa,
  Bopf: sa,
  bopf: ca,
  bot: ia,
  bottom: aa,
  bowtie: la,
  boxbox: ua,
  boxdl: pa,
  boxdL: fa,
  boxDl: da,
  boxDL: ha,
  boxdr: ga,
  boxdR: $a,
  boxDr: ma,
  boxDR: ba,
  boxh: ya,
  boxH: va,
  boxhd: wa,
  boxHd: _a,
  boxhD: Ea,
  boxHD: xa,
  boxhu: qa,
  boxHu: Sa,
  boxhU: Ta,
  boxHU: Aa,
  boxminus: ka,
  boxplus: Da,
  boxtimes: La,
  boxul: Ca,
  boxuL: Na,
  boxUl: Ra,
  boxUL: Ia,
  boxur: Ba,
  boxuR: Oa,
  boxUr: Ua,
  boxUR: Pa,
  boxv: Fa,
  boxV: Va,
  boxvh: Ma,
  boxvH: Ha,
  boxVh: Ga,
  boxVH: ja,
  boxvl: za,
  boxvL: Ya,
  boxVl: Wa,
  boxVL: Ja,
  boxvr: Xa,
  boxvR: Za,
  boxVr: Qa,
  boxVR: Ka,
  bprime: tl,
  breve: el,
  Breve: nl,
  brvbar: rl,
  bscr: ol,
  Bscr: sl,
  bsemi: cl,
  bsim: il,
  bsime: al,
  bsolb: ll,
  bsol: ul,
  bsolhsub: pl,
  bull: fl,
  bullet: dl,
  bump: hl,
  bumpE: gl,
  bumpe: $l,
  Bumpeq: ml,
  bumpeq: bl,
  Cacute: yl,
  cacute: vl,
  capand: wl,
  capbrcup: _l,
  capcap: El,
  cap: xl,
  Cap: ql,
  capcup: Sl,
  capdot: Tl,
  CapitalDifferentialD: Al,
  caps: kl,
  caret: Dl,
  caron: Ll,
  Cayleys: Cl,
  ccaps: Nl,
  Ccaron: Rl,
  ccaron: Il,
  Ccedil: Bl,
  ccedil: Ol,
  Ccirc: Ul,
  ccirc: Pl,
  Cconint: Fl,
  ccups: Vl,
  ccupssm: Ml,
  Cdot: Hl,
  cdot: Gl,
  cedil: jl,
  Cedilla: zl,
  cemptyv: Yl,
  cent: Wl,
  centerdot: Jl,
  CenterDot: Xl,
  cfr: Zl,
  Cfr: Ql,
  CHcy: Kl,
  chcy: tu,
  check: eu,
  checkmark: nu,
  Chi: ru,
  chi: ou,
  circ: su,
  circeq: cu,
  circlearrowleft: iu,
  circlearrowright: au,
  circledast: lu,
  circledcirc: uu,
  circleddash: pu,
  CircleDot: fu,
  circledR: du,
  circledS: hu,
  CircleMinus: gu,
  CirclePlus: $u,
  CircleTimes: mu,
  cir: bu,
  cirE: yu,
  cire: vu,
  cirfnint: wu,
  cirmid: _u,
  cirscir: Eu,
  ClockwiseContourIntegral: xu,
  CloseCurlyDoubleQuote: qu,
  CloseCurlyQuote: Su,
  clubs: Tu,
  clubsuit: Au,
  colon: ku,
  Colon: Du,
  Colone: Lu,
  colone: Cu,
  coloneq: Nu,
  comma: Ru,
  commat: Iu,
  comp: Bu,
  compfn: Ou,
  complement: Uu,
  complexes: Pu,
  cong: Fu,
  congdot: Vu,
  Congruent: Mu,
  conint: Hu,
  Conint: Gu,
  ContourIntegral: ju,
  copf: zu,
  Copf: Yu,
  coprod: Wu,
  Coproduct: Ju,
  copy: Xu,
  COPY: Zu,
  copysr: Qu,
  CounterClockwiseContourIntegral: Ku,
  crarr: tp,
  cross: ep,
  Cross: np,
  Cscr: rp,
  cscr: op,
  csub: sp,
  csube: cp,
  csup: ip,
  csupe: ap,
  ctdot: lp,
  cudarrl: up,
  cudarrr: pp,
  cuepr: fp,
  cuesc: dp,
  cularr: hp,
  cularrp: gp,
  cupbrcap: $p,
  cupcap: mp,
  CupCap: bp,
  cup: yp,
  Cup: vp,
  cupcup: wp,
  cupdot: _p,
  cupor: Ep,
  cups: xp,
  curarr: qp,
  curarrm: Sp,
  curlyeqprec: Tp,
  curlyeqsucc: Ap,
  curlyvee: kp,
  curlywedge: Dp,
  curren: Lp,
  curvearrowleft: Cp,
  curvearrowright: Np,
  cuvee: Rp,
  cuwed: Ip,
  cwconint: Bp,
  cwint: Op,
  cylcty: Up,
  dagger: Pp,
  Dagger: Fp,
  daleth: Vp,
  darr: Mp,
  Darr: Hp,
  dArr: Gp,
  dash: jp,
  Dashv: zp,
  dashv: Yp,
  dbkarow: Wp,
  dblac: Jp,
  Dcaron: Xp,
  dcaron: Zp,
  Dcy: Qp,
  dcy: Kp,
  ddagger: tf,
  ddarr: ef,
  DD: nf,
  dd: rf,
  DDotrahd: of,
  ddotseq: sf,
  deg: cf,
  Del: af,
  Delta: lf,
  delta: uf,
  demptyv: pf,
  dfisht: ff,
  Dfr: df,
  dfr: hf,
  dHar: gf,
  dharl: $f,
  dharr: mf,
  DiacriticalAcute: bf,
  DiacriticalDot: yf,
  DiacriticalDoubleAcute: vf,
  DiacriticalGrave: wf,
  DiacriticalTilde: _f,
  diam: Ef,
  diamond: xf,
  Diamond: qf,
  diamondsuit: Sf,
  diams: Tf,
  die: Af,
  DifferentialD: kf,
  digamma: Df,
  disin: Lf,
  div: Cf,
  divide: Nf,
  divideontimes: Rf,
  divonx: If,
  DJcy: Bf,
  djcy: Of,
  dlcorn: Uf,
  dlcrop: Pf,
  dollar: Ff,
  Dopf: Vf,
  dopf: Mf,
  Dot: Hf,
  dot: Gf,
  DotDot: jf,
  doteq: zf,
  doteqdot: Yf,
  DotEqual: Wf,
  dotminus: Jf,
  dotplus: Xf,
  dotsquare: Zf,
  doublebarwedge: Qf,
  DoubleContourIntegral: Kf,
  DoubleDot: td,
  DoubleDownArrow: ed,
  DoubleLeftArrow: nd,
  DoubleLeftRightArrow: rd,
  DoubleLeftTee: od,
  DoubleLongLeftArrow: sd,
  DoubleLongLeftRightArrow: cd,
  DoubleLongRightArrow: id,
  DoubleRightArrow: ad,
  DoubleRightTee: ld,
  DoubleUpArrow: ud,
  DoubleUpDownArrow: pd,
  DoubleVerticalBar: fd,
  DownArrowBar: dd,
  downarrow: hd,
  DownArrow: gd,
  Downarrow: $d,
  DownArrowUpArrow: md,
  DownBreve: bd,
  downdownarrows: yd,
  downharpoonleft: vd,
  downharpoonright: wd,
  DownLeftRightVector: _d,
  DownLeftTeeVector: Ed,
  DownLeftVectorBar: xd,
  DownLeftVector: qd,
  DownRightTeeVector: Sd,
  DownRightVectorBar: Td,
  DownRightVector: Ad,
  DownTeeArrow: kd,
  DownTee: Dd,
  drbkarow: Ld,
  drcorn: Cd,
  drcrop: Nd,
  Dscr: Rd,
  dscr: Id,
  DScy: Bd,
  dscy: Od,
  dsol: Ud,
  Dstrok: Pd,
  dstrok: Fd,
  dtdot: Vd,
  dtri: Md,
  dtrif: Hd,
  duarr: Gd,
  duhar: jd,
  dwangle: zd,
  DZcy: Yd,
  dzcy: Wd,
  dzigrarr: Jd,
  Eacute: Xd,
  eacute: Zd,
  easter: Qd,
  Ecaron: Kd,
  ecaron: th,
  Ecirc: eh,
  ecirc: nh,
  ecir: rh,
  ecolon: oh,
  Ecy: sh,
  ecy: ch,
  eDDot: ih,
  Edot: ah,
  edot: lh,
  eDot: uh,
  ee: ph,
  efDot: fh,
  Efr: dh,
  efr: hh,
  eg: gh,
  Egrave: $h,
  egrave: mh,
  egs: bh,
  egsdot: yh,
  el: vh,
  Element: wh,
  elinters: _h,
  ell: Eh,
  els: xh,
  elsdot: qh,
  Emacr: Sh,
  emacr: Th,
  empty: Ah,
  emptyset: kh,
  EmptySmallSquare: Dh,
  emptyv: Lh,
  EmptyVerySmallSquare: Ch,
  emsp13: Nh,
  emsp14: Rh,
  emsp: Ih,
  ENG: Bh,
  eng: Oh,
  ensp: Uh,
  Eogon: Ph,
  eogon: Fh,
  Eopf: Vh,
  eopf: Mh,
  epar: Hh,
  eparsl: Gh,
  eplus: jh,
  epsi: zh,
  Epsilon: Yh,
  epsilon: Wh,
  epsiv: Jh,
  eqcirc: Xh,
  eqcolon: Zh,
  eqsim: Qh,
  eqslantgtr: Kh,
  eqslantless: t1,
  Equal: e1,
  equals: n1,
  EqualTilde: r1,
  equest: o1,
  Equilibrium: s1,
  equiv: c1,
  equivDD: i1,
  eqvparsl: a1,
  erarr: l1,
  erDot: u1,
  escr: p1,
  Escr: f1,
  esdot: d1,
  Esim: h1,
  esim: g1,
  Eta: $1,
  eta: m1,
  ETH: b1,
  eth: y1,
  Euml: v1,
  euml: w1,
  euro: _1,
  excl: E1,
  exist: x1,
  Exists: q1,
  expectation: S1,
  exponentiale: T1,
  ExponentialE: A1,
  fallingdotseq: k1,
  Fcy: D1,
  fcy: L1,
  female: C1,
  ffilig: N1,
  fflig: R1,
  ffllig: I1,
  Ffr: B1,
  ffr: O1,
  filig: U1,
  FilledSmallSquare: P1,
  FilledVerySmallSquare: F1,
  fjlig: V1,
  flat: M1,
  fllig: H1,
  fltns: G1,
  fnof: j1,
  Fopf: z1,
  fopf: Y1,
  forall: W1,
  ForAll: J1,
  fork: X1,
  forkv: Z1,
  Fouriertrf: Q1,
  fpartint: K1,
  frac12: tg,
  frac13: eg,
  frac14: ng,
  frac15: rg,
  frac16: og,
  frac18: sg,
  frac23: cg,
  frac25: ig,
  frac34: ag,
  frac35: lg,
  frac38: ug,
  frac45: pg,
  frac56: fg,
  frac58: dg,
  frac78: hg,
  frasl: gg,
  frown: $g,
  fscr: mg,
  Fscr: bg,
  gacute: yg,
  Gamma: vg,
  gamma: wg,
  Gammad: _g,
  gammad: Eg,
  gap: xg,
  Gbreve: qg,
  gbreve: Sg,
  Gcedil: Tg,
  Gcirc: Ag,
  gcirc: kg,
  Gcy: Dg,
  gcy: Lg,
  Gdot: Cg,
  gdot: Ng,
  ge: Rg,
  gE: Ig,
  gEl: Bg,
  gel: Og,
  geq: Ug,
  geqq: Pg,
  geqslant: Fg,
  gescc: Vg,
  ges: Mg,
  gesdot: Hg,
  gesdoto: Gg,
  gesdotol: jg,
  gesl: zg,
  gesles: Yg,
  Gfr: Wg,
  gfr: Jg,
  gg: Xg,
  Gg: Zg,
  ggg: Qg,
  gimel: Kg,
  GJcy: t$,
  gjcy: e$,
  gla: n$,
  gl: r$,
  glE: o$,
  glj: s$,
  gnap: c$,
  gnapprox: i$,
  gne: a$,
  gnE: l$,
  gneq: u$,
  gneqq: p$,
  gnsim: f$,
  Gopf: d$,
  gopf: h$,
  grave: g$,
  GreaterEqual: $$,
  GreaterEqualLess: m$,
  GreaterFullEqual: b$,
  GreaterGreater: y$,
  GreaterLess: v$,
  GreaterSlantEqual: w$,
  GreaterTilde: _$,
  Gscr: E$,
  gscr: x$,
  gsim: q$,
  gsime: S$,
  gsiml: T$,
  gtcc: A$,
  gtcir: k$,
  gt: D$,
  GT: L$,
  Gt: C$,
  gtdot: N$,
  gtlPar: R$,
  gtquest: I$,
  gtrapprox: B$,
  gtrarr: O$,
  gtrdot: U$,
  gtreqless: P$,
  gtreqqless: F$,
  gtrless: V$,
  gtrsim: M$,
  gvertneqq: H$,
  gvnE: G$,
  Hacek: j$,
  hairsp: z$,
  half: Y$,
  hamilt: W$,
  HARDcy: J$,
  hardcy: X$,
  harrcir: Z$,
  harr: Q$,
  hArr: K$,
  harrw: tm,
  Hat: em,
  hbar: nm,
  Hcirc: rm,
  hcirc: om,
  hearts: sm,
  heartsuit: cm,
  hellip: im,
  hercon: am,
  hfr: lm,
  Hfr: um,
  HilbertSpace: pm,
  hksearow: fm,
  hkswarow: dm,
  hoarr: hm,
  homtht: gm,
  hookleftarrow: $m,
  hookrightarrow: mm,
  hopf: bm,
  Hopf: ym,
  horbar: vm,
  HorizontalLine: wm,
  hscr: _m,
  Hscr: Em,
  hslash: xm,
  Hstrok: qm,
  hstrok: Sm,
  HumpDownHump: Tm,
  HumpEqual: Am,
  hybull: km,
  hyphen: Dm,
  Iacute: Lm,
  iacute: Cm,
  ic: Nm,
  Icirc: Rm,
  icirc: Im,
  Icy: Bm,
  icy: Om,
  Idot: Um,
  IEcy: Pm,
  iecy: Fm,
  iexcl: Vm,
  iff: Mm,
  ifr: Hm,
  Ifr: Gm,
  Igrave: jm,
  igrave: zm,
  ii: Ym,
  iiiint: Wm,
  iiint: Jm,
  iinfin: Xm,
  iiota: Zm,
  IJlig: Qm,
  ijlig: Km,
  Imacr: tb,
  imacr: eb,
  image: nb,
  ImaginaryI: rb,
  imagline: ob,
  imagpart: sb,
  imath: cb,
  Im: ib,
  imof: ab,
  imped: lb,
  Implies: ub,
  incare: pb,
  in: "∈",
  infin: fb,
  infintie: db,
  inodot: hb,
  intcal: gb,
  int: $b,
  Int: mb,
  integers: bb,
  Integral: yb,
  intercal: vb,
  Intersection: wb,
  intlarhk: _b,
  intprod: Eb,
  InvisibleComma: xb,
  InvisibleTimes: qb,
  IOcy: Sb,
  iocy: Tb,
  Iogon: Ab,
  iogon: kb,
  Iopf: Db,
  iopf: Lb,
  Iota: Cb,
  iota: Nb,
  iprod: Rb,
  iquest: Ib,
  iscr: Bb,
  Iscr: Ob,
  isin: Ub,
  isindot: Pb,
  isinE: Fb,
  isins: Vb,
  isinsv: Mb,
  isinv: Hb,
  it: Gb,
  Itilde: jb,
  itilde: zb,
  Iukcy: Yb,
  iukcy: Wb,
  Iuml: Jb,
  iuml: Xb,
  Jcirc: Zb,
  jcirc: Qb,
  Jcy: Kb,
  jcy: ty,
  Jfr: ey,
  jfr: ny,
  jmath: ry,
  Jopf: oy,
  jopf: sy,
  Jscr: cy,
  jscr: iy,
  Jsercy: ay,
  jsercy: ly,
  Jukcy: uy,
  jukcy: py,
  Kappa: fy,
  kappa: dy,
  kappav: hy,
  Kcedil: gy,
  kcedil: $y,
  Kcy: my,
  kcy: by,
  Kfr: yy,
  kfr: vy,
  kgreen: wy,
  KHcy: _y,
  khcy: Ey,
  KJcy: xy,
  kjcy: qy,
  Kopf: Sy,
  kopf: Ty,
  Kscr: Ay,
  kscr: ky,
  lAarr: Dy,
  Lacute: Ly,
  lacute: Cy,
  laemptyv: Ny,
  lagran: Ry,
  Lambda: Iy,
  lambda: By,
  lang: Oy,
  Lang: Uy,
  langd: Py,
  langle: Fy,
  lap: Vy,
  Laplacetrf: My,
  laquo: Hy,
  larrb: Gy,
  larrbfs: jy,
  larr: zy,
  Larr: Yy,
  lArr: Wy,
  larrfs: Jy,
  larrhk: Xy,
  larrlp: Zy,
  larrpl: Qy,
  larrsim: Ky,
  larrtl: tv,
  latail: ev,
  lAtail: nv,
  lat: rv,
  late: ov,
  lates: sv,
  lbarr: cv,
  lBarr: iv,
  lbbrk: av,
  lbrace: lv,
  lbrack: uv,
  lbrke: pv,
  lbrksld: fv,
  lbrkslu: dv,
  Lcaron: hv,
  lcaron: gv,
  Lcedil: $v,
  lcedil: mv,
  lceil: bv,
  lcub: yv,
  Lcy: vv,
  lcy: wv,
  ldca: _v,
  ldquo: Ev,
  ldquor: xv,
  ldrdhar: qv,
  ldrushar: Sv,
  ldsh: Tv,
  le: Av,
  lE: kv,
  LeftAngleBracket: Dv,
  LeftArrowBar: Lv,
  leftarrow: Cv,
  LeftArrow: Nv,
  Leftarrow: Rv,
  LeftArrowRightArrow: Iv,
  leftarrowtail: Bv,
  LeftCeiling: Ov,
  LeftDoubleBracket: Uv,
  LeftDownTeeVector: Pv,
  LeftDownVectorBar: Fv,
  LeftDownVector: Vv,
  LeftFloor: Mv,
  leftharpoondown: Hv,
  leftharpoonup: Gv,
  leftleftarrows: jv,
  leftrightarrow: zv,
  LeftRightArrow: Yv,
  Leftrightarrow: Wv,
  leftrightarrows: Jv,
  leftrightharpoons: Xv,
  leftrightsquigarrow: Zv,
  LeftRightVector: Qv,
  LeftTeeArrow: Kv,
  LeftTee: tw,
  LeftTeeVector: ew,
  leftthreetimes: nw,
  LeftTriangleBar: rw,
  LeftTriangle: ow,
  LeftTriangleEqual: sw,
  LeftUpDownVector: cw,
  LeftUpTeeVector: iw,
  LeftUpVectorBar: aw,
  LeftUpVector: lw,
  LeftVectorBar: uw,
  LeftVector: pw,
  lEg: fw,
  leg: dw,
  leq: hw,
  leqq: gw,
  leqslant: $w,
  lescc: mw,
  les: bw,
  lesdot: yw,
  lesdoto: vw,
  lesdotor: ww,
  lesg: _w,
  lesges: Ew,
  lessapprox: xw,
  lessdot: qw,
  lesseqgtr: Sw,
  lesseqqgtr: Tw,
  LessEqualGreater: Aw,
  LessFullEqual: kw,
  LessGreater: Dw,
  lessgtr: Lw,
  LessLess: Cw,
  lesssim: Nw,
  LessSlantEqual: Rw,
  LessTilde: Iw,
  lfisht: Bw,
  lfloor: Ow,
  Lfr: Uw,
  lfr: Pw,
  lg: Fw,
  lgE: Vw,
  lHar: Mw,
  lhard: Hw,
  lharu: Gw,
  lharul: jw,
  lhblk: zw,
  LJcy: Yw,
  ljcy: Ww,
  llarr: Jw,
  ll: Xw,
  Ll: Zw,
  llcorner: Qw,
  Lleftarrow: Kw,
  llhard: t0,
  lltri: e0,
  Lmidot: n0,
  lmidot: r0,
  lmoustache: o0,
  lmoust: s0,
  lnap: c0,
  lnapprox: i0,
  lne: a0,
  lnE: l0,
  lneq: u0,
  lneqq: p0,
  lnsim: f0,
  loang: d0,
  loarr: h0,
  lobrk: g0,
  longleftarrow: $0,
  LongLeftArrow: m0,
  Longleftarrow: b0,
  longleftrightarrow: y0,
  LongLeftRightArrow: v0,
  Longleftrightarrow: w0,
  longmapsto: _0,
  longrightarrow: E0,
  LongRightArrow: x0,
  Longrightarrow: q0,
  looparrowleft: S0,
  looparrowright: T0,
  lopar: A0,
  Lopf: k0,
  lopf: D0,
  loplus: L0,
  lotimes: C0,
  lowast: N0,
  lowbar: R0,
  LowerLeftArrow: I0,
  LowerRightArrow: B0,
  loz: O0,
  lozenge: U0,
  lozf: P0,
  lpar: F0,
  lparlt: V0,
  lrarr: M0,
  lrcorner: H0,
  lrhar: G0,
  lrhard: j0,
  lrm: z0,
  lrtri: Y0,
  lsaquo: W0,
  lscr: J0,
  Lscr: X0,
  lsh: Z0,
  Lsh: Q0,
  lsim: K0,
  lsime: t_,
  lsimg: e_,
  lsqb: n_,
  lsquo: r_,
  lsquor: o_,
  Lstrok: s_,
  lstrok: c_,
  ltcc: i_,
  ltcir: a_,
  lt: l_,
  LT: u_,
  Lt: p_,
  ltdot: f_,
  lthree: d_,
  ltimes: h_,
  ltlarr: g_,
  ltquest: $_,
  ltri: m_,
  ltrie: b_,
  ltrif: y_,
  ltrPar: v_,
  lurdshar: w_,
  luruhar: __,
  lvertneqq: E_,
  lvnE: x_,
  macr: q_,
  male: S_,
  malt: T_,
  maltese: A_,
  Map: "⤅",
  map: k_,
  mapsto: D_,
  mapstodown: L_,
  mapstoleft: C_,
  mapstoup: N_,
  marker: R_,
  mcomma: I_,
  Mcy: B_,
  mcy: O_,
  mdash: U_,
  mDDot: P_,
  measuredangle: F_,
  MediumSpace: V_,
  Mellintrf: M_,
  Mfr: H_,
  mfr: G_,
  mho: j_,
  micro: z_,
  midast: Y_,
  midcir: W_,
  mid: J_,
  middot: X_,
  minusb: Z_,
  minus: Q_,
  minusd: K_,
  minusdu: tE,
  MinusPlus: eE,
  mlcp: nE,
  mldr: rE,
  mnplus: oE,
  models: sE,
  Mopf: cE,
  mopf: iE,
  mp: aE,
  mscr: lE,
  Mscr: uE,
  mstpos: pE,
  Mu: fE,
  mu: dE,
  multimap: hE,
  mumap: gE,
  nabla: $E,
  Nacute: mE,
  nacute: bE,
  nang: yE,
  nap: vE,
  napE: wE,
  napid: _E,
  napos: EE,
  napprox: xE,
  natural: qE,
  naturals: SE,
  natur: TE,
  nbsp: AE,
  nbump: kE,
  nbumpe: DE,
  ncap: LE,
  Ncaron: CE,
  ncaron: NE,
  Ncedil: RE,
  ncedil: IE,
  ncong: BE,
  ncongdot: OE,
  ncup: UE,
  Ncy: PE,
  ncy: FE,
  ndash: VE,
  nearhk: ME,
  nearr: HE,
  neArr: GE,
  nearrow: jE,
  ne: zE,
  nedot: YE,
  NegativeMediumSpace: WE,
  NegativeThickSpace: JE,
  NegativeThinSpace: XE,
  NegativeVeryThinSpace: ZE,
  nequiv: QE,
  nesear: KE,
  nesim: tx,
  NestedGreaterGreater: ex,
  NestedLessLess: nx,
  NewLine: rx,
  nexist: ox,
  nexists: sx,
  Nfr: cx,
  nfr: ix,
  ngE: ax,
  nge: lx,
  ngeq: ux,
  ngeqq: px,
  ngeqslant: fx,
  nges: dx,
  nGg: hx,
  ngsim: gx,
  nGt: $x,
  ngt: mx,
  ngtr: bx,
  nGtv: yx,
  nharr: vx,
  nhArr: wx,
  nhpar: _x,
  ni: Ex,
  nis: xx,
  nisd: qx,
  niv: Sx,
  NJcy: Tx,
  njcy: Ax,
  nlarr: kx,
  nlArr: Dx,
  nldr: Lx,
  nlE: Cx,
  nle: Nx,
  nleftarrow: Rx,
  nLeftarrow: Ix,
  nleftrightarrow: Bx,
  nLeftrightarrow: Ox,
  nleq: Ux,
  nleqq: Px,
  nleqslant: Fx,
  nles: Vx,
  nless: Mx,
  nLl: Hx,
  nlsim: Gx,
  nLt: jx,
  nlt: zx,
  nltri: Yx,
  nltrie: Wx,
  nLtv: Jx,
  nmid: Xx,
  NoBreak: Zx,
  NonBreakingSpace: Qx,
  nopf: Kx,
  Nopf: tq,
  Not: eq,
  not: nq,
  NotCongruent: rq,
  NotCupCap: oq,
  NotDoubleVerticalBar: sq,
  NotElement: cq,
  NotEqual: iq,
  NotEqualTilde: aq,
  NotExists: lq,
  NotGreater: uq,
  NotGreaterEqual: pq,
  NotGreaterFullEqual: fq,
  NotGreaterGreater: dq,
  NotGreaterLess: hq,
  NotGreaterSlantEqual: gq,
  NotGreaterTilde: $q,
  NotHumpDownHump: mq,
  NotHumpEqual: bq,
  notin: yq,
  notindot: vq,
  notinE: wq,
  notinva: _q,
  notinvb: Eq,
  notinvc: xq,
  NotLeftTriangleBar: qq,
  NotLeftTriangle: Sq,
  NotLeftTriangleEqual: Tq,
  NotLess: Aq,
  NotLessEqual: kq,
  NotLessGreater: Dq,
  NotLessLess: Lq,
  NotLessSlantEqual: Cq,
  NotLessTilde: Nq,
  NotNestedGreaterGreater: Rq,
  NotNestedLessLess: Iq,
  notni: Bq,
  notniva: Oq,
  notnivb: Uq,
  notnivc: Pq,
  NotPrecedes: Fq,
  NotPrecedesEqual: Vq,
  NotPrecedesSlantEqual: Mq,
  NotReverseElement: Hq,
  NotRightTriangleBar: Gq,
  NotRightTriangle: jq,
  NotRightTriangleEqual: zq,
  NotSquareSubset: Yq,
  NotSquareSubsetEqual: Wq,
  NotSquareSuperset: Jq,
  NotSquareSupersetEqual: Xq,
  NotSubset: Zq,
  NotSubsetEqual: Qq,
  NotSucceeds: Kq,
  NotSucceedsEqual: tS,
  NotSucceedsSlantEqual: eS,
  NotSucceedsTilde: nS,
  NotSuperset: rS,
  NotSupersetEqual: oS,
  NotTilde: sS,
  NotTildeEqual: cS,
  NotTildeFullEqual: iS,
  NotTildeTilde: aS,
  NotVerticalBar: lS,
  nparallel: uS,
  npar: pS,
  nparsl: fS,
  npart: dS,
  npolint: hS,
  npr: gS,
  nprcue: $S,
  nprec: mS,
  npreceq: bS,
  npre: yS,
  nrarrc: vS,
  nrarr: wS,
  nrArr: _S,
  nrarrw: ES,
  nrightarrow: xS,
  nRightarrow: qS,
  nrtri: SS,
  nrtrie: TS,
  nsc: AS,
  nsccue: kS,
  nsce: DS,
  Nscr: LS,
  nscr: CS,
  nshortmid: NS,
  nshortparallel: RS,
  nsim: IS,
  nsime: BS,
  nsimeq: OS,
  nsmid: US,
  nspar: PS,
  nsqsube: FS,
  nsqsupe: VS,
  nsub: MS,
  nsubE: HS,
  nsube: GS,
  nsubset: jS,
  nsubseteq: zS,
  nsubseteqq: YS,
  nsucc: WS,
  nsucceq: JS,
  nsup: XS,
  nsupE: ZS,
  nsupe: QS,
  nsupset: KS,
  nsupseteq: tT,
  nsupseteqq: eT,
  ntgl: nT,
  Ntilde: rT,
  ntilde: oT,
  ntlg: sT,
  ntriangleleft: cT,
  ntrianglelefteq: iT,
  ntriangleright: aT,
  ntrianglerighteq: lT,
  Nu: uT,
  nu: pT,
  num: fT,
  numero: dT,
  numsp: hT,
  nvap: gT,
  nvdash: $T,
  nvDash: mT,
  nVdash: bT,
  nVDash: yT,
  nvge: vT,
  nvgt: wT,
  nvHarr: _T,
  nvinfin: ET,
  nvlArr: xT,
  nvle: qT,
  nvlt: ST,
  nvltrie: TT,
  nvrArr: AT,
  nvrtrie: kT,
  nvsim: DT,
  nwarhk: LT,
  nwarr: CT,
  nwArr: NT,
  nwarrow: RT,
  nwnear: IT,
  Oacute: BT,
  oacute: OT,
  oast: UT,
  Ocirc: PT,
  ocirc: FT,
  ocir: VT,
  Ocy: MT,
  ocy: HT,
  odash: GT,
  Odblac: jT,
  odblac: zT,
  odiv: YT,
  odot: WT,
  odsold: JT,
  OElig: XT,
  oelig: ZT,
  ofcir: QT,
  Ofr: KT,
  ofr: tA,
  ogon: eA,
  Ograve: nA,
  ograve: rA,
  ogt: oA,
  ohbar: sA,
  ohm: cA,
  oint: iA,
  olarr: aA,
  olcir: lA,
  olcross: uA,
  oline: pA,
  olt: fA,
  Omacr: dA,
  omacr: hA,
  Omega: gA,
  omega: $A,
  Omicron: mA,
  omicron: bA,
  omid: yA,
  ominus: vA,
  Oopf: wA,
  oopf: _A,
  opar: EA,
  OpenCurlyDoubleQuote: xA,
  OpenCurlyQuote: qA,
  operp: SA,
  oplus: TA,
  orarr: AA,
  Or: kA,
  or: DA,
  ord: LA,
  order: CA,
  orderof: NA,
  ordf: RA,
  ordm: IA,
  origof: BA,
  oror: OA,
  orslope: UA,
  orv: PA,
  oS: FA,
  Oscr: VA,
  oscr: MA,
  Oslash: HA,
  oslash: GA,
  osol: jA,
  Otilde: zA,
  otilde: YA,
  otimesas: WA,
  Otimes: JA,
  otimes: XA,
  Ouml: ZA,
  ouml: QA,
  ovbar: KA,
  OverBar: tk,
  OverBrace: ek,
  OverBracket: nk,
  OverParenthesis: rk,
  para: ok,
  parallel: sk,
  par: ck,
  parsim: ik,
  parsl: ak,
  part: lk,
  PartialD: uk,
  Pcy: pk,
  pcy: fk,
  percnt: dk,
  period: hk,
  permil: gk,
  perp: $k,
  pertenk: mk,
  Pfr: bk,
  pfr: yk,
  Phi: vk,
  phi: wk,
  phiv: _k,
  phmmat: Ek,
  phone: xk,
  Pi: qk,
  pi: Sk,
  pitchfork: Tk,
  piv: Ak,
  planck: kk,
  planckh: Dk,
  plankv: Lk,
  plusacir: Ck,
  plusb: Nk,
  pluscir: Rk,
  plus: Ik,
  plusdo: Bk,
  plusdu: Ok,
  pluse: Uk,
  PlusMinus: Pk,
  plusmn: Fk,
  plussim: Vk,
  plustwo: Mk,
  pm: Hk,
  Poincareplane: Gk,
  pointint: jk,
  popf: zk,
  Popf: Yk,
  pound: Wk,
  prap: Jk,
  Pr: Xk,
  pr: Zk,
  prcue: Qk,
  precapprox: Kk,
  prec: tD,
  preccurlyeq: eD,
  Precedes: nD,
  PrecedesEqual: rD,
  PrecedesSlantEqual: oD,
  PrecedesTilde: sD,
  preceq: cD,
  precnapprox: iD,
  precneqq: aD,
  precnsim: lD,
  pre: uD,
  prE: pD,
  precsim: fD,
  prime: dD,
  Prime: hD,
  primes: gD,
  prnap: $D,
  prnE: mD,
  prnsim: bD,
  prod: yD,
  Product: vD,
  profalar: wD,
  profline: _D,
  profsurf: ED,
  prop: xD,
  Proportional: qD,
  Proportion: SD,
  propto: TD,
  prsim: AD,
  prurel: kD,
  Pscr: DD,
  pscr: LD,
  Psi: CD,
  psi: ND,
  puncsp: RD,
  Qfr: ID,
  qfr: BD,
  qint: OD,
  qopf: UD,
  Qopf: PD,
  qprime: FD,
  Qscr: VD,
  qscr: MD,
  quaternions: HD,
  quatint: GD,
  quest: jD,
  questeq: zD,
  quot: YD,
  QUOT: WD,
  rAarr: JD,
  race: XD,
  Racute: ZD,
  racute: QD,
  radic: KD,
  raemptyv: tL,
  rang: eL,
  Rang: nL,
  rangd: rL,
  range: oL,
  rangle: sL,
  raquo: cL,
  rarrap: iL,
  rarrb: aL,
  rarrbfs: lL,
  rarrc: uL,
  rarr: pL,
  Rarr: fL,
  rArr: dL,
  rarrfs: hL,
  rarrhk: gL,
  rarrlp: $L,
  rarrpl: mL,
  rarrsim: bL,
  Rarrtl: yL,
  rarrtl: vL,
  rarrw: wL,
  ratail: _L,
  rAtail: EL,
  ratio: xL,
  rationals: qL,
  rbarr: SL,
  rBarr: TL,
  RBarr: AL,
  rbbrk: kL,
  rbrace: DL,
  rbrack: LL,
  rbrke: CL,
  rbrksld: NL,
  rbrkslu: RL,
  Rcaron: IL,
  rcaron: BL,
  Rcedil: OL,
  rcedil: UL,
  rceil: PL,
  rcub: FL,
  Rcy: VL,
  rcy: ML,
  rdca: HL,
  rdldhar: GL,
  rdquo: jL,
  rdquor: zL,
  rdsh: YL,
  real: WL,
  realine: JL,
  realpart: XL,
  reals: ZL,
  Re: QL,
  rect: KL,
  reg: tC,
  REG: eC,
  ReverseElement: nC,
  ReverseEquilibrium: rC,
  ReverseUpEquilibrium: oC,
  rfisht: sC,
  rfloor: cC,
  rfr: iC,
  Rfr: aC,
  rHar: lC,
  rhard: uC,
  rharu: pC,
  rharul: fC,
  Rho: dC,
  rho: hC,
  rhov: gC,
  RightAngleBracket: $C,
  RightArrowBar: mC,
  rightarrow: bC,
  RightArrow: yC,
  Rightarrow: vC,
  RightArrowLeftArrow: wC,
  rightarrowtail: _C,
  RightCeiling: EC,
  RightDoubleBracket: xC,
  RightDownTeeVector: qC,
  RightDownVectorBar: SC,
  RightDownVector: TC,
  RightFloor: AC,
  rightharpoondown: kC,
  rightharpoonup: DC,
  rightleftarrows: LC,
  rightleftharpoons: CC,
  rightrightarrows: NC,
  rightsquigarrow: RC,
  RightTeeArrow: IC,
  RightTee: BC,
  RightTeeVector: OC,
  rightthreetimes: UC,
  RightTriangleBar: PC,
  RightTriangle: FC,
  RightTriangleEqual: VC,
  RightUpDownVector: MC,
  RightUpTeeVector: HC,
  RightUpVectorBar: GC,
  RightUpVector: jC,
  RightVectorBar: zC,
  RightVector: YC,
  ring: WC,
  risingdotseq: JC,
  rlarr: XC,
  rlhar: ZC,
  rlm: QC,
  rmoustache: KC,
  rmoust: tN,
  rnmid: eN,
  roang: nN,
  roarr: rN,
  robrk: oN,
  ropar: sN,
  ropf: cN,
  Ropf: iN,
  roplus: aN,
  rotimes: lN,
  RoundImplies: uN,
  rpar: pN,
  rpargt: fN,
  rppolint: dN,
  rrarr: hN,
  Rrightarrow: gN,
  rsaquo: $N,
  rscr: mN,
  Rscr: bN,
  rsh: yN,
  Rsh: vN,
  rsqb: wN,
  rsquo: _N,
  rsquor: EN,
  rthree: xN,
  rtimes: qN,
  rtri: SN,
  rtrie: TN,
  rtrif: AN,
  rtriltri: kN,
  RuleDelayed: DN,
  ruluhar: LN,
  rx: CN,
  Sacute: NN,
  sacute: RN,
  sbquo: IN,
  scap: BN,
  Scaron: ON,
  scaron: UN,
  Sc: PN,
  sc: FN,
  sccue: VN,
  sce: MN,
  scE: HN,
  Scedil: GN,
  scedil: jN,
  Scirc: zN,
  scirc: YN,
  scnap: WN,
  scnE: JN,
  scnsim: XN,
  scpolint: ZN,
  scsim: QN,
  Scy: KN,
  scy: tR,
  sdotb: eR,
  sdot: nR,
  sdote: rR,
  searhk: oR,
  searr: sR,
  seArr: cR,
  searrow: iR,
  sect: aR,
  semi: lR,
  seswar: uR,
  setminus: pR,
  setmn: fR,
  sext: dR,
  Sfr: hR,
  sfr: gR,
  sfrown: $R,
  sharp: mR,
  SHCHcy: bR,
  shchcy: yR,
  SHcy: vR,
  shcy: wR,
  ShortDownArrow: _R,
  ShortLeftArrow: ER,
  shortmid: xR,
  shortparallel: qR,
  ShortRightArrow: SR,
  ShortUpArrow: TR,
  shy: AR,
  Sigma: kR,
  sigma: DR,
  sigmaf: LR,
  sigmav: CR,
  sim: NR,
  simdot: RR,
  sime: IR,
  simeq: BR,
  simg: OR,
  simgE: UR,
  siml: PR,
  simlE: FR,
  simne: VR,
  simplus: MR,
  simrarr: HR,
  slarr: GR,
  SmallCircle: jR,
  smallsetminus: zR,
  smashp: YR,
  smeparsl: WR,
  smid: JR,
  smile: XR,
  smt: ZR,
  smte: QR,
  smtes: KR,
  SOFTcy: t2,
  softcy: e2,
  solbar: n2,
  solb: r2,
  sol: o2,
  Sopf: s2,
  sopf: c2,
  spades: i2,
  spadesuit: a2,
  spar: l2,
  sqcap: u2,
  sqcaps: p2,
  sqcup: f2,
  sqcups: d2,
  Sqrt: h2,
  sqsub: g2,
  sqsube: $2,
  sqsubset: m2,
  sqsubseteq: b2,
  sqsup: y2,
  sqsupe: v2,
  sqsupset: w2,
  sqsupseteq: _2,
  square: E2,
  Square: x2,
  SquareIntersection: q2,
  SquareSubset: S2,
  SquareSubsetEqual: T2,
  SquareSuperset: A2,
  SquareSupersetEqual: k2,
  SquareUnion: D2,
  squarf: L2,
  squ: C2,
  squf: N2,
  srarr: R2,
  Sscr: I2,
  sscr: B2,
  ssetmn: O2,
  ssmile: U2,
  sstarf: P2,
  Star: F2,
  star: V2,
  starf: M2,
  straightepsilon: H2,
  straightphi: G2,
  strns: j2,
  sub: z2,
  Sub: Y2,
  subdot: W2,
  subE: J2,
  sube: X2,
  subedot: Z2,
  submult: Q2,
  subnE: K2,
  subne: tI,
  subplus: eI,
  subrarr: nI,
  subset: rI,
  Subset: oI,
  subseteq: sI,
  subseteqq: cI,
  SubsetEqual: iI,
  subsetneq: aI,
  subsetneqq: lI,
  subsim: uI,
  subsub: pI,
  subsup: fI,
  succapprox: dI,
  succ: hI,
  succcurlyeq: gI,
  Succeeds: $I,
  SucceedsEqual: mI,
  SucceedsSlantEqual: bI,
  SucceedsTilde: yI,
  succeq: vI,
  succnapprox: wI,
  succneqq: _I,
  succnsim: EI,
  succsim: xI,
  SuchThat: qI,
  sum: SI,
  Sum: TI,
  sung: AI,
  sup1: kI,
  sup2: DI,
  sup3: LI,
  sup: CI,
  Sup: NI,
  supdot: RI,
  supdsub: II,
  supE: BI,
  supe: OI,
  supedot: UI,
  Superset: PI,
  SupersetEqual: FI,
  suphsol: VI,
  suphsub: MI,
  suplarr: HI,
  supmult: GI,
  supnE: jI,
  supne: zI,
  supplus: YI,
  supset: WI,
  Supset: JI,
  supseteq: XI,
  supseteqq: ZI,
  supsetneq: QI,
  supsetneqq: KI,
  supsim: tB,
  supsub: eB,
  supsup: nB,
  swarhk: rB,
  swarr: oB,
  swArr: sB,
  swarrow: cB,
  swnwar: iB,
  szlig: aB,
  Tab: lB,
  target: uB,
  Tau: pB,
  tau: fB,
  tbrk: dB,
  Tcaron: hB,
  tcaron: gB,
  Tcedil: $B,
  tcedil: mB,
  Tcy: bB,
  tcy: yB,
  tdot: vB,
  telrec: wB,
  Tfr: _B,
  tfr: EB,
  there4: xB,
  therefore: qB,
  Therefore: SB,
  Theta: TB,
  theta: AB,
  thetasym: kB,
  thetav: DB,
  thickapprox: LB,
  thicksim: CB,
  ThickSpace: NB,
  ThinSpace: RB,
  thinsp: IB,
  thkap: BB,
  thksim: OB,
  THORN: UB,
  thorn: PB,
  tilde: FB,
  Tilde: VB,
  TildeEqual: MB,
  TildeFullEqual: HB,
  TildeTilde: GB,
  timesbar: jB,
  timesb: zB,
  times: YB,
  timesd: WB,
  tint: JB,
  toea: XB,
  topbot: ZB,
  topcir: QB,
  top: KB,
  Topf: t3,
  topf: e3,
  topfork: n3,
  tosa: r3,
  tprime: o3,
  trade: s3,
  TRADE: c3,
  triangle: i3,
  triangledown: a3,
  triangleleft: l3,
  trianglelefteq: u3,
  triangleq: p3,
  triangleright: f3,
  trianglerighteq: d3,
  tridot: h3,
  trie: g3,
  triminus: $3,
  TripleDot: m3,
  triplus: b3,
  trisb: y3,
  tritime: v3,
  trpezium: w3,
  Tscr: _3,
  tscr: E3,
  TScy: x3,
  tscy: q3,
  TSHcy: S3,
  tshcy: T3,
  Tstrok: A3,
  tstrok: k3,
  twixt: D3,
  twoheadleftarrow: L3,
  twoheadrightarrow: C3,
  Uacute: N3,
  uacute: R3,
  uarr: I3,
  Uarr: B3,
  uArr: O3,
  Uarrocir: U3,
  Ubrcy: P3,
  ubrcy: F3,
  Ubreve: V3,
  ubreve: M3,
  Ucirc: H3,
  ucirc: G3,
  Ucy: j3,
  ucy: z3,
  udarr: Y3,
  Udblac: W3,
  udblac: J3,
  udhar: X3,
  ufisht: Z3,
  Ufr: Q3,
  ufr: K3,
  Ugrave: tO,
  ugrave: eO,
  uHar: nO,
  uharl: rO,
  uharr: oO,
  uhblk: sO,
  ulcorn: cO,
  ulcorner: iO,
  ulcrop: aO,
  ultri: lO,
  Umacr: uO,
  umacr: pO,
  uml: fO,
  UnderBar: dO,
  UnderBrace: hO,
  UnderBracket: gO,
  UnderParenthesis: $O,
  Union: mO,
  UnionPlus: bO,
  Uogon: yO,
  uogon: vO,
  Uopf: wO,
  uopf: _O,
  UpArrowBar: EO,
  uparrow: xO,
  UpArrow: qO,
  Uparrow: SO,
  UpArrowDownArrow: TO,
  updownarrow: AO,
  UpDownArrow: kO,
  Updownarrow: DO,
  UpEquilibrium: LO,
  upharpoonleft: CO,
  upharpoonright: NO,
  uplus: RO,
  UpperLeftArrow: IO,
  UpperRightArrow: BO,
  upsi: OO,
  Upsi: UO,
  upsih: PO,
  Upsilon: FO,
  upsilon: VO,
  UpTeeArrow: MO,
  UpTee: HO,
  upuparrows: GO,
  urcorn: jO,
  urcorner: zO,
  urcrop: YO,
  Uring: WO,
  uring: JO,
  urtri: XO,
  Uscr: ZO,
  uscr: QO,
  utdot: KO,
  Utilde: tU,
  utilde: eU,
  utri: nU,
  utrif: rU,
  uuarr: oU,
  Uuml: sU,
  uuml: cU,
  uwangle: iU,
  vangrt: aU,
  varepsilon: lU,
  varkappa: uU,
  varnothing: pU,
  varphi: fU,
  varpi: dU,
  varpropto: hU,
  varr: gU,
  vArr: $U,
  varrho: mU,
  varsigma: bU,
  varsubsetneq: yU,
  varsubsetneqq: vU,
  varsupsetneq: wU,
  varsupsetneqq: _U,
  vartheta: EU,
  vartriangleleft: xU,
  vartriangleright: qU,
  vBar: SU,
  Vbar: TU,
  vBarv: AU,
  Vcy: kU,
  vcy: DU,
  vdash: LU,
  vDash: CU,
  Vdash: NU,
  VDash: RU,
  Vdashl: IU,
  veebar: BU,
  vee: OU,
  Vee: UU,
  veeeq: PU,
  vellip: FU,
  verbar: VU,
  Verbar: MU,
  vert: HU,
  Vert: GU,
  VerticalBar: jU,
  VerticalLine: zU,
  VerticalSeparator: YU,
  VerticalTilde: WU,
  VeryThinSpace: JU,
  Vfr: XU,
  vfr: ZU,
  vltri: QU,
  vnsub: KU,
  vnsup: tP,
  Vopf: eP,
  vopf: nP,
  vprop: rP,
  vrtri: oP,
  Vscr: sP,
  vscr: cP,
  vsubnE: iP,
  vsubne: aP,
  vsupnE: lP,
  vsupne: uP,
  Vvdash: pP,
  vzigzag: fP,
  Wcirc: dP,
  wcirc: hP,
  wedbar: gP,
  wedge: $P,
  Wedge: mP,
  wedgeq: bP,
  weierp: yP,
  Wfr: vP,
  wfr: wP,
  Wopf: _P,
  wopf: EP,
  wp: xP,
  wr: qP,
  wreath: SP,
  Wscr: TP,
  wscr: AP,
  xcap: kP,
  xcirc: DP,
  xcup: LP,
  xdtri: CP,
  Xfr: NP,
  xfr: RP,
  xharr: IP,
  xhArr: BP,
  Xi: OP,
  xi: UP,
  xlarr: PP,
  xlArr: FP,
  xmap: VP,
  xnis: MP,
  xodot: HP,
  Xopf: GP,
  xopf: jP,
  xoplus: zP,
  xotime: YP,
  xrarr: WP,
  xrArr: JP,
  Xscr: XP,
  xscr: ZP,
  xsqcup: QP,
  xuplus: KP,
  xutri: tF,
  xvee: eF,
  xwedge: nF,
  Yacute: rF,
  yacute: oF,
  YAcy: sF,
  yacy: cF,
  Ycirc: iF,
  ycirc: aF,
  Ycy: lF,
  ycy: uF,
  yen: pF,
  Yfr: fF,
  yfr: dF,
  YIcy: hF,
  yicy: gF,
  Yopf: $F,
  yopf: mF,
  Yscr: bF,
  yscr: yF,
  YUcy: vF,
  yucy: wF,
  yuml: _F,
  Yuml: EF,
  Zacute: xF,
  zacute: qF,
  Zcaron: SF,
  zcaron: TF,
  Zcy: AF,
  zcy: kF,
  Zdot: DF,
  zdot: LF,
  zeetrf: CF,
  ZeroWidthSpace: NF,
  Zeta: RF,
  zeta: IF,
  zfr: BF,
  Zfr: OF,
  ZHcy: UF,
  zhcy: PF,
  zigrarr: FF,
  zopf: VF,
  Zopf: MF,
  Zscr: HF,
  zscr: GF,
  zwj: jF,
  zwnj: zF
}, WF = "Á", JF = "á", XF = "Â", ZF = "â", QF = "´", KF = "Æ", tV = "æ", eV = "À", nV = "à", rV = "&", oV = "&", sV = "Å", cV = "å", iV = "Ã", aV = "ã", lV = "Ä", uV = "ä", pV = "¦", fV = "Ç", dV = "ç", hV = "¸", gV = "¢", $V = "©", mV = "©", bV = "¤", yV = "°", vV = "÷", wV = "É", _V = "é", EV = "Ê", xV = "ê", qV = "È", SV = "è", TV = "Ð", AV = "ð", kV = "Ë", DV = "ë", LV = "½", CV = "¼", NV = "¾", RV = ">", IV = ">", BV = "Í", OV = "í", UV = "Î", PV = "î", FV = "¡", VV = "Ì", MV = "ì", HV = "¿", GV = "Ï", jV = "ï", zV = "«", YV = "<", WV = "<", JV = "¯", XV = "µ", ZV = "·", QV = " ", KV = "¬", tM = "Ñ", eM = "ñ", nM = "Ó", rM = "ó", oM = "Ô", sM = "ô", cM = "Ò", iM = "ò", aM = "ª", lM = "º", uM = "Ø", pM = "ø", fM = "Õ", dM = "õ", hM = "Ö", gM = "ö", $M = "¶", mM = "±", bM = "£", yM = '"', vM = '"', wM = "»", _M = "®", EM = "®", xM = "§", qM = "­", SM = "¹", TM = "²", AM = "³", kM = "ß", DM = "Þ", LM = "þ", CM = "×", NM = "Ú", RM = "ú", IM = "Û", BM = "û", OM = "Ù", UM = "ù", PM = "¨", FM = "Ü", VM = "ü", MM = "Ý", HM = "ý", GM = "¥", jM = "ÿ", zM = {
  Aacute: WF,
  aacute: JF,
  Acirc: XF,
  acirc: ZF,
  acute: QF,
  AElig: KF,
  aelig: tV,
  Agrave: eV,
  agrave: nV,
  amp: rV,
  AMP: oV,
  Aring: sV,
  aring: cV,
  Atilde: iV,
  atilde: aV,
  Auml: lV,
  auml: uV,
  brvbar: pV,
  Ccedil: fV,
  ccedil: dV,
  cedil: hV,
  cent: gV,
  copy: $V,
  COPY: mV,
  curren: bV,
  deg: yV,
  divide: vV,
  Eacute: wV,
  eacute: _V,
  Ecirc: EV,
  ecirc: xV,
  Egrave: qV,
  egrave: SV,
  ETH: TV,
  eth: AV,
  Euml: kV,
  euml: DV,
  frac12: LV,
  frac14: CV,
  frac34: NV,
  gt: RV,
  GT: IV,
  Iacute: BV,
  iacute: OV,
  Icirc: UV,
  icirc: PV,
  iexcl: FV,
  Igrave: VV,
  igrave: MV,
  iquest: HV,
  Iuml: GV,
  iuml: jV,
  laquo: zV,
  lt: YV,
  LT: WV,
  macr: JV,
  micro: XV,
  middot: ZV,
  nbsp: QV,
  not: KV,
  Ntilde: tM,
  ntilde: eM,
  Oacute: nM,
  oacute: rM,
  Ocirc: oM,
  ocirc: sM,
  Ograve: cM,
  ograve: iM,
  ordf: aM,
  ordm: lM,
  Oslash: uM,
  oslash: pM,
  Otilde: fM,
  otilde: dM,
  Ouml: hM,
  ouml: gM,
  para: $M,
  plusmn: mM,
  pound: bM,
  quot: yM,
  QUOT: vM,
  raquo: wM,
  reg: _M,
  REG: EM,
  sect: xM,
  shy: qM,
  sup1: SM,
  sup2: TM,
  sup3: AM,
  szlig: kM,
  THORN: DM,
  thorn: LM,
  times: CM,
  Uacute: NM,
  uacute: RM,
  Ucirc: IM,
  ucirc: BM,
  Ugrave: OM,
  ugrave: UM,
  uml: PM,
  Uuml: FM,
  uuml: VM,
  Yacute: MM,
  yacute: HM,
  yen: GM,
  yuml: jM
}, YM = "&", WM = "'", JM = ">", XM = "<", ZM = '"', QM = {
  amp: YM,
  apos: WM,
  gt: JM,
  lt: XM,
  quot: ZM
};
var Yr = T, KM = Ts, tH = YF, Zn = zM, eH = QM, L = 0, H = L++, Wr = L++, Mt = L++, Jr = L++, Xr = L++, pe = L++, Zr = L++, Rt = L++, Ce = L++, En = L++, xn = L++, qn = L++, Sn = L++, Tn = L++, Qr = L++, At = L++, Kr = L++, to = L++, fe = L++, An = L++, kn = L++, eo = L++, no = L++, ro = L++, oo = L++, so = L++, co = L++, de = L++, Dn = L++, Ln = L++, io = L++, ao = L++, lo = L++, uo = L++, po = L++, fo = L++, ho = L++, go = L++, $o = L++, mo = L++, bo = L++, yo = L++, vo = L++, wo = L++, _o = L++, Eo = L++, xo = L++, qo = L++, So = L++, To = L++, he = L++, Ao = L++, Cn = L++, Nn = L++, Rn = L++, In = 0, ee = In++, ko = In++, Do = In++;
function at(t) {
  return t === " " || t === `
` || t === "	" || t === "\f" || t === "\r";
}
function lt(t, e, n) {
  var s = t.toLowerCase();
  return t === s ? function(c) {
    c === s ? this._state = e : (this._state = n, this._index--);
  } : function(c) {
    c === s || c === t ? this._state = e : (this._state = n, this._index--);
  };
}
function Ht(t, e) {
  var n = t.toLowerCase();
  return function(s) {
    s === n || s === t ? this._state = e : (this._state = Mt, this._index--);
  };
}
function T(t, e) {
  this._state = H, this._buffer = "", this._sectionStart = 0, this._index = 0, this._bufferOffset = 0, this._baseState = H, this._special = ee, this._cbs = e, this._running = !0, this._ended = !1, this._xmlMode = !!(t && t.xmlMode), this._decodeEntities = !!(t && t.decodeEntities);
}
T.prototype._stateText = function(t) {
  t === "<" ? (this._index > this._sectionStart && this._cbs.ontext(this._getSection()), this._state = Wr, this._sectionStart = this._index) : this._decodeEntities && this._special === ee && t === "&" && (this._index > this._sectionStart && this._cbs.ontext(this._getSection()), this._baseState = H, this._state = he, this._sectionStart = this._index);
};
T.prototype._stateBeforeTagName = function(t) {
  t === "/" ? this._state = Xr : t === "<" ? (this._cbs.ontext(this._getSection()), this._sectionStart = this._index) : t === ">" || this._special !== ee || at(t) ? this._state = H : t === "!" ? (this._state = Qr, this._sectionStart = this._index + 1) : t === "?" ? (this._state = Kr, this._sectionStart = this._index + 1) : (this._state = !this._xmlMode && (t === "s" || t === "S") ? io : Mt, this._sectionStart = this._index);
};
T.prototype._stateInTagName = function(t) {
  (t === "/" || t === ">" || at(t)) && (this._emitToken("onopentagname"), this._state = Rt, this._index--);
};
T.prototype._stateBeforeCloseingTagName = function(t) {
  at(t) || (t === ">" ? this._state = H : this._special !== ee ? t === "s" || t === "S" ? this._state = ao : (this._state = H, this._index--) : (this._state = pe, this._sectionStart = this._index));
};
T.prototype._stateInCloseingTagName = function(t) {
  (t === ">" || at(t)) && (this._emitToken("onclosetag"), this._state = Zr, this._index--);
};
T.prototype._stateAfterCloseingTagName = function(t) {
  t === ">" && (this._state = H, this._sectionStart = this._index + 1);
};
T.prototype._stateBeforeAttributeName = function(t) {
  t === ">" ? (this._cbs.onopentagend(), this._state = H, this._sectionStart = this._index + 1) : t === "/" ? this._state = Jr : at(t) || (this._state = Ce, this._sectionStart = this._index);
};
T.prototype._stateInSelfClosingTag = function(t) {
  t === ">" ? (this._cbs.onselfclosingtag(), this._state = H, this._sectionStart = this._index + 1) : at(t) || (this._state = Rt, this._index--);
};
T.prototype._stateInAttributeName = function(t) {
  (t === "=" || t === "/" || t === ">" || at(t)) && (this._cbs.onattribname(this._getSection()), this._sectionStart = -1, this._state = En, this._index--);
};
T.prototype._stateAfterAttributeName = function(t) {
  t === "=" ? this._state = xn : t === "/" || t === ">" ? (this._cbs.onattribend(), this._state = Rt, this._index--) : at(t) || (this._cbs.onattribend(), this._state = Ce, this._sectionStart = this._index);
};
T.prototype._stateBeforeAttributeValue = function(t) {
  t === '"' ? (this._state = qn, this._sectionStart = this._index + 1) : t === "'" ? (this._state = Sn, this._sectionStart = this._index + 1) : at(t) || (this._state = Tn, this._sectionStart = this._index, this._index--);
};
T.prototype._stateInAttributeValueDoubleQuotes = function(t) {
  t === '"' ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = Rt) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = he, this._sectionStart = this._index);
};
T.prototype._stateInAttributeValueSingleQuotes = function(t) {
  t === "'" ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = Rt) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = he, this._sectionStart = this._index);
};
T.prototype._stateInAttributeValueNoQuotes = function(t) {
  at(t) || t === ">" ? (this._emitToken("onattribdata"), this._cbs.onattribend(), this._state = Rt, this._index--) : this._decodeEntities && t === "&" && (this._emitToken("onattribdata"), this._baseState = this._state, this._state = he, this._sectionStart = this._index);
};
T.prototype._stateBeforeDeclaration = function(t) {
  this._state = t === "[" ? eo : t === "-" ? to : At;
};
T.prototype._stateInDeclaration = function(t) {
  t === ">" && (this._cbs.ondeclaration(this._getSection()), this._state = H, this._sectionStart = this._index + 1);
};
T.prototype._stateInProcessingInstruction = function(t) {
  t === ">" && (this._cbs.onprocessinginstruction(this._getSection()), this._state = H, this._sectionStart = this._index + 1);
};
T.prototype._stateBeforeComment = function(t) {
  t === "-" ? (this._state = fe, this._sectionStart = this._index + 1) : this._state = At;
};
T.prototype._stateInComment = function(t) {
  t === "-" && (this._state = An);
};
T.prototype._stateAfterComment1 = function(t) {
  t === "-" ? this._state = kn : this._state = fe;
};
T.prototype._stateAfterComment2 = function(t) {
  t === ">" ? (this._cbs.oncomment(
    this._buffer.substring(this._sectionStart, this._index - 2)
  ), this._state = H, this._sectionStart = this._index + 1) : t !== "-" && (this._state = fe);
};
T.prototype._stateBeforeCdata1 = lt(
  "C",
  no,
  At
);
T.prototype._stateBeforeCdata2 = lt(
  "D",
  ro,
  At
);
T.prototype._stateBeforeCdata3 = lt(
  "A",
  oo,
  At
);
T.prototype._stateBeforeCdata4 = lt(
  "T",
  so,
  At
);
T.prototype._stateBeforeCdata5 = lt(
  "A",
  co,
  At
);
T.prototype._stateBeforeCdata6 = function(t) {
  t === "[" ? (this._state = de, this._sectionStart = this._index + 1) : (this._state = At, this._index--);
};
T.prototype._stateInCdata = function(t) {
  t === "]" && (this._state = Dn);
};
T.prototype._stateAfterCdata1 = function(t) {
  t === "]" ? this._state = Ln : this._state = de;
};
T.prototype._stateAfterCdata2 = function(t) {
  t === ">" ? (this._cbs.oncdata(
    this._buffer.substring(this._sectionStart, this._index - 2)
  ), this._state = H, this._sectionStart = this._index + 1) : t !== "]" && (this._state = de);
};
T.prototype._stateBeforeSpecial = function(t) {
  t === "c" || t === "C" ? this._state = lo : t === "t" || t === "T" ? this._state = vo : (this._state = Mt, this._index--);
};
T.prototype._stateBeforeSpecialEnd = function(t) {
  this._special === ko && (t === "c" || t === "C") ? this._state = go : this._special === Do && (t === "t" || t === "T") ? this._state = xo : this._state = H;
};
T.prototype._stateBeforeScript1 = Ht(
  "R",
  uo
);
T.prototype._stateBeforeScript2 = Ht(
  "I",
  po
);
T.prototype._stateBeforeScript3 = Ht(
  "P",
  fo
);
T.prototype._stateBeforeScript4 = Ht(
  "T",
  ho
);
T.prototype._stateBeforeScript5 = function(t) {
  (t === "/" || t === ">" || at(t)) && (this._special = ko), this._state = Mt, this._index--;
};
T.prototype._stateAfterScript1 = lt("R", $o, H);
T.prototype._stateAfterScript2 = lt("I", mo, H);
T.prototype._stateAfterScript3 = lt("P", bo, H);
T.prototype._stateAfterScript4 = lt("T", yo, H);
T.prototype._stateAfterScript5 = function(t) {
  t === ">" || at(t) ? (this._special = ee, this._state = pe, this._sectionStart = this._index - 6, this._index--) : this._state = H;
};
T.prototype._stateBeforeStyle1 = Ht(
  "Y",
  wo
);
T.prototype._stateBeforeStyle2 = Ht(
  "L",
  _o
);
T.prototype._stateBeforeStyle3 = Ht(
  "E",
  Eo
);
T.prototype._stateBeforeStyle4 = function(t) {
  (t === "/" || t === ">" || at(t)) && (this._special = Do), this._state = Mt, this._index--;
};
T.prototype._stateAfterStyle1 = lt("Y", qo, H);
T.prototype._stateAfterStyle2 = lt("L", So, H);
T.prototype._stateAfterStyle3 = lt("E", To, H);
T.prototype._stateAfterStyle4 = function(t) {
  t === ">" || at(t) ? (this._special = ee, this._state = pe, this._sectionStart = this._index - 5, this._index--) : this._state = H;
};
T.prototype._stateBeforeEntity = lt(
  "#",
  Ao,
  Cn
);
T.prototype._stateBeforeNumericEntity = lt(
  "X",
  Rn,
  Nn
);
T.prototype._parseNamedEntityStrict = function() {
  if (this._sectionStart + 1 < this._index) {
    var t = this._buffer.substring(
      this._sectionStart + 1,
      this._index
    ), e = this._xmlMode ? eH : tH;
    e.hasOwnProperty(t) && (this._emitPartial(e[t]), this._sectionStart = this._index + 1);
  }
};
T.prototype._parseLegacyEntity = function() {
  var t = this._sectionStart + 1, e = this._index - t;
  for (e > 6 && (e = 6); e >= 2; ) {
    var n = this._buffer.substr(t, e);
    if (Zn.hasOwnProperty(n)) {
      this._emitPartial(Zn[n]), this._sectionStart += e + 1;
      return;
    } else
      e--;
  }
};
T.prototype._stateInNamedEntity = function(t) {
  t === ";" ? (this._parseNamedEntityStrict(), this._sectionStart + 1 < this._index && !this._xmlMode && this._parseLegacyEntity(), this._state = this._baseState) : (t < "a" || t > "z") && (t < "A" || t > "Z") && (t < "0" || t > "9") && (this._xmlMode || this._sectionStart + 1 === this._index || (this._baseState !== H ? t !== "=" && this._parseNamedEntityStrict() : this._parseLegacyEntity()), this._state = this._baseState, this._index--);
};
T.prototype._decodeNumericEntity = function(t, e) {
  var n = this._sectionStart + t;
  if (n !== this._index) {
    var s = this._buffer.substring(n, this._index), c = parseInt(s, e);
    this._emitPartial(KM(c)), this._sectionStart = this._index;
  } else
    this._sectionStart--;
  this._state = this._baseState;
};
T.prototype._stateInNumericEntity = function(t) {
  t === ";" ? (this._decodeNumericEntity(2, 10), this._sectionStart++) : (t < "0" || t > "9") && (this._xmlMode ? this._state = this._baseState : this._decodeNumericEntity(2, 10), this._index--);
};
T.prototype._stateInHexEntity = function(t) {
  t === ";" ? (this._decodeNumericEntity(3, 16), this._sectionStart++) : (t < "a" || t > "f") && (t < "A" || t > "F") && (t < "0" || t > "9") && (this._xmlMode ? this._state = this._baseState : this._decodeNumericEntity(3, 16), this._index--);
};
T.prototype._cleanup = function() {
  this._sectionStart < 0 ? (this._buffer = "", this._bufferOffset += this._index, this._index = 0) : this._running && (this._state === H ? (this._sectionStart !== this._index && this._cbs.ontext(this._buffer.substr(this._sectionStart)), this._buffer = "", this._bufferOffset += this._index, this._index = 0) : this._sectionStart === this._index ? (this._buffer = "", this._bufferOffset += this._index, this._index = 0) : (this._buffer = this._buffer.substr(this._sectionStart), this._index -= this._sectionStart, this._bufferOffset += this._sectionStart), this._sectionStart = 0);
};
T.prototype.write = function(t) {
  this._ended && this._cbs.onerror(Error(".write() after done!")), this._buffer += t, this._parse();
};
T.prototype._parse = function() {
  for (; this._index < this._buffer.length && this._running; ) {
    var t = this._buffer.charAt(this._index);
    this._state === H ? this._stateText(t) : this._state === Wr ? this._stateBeforeTagName(t) : this._state === Mt ? this._stateInTagName(t) : this._state === Xr ? this._stateBeforeCloseingTagName(t) : this._state === pe ? this._stateInCloseingTagName(t) : this._state === Zr ? this._stateAfterCloseingTagName(t) : this._state === Jr ? this._stateInSelfClosingTag(t) : this._state === Rt ? this._stateBeforeAttributeName(t) : this._state === Ce ? this._stateInAttributeName(t) : this._state === En ? this._stateAfterAttributeName(t) : this._state === xn ? this._stateBeforeAttributeValue(t) : this._state === qn ? this._stateInAttributeValueDoubleQuotes(t) : this._state === Sn ? this._stateInAttributeValueSingleQuotes(t) : this._state === Tn ? this._stateInAttributeValueNoQuotes(t) : this._state === Qr ? this._stateBeforeDeclaration(t) : this._state === At ? this._stateInDeclaration(t) : this._state === Kr ? this._stateInProcessingInstruction(t) : this._state === to ? this._stateBeforeComment(t) : this._state === fe ? this._stateInComment(t) : this._state === An ? this._stateAfterComment1(t) : this._state === kn ? this._stateAfterComment2(t) : this._state === eo ? this._stateBeforeCdata1(t) : this._state === no ? this._stateBeforeCdata2(t) : this._state === ro ? this._stateBeforeCdata3(t) : this._state === oo ? this._stateBeforeCdata4(t) : this._state === so ? this._stateBeforeCdata5(t) : this._state === co ? this._stateBeforeCdata6(t) : this._state === de ? this._stateInCdata(t) : this._state === Dn ? this._stateAfterCdata1(t) : this._state === Ln ? this._stateAfterCdata2(t) : this._state === io ? this._stateBeforeSpecial(t) : this._state === ao ? this._stateBeforeSpecialEnd(t) : this._state === lo ? this._stateBeforeScript1(t) : this._state === uo ? this._stateBeforeScript2(t) : this._state === po ? this._stateBeforeScript3(t) : this._state === fo ? this._stateBeforeScript4(t) : this._state === ho ? this._stateBeforeScript5(t) : this._state === go ? this._stateAfterScript1(t) : this._state === $o ? this._stateAfterScript2(t) : this._state === mo ? this._stateAfterScript3(t) : this._state === bo ? this._stateAfterScript4(t) : this._state === yo ? this._stateAfterScript5(t) : this._state === vo ? this._stateBeforeStyle1(t) : this._state === wo ? this._stateBeforeStyle2(t) : this._state === _o ? this._stateBeforeStyle3(t) : this._state === Eo ? this._stateBeforeStyle4(t) : this._state === xo ? this._stateAfterStyle1(t) : this._state === qo ? this._stateAfterStyle2(t) : this._state === So ? this._stateAfterStyle3(t) : this._state === To ? this._stateAfterStyle4(t) : this._state === he ? this._stateBeforeEntity(t) : this._state === Ao ? this._stateBeforeNumericEntity(t) : this._state === Cn ? this._stateInNamedEntity(t) : this._state === Nn ? this._stateInNumericEntity(t) : this._state === Rn ? this._stateInHexEntity(t) : this._cbs.onerror(Error("unknown _state"), this._state), this._index++;
  }
  this._cleanup();
};
T.prototype.pause = function() {
  this._running = !1;
};
T.prototype.resume = function() {
  this._running = !0, this._index < this._buffer.length && this._parse(), this._ended && this._finish();
};
T.prototype.end = function(t) {
  this._ended && this._cbs.onerror(Error(".end() after done!")), t && this.write(t), this._ended = !0, this._running && this._finish();
};
T.prototype._finish = function() {
  this._sectionStart < this._index && this._handleTrailingData(), this._cbs.onend();
};
T.prototype._handleTrailingData = function() {
  var t = this._buffer.substr(this._sectionStart);
  this._state === de || this._state === Dn || this._state === Ln ? this._cbs.oncdata(t) : this._state === fe || this._state === An || this._state === kn ? this._cbs.oncomment(t) : this._state === Cn && !this._xmlMode ? (this._parseLegacyEntity(), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state === Nn && !this._xmlMode ? (this._decodeNumericEntity(2, 10), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state === Rn && !this._xmlMode ? (this._decodeNumericEntity(3, 16), this._sectionStart < this._index && (this._state = this._baseState, this._handleTrailingData())) : this._state !== Mt && this._state !== Rt && this._state !== xn && this._state !== En && this._state !== Ce && this._state !== Sn && this._state !== qn && this._state !== Tn && this._state !== pe && this._cbs.ontext(t);
};
T.prototype.reset = function() {
  T.call(
    this,
    { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
    this._cbs
  );
};
T.prototype.getAbsoluteIndex = function() {
  return this._bufferOffset + this._index;
};
T.prototype._getSection = function() {
  return this._buffer.substring(this._sectionStart, this._index);
};
T.prototype._emitToken = function(t) {
  this._cbs[t](this._getSection()), this._sectionStart = -1;
};
T.prototype._emitPartial = function(t) {
  this._baseState !== H ? this._cbs.onattribdata(t) : this._cbs.ontext(t);
};
var fn = { exports: {} };
typeof Object.create == "function" ? fn.exports = function(e, n) {
  n && (e.super_ = n, e.prototype = Object.create(n.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : fn.exports = function(e, n) {
  if (n) {
    e.super_ = n;
    var s = function() {
    };
    s.prototype = n.prototype, e.prototype = new s(), e.prototype.constructor = e;
  }
};
var Ne = fn.exports;
const nH = {}, rH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nH
}, Symbol.toStringTag, { value: "Module" })), Lo = /* @__PURE__ */ ws(rH);
var Qn = Yr, jt = {
  input: !0,
  option: !0,
  optgroup: !0,
  select: !0,
  button: !0,
  datalist: !0,
  textarea: !0
}, Kn = {
  tr: { tr: !0, th: !0, td: !0 },
  th: { th: !0 },
  td: { thead: !0, th: !0, td: !0 },
  body: { head: !0, link: !0, script: !0 },
  li: { li: !0 },
  p: { p: !0 },
  h1: { p: !0 },
  h2: { p: !0 },
  h3: { p: !0 },
  h4: { p: !0 },
  h5: { p: !0 },
  h6: { p: !0 },
  select: jt,
  input: jt,
  output: jt,
  button: jt,
  datalist: jt,
  textarea: jt,
  option: { option: !0 },
  optgroup: { optgroup: !0 }
}, Bn = {
  __proto__: null,
  area: !0,
  base: !0,
  basefont: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  frame: !0,
  hr: !0,
  img: !0,
  input: !0,
  isindex: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
}, Co = {
  __proto__: null,
  math: !0,
  svg: !0
}, No = {
  __proto__: null,
  mi: !0,
  mo: !0,
  mn: !0,
  ms: !0,
  mtext: !0,
  "annotation-xml": !0,
  foreignObject: !0,
  desc: !0,
  title: !0
}, oH = /\s|\//;
function V(t, e) {
  this._options = e || {}, this._cbs = t || {}, this._tagname = "", this._attribname = "", this._attribvalue = "", this._attribs = null, this._stack = [], this._foreignContext = [], this.startIndex = 0, this.endIndex = null, this._lowerCaseTagNames = "lowerCaseTags" in this._options ? !!this._options.lowerCaseTags : !this._options.xmlMode, this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ? !!this._options.lowerCaseAttributeNames : !this._options.xmlMode, this._options.Tokenizer && (Qn = this._options.Tokenizer), this._tokenizer = new Qn(this._options, this), this._cbs.onparserinit && this._cbs.onparserinit(this);
}
Ne(V, Lo.EventEmitter);
V.prototype._updatePosition = function(t) {
  this.endIndex === null ? this._tokenizer._sectionStart <= t ? this.startIndex = 0 : this.startIndex = this._tokenizer._sectionStart - t : this.startIndex = this.endIndex + 1, this.endIndex = this._tokenizer.getAbsoluteIndex();
};
V.prototype.ontext = function(t) {
  this._updatePosition(1), this.endIndex--, this._cbs.ontext && this._cbs.ontext(t);
};
V.prototype.onopentagname = function(t) {
  if (this._lowerCaseTagNames && (t = t.toLowerCase()), this._tagname = t, !this._options.xmlMode && t in Kn)
    for (var e; (e = this._stack[this._stack.length - 1]) in Kn[t]; this.onclosetag(e))
      ;
  (this._options.xmlMode || !(t in Bn)) && (this._stack.push(t), t in Co ? this._foreignContext.push(!0) : t in No && this._foreignContext.push(!1)), this._cbs.onopentagname && this._cbs.onopentagname(t), this._cbs.onopentag && (this._attribs = {});
};
V.prototype.onopentagend = function() {
  this._updatePosition(1), this._attribs && (this._cbs.onopentag && this._cbs.onopentag(this._tagname, this._attribs), this._attribs = null), !this._options.xmlMode && this._cbs.onclosetag && this._tagname in Bn && this._cbs.onclosetag(this._tagname), this._tagname = "";
};
V.prototype.onclosetag = function(t) {
  if (this._updatePosition(1), this._lowerCaseTagNames && (t = t.toLowerCase()), (t in Co || t in No) && this._foreignContext.pop(), this._stack.length && (!(t in Bn) || this._options.xmlMode)) {
    var e = this._stack.lastIndexOf(t);
    if (e !== -1)
      if (this._cbs.onclosetag)
        for (e = this._stack.length - e; e--; )
          this._cbs.onclosetag(this._stack.pop());
      else
        this._stack.length = e;
    else
      t === "p" && !this._options.xmlMode && (this.onopentagname(t), this._closeCurrentTag());
  } else
    !this._options.xmlMode && (t === "br" || t === "p") && (this.onopentagname(t), this._closeCurrentTag());
};
V.prototype.onselfclosingtag = function() {
  this._options.xmlMode || this._options.recognizeSelfClosing || this._foreignContext[this._foreignContext.length - 1] ? this._closeCurrentTag() : this.onopentagend();
};
V.prototype._closeCurrentTag = function() {
  var t = this._tagname;
  this.onopentagend(), this._stack[this._stack.length - 1] === t && (this._cbs.onclosetag && this._cbs.onclosetag(t), this._stack.pop());
};
V.prototype.onattribname = function(t) {
  this._lowerCaseAttributeNames && (t = t.toLowerCase()), this._attribname = t;
};
V.prototype.onattribdata = function(t) {
  this._attribvalue += t;
};
V.prototype.onattribend = function() {
  this._cbs.onattribute && this._cbs.onattribute(this._attribname, this._attribvalue), this._attribs && !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname) && (this._attribs[this._attribname] = this._attribvalue), this._attribname = "", this._attribvalue = "";
};
V.prototype._getInstructionName = function(t) {
  var e = t.search(oH), n = e < 0 ? t : t.substr(0, e);
  return this._lowerCaseTagNames && (n = n.toLowerCase()), n;
};
V.prototype.ondeclaration = function(t) {
  if (this._cbs.onprocessinginstruction) {
    var e = this._getInstructionName(t);
    this._cbs.onprocessinginstruction("!" + e, "!" + t);
  }
};
V.prototype.onprocessinginstruction = function(t) {
  if (this._cbs.onprocessinginstruction) {
    var e = this._getInstructionName(t);
    this._cbs.onprocessinginstruction("?" + e, "?" + t);
  }
};
V.prototype.oncomment = function(t) {
  this._updatePosition(4), this._cbs.oncomment && this._cbs.oncomment(t), this._cbs.oncommentend && this._cbs.oncommentend();
};
V.prototype.oncdata = function(t) {
  this._updatePosition(1), this._options.xmlMode || this._options.recognizeCDATA ? (this._cbs.oncdatastart && this._cbs.oncdatastart(), this._cbs.ontext && this._cbs.ontext(t), this._cbs.oncdataend && this._cbs.oncdataend()) : this.oncomment("[CDATA[" + t + "]]");
};
V.prototype.onerror = function(t) {
  this._cbs.onerror && this._cbs.onerror(t);
};
V.prototype.onend = function() {
  if (this._cbs.onclosetag)
    for (var t = this._stack.length; t > 0; this._cbs.onclosetag(this._stack[--t]))
      ;
  this._cbs.onend && this._cbs.onend();
};
V.prototype.reset = function() {
  this._cbs.onreset && this._cbs.onreset(), this._tokenizer.reset(), this._tagname = "", this._attribname = "", this._attribs = null, this._stack = [], this._cbs.onparserinit && this._cbs.onparserinit(this);
};
V.prototype.parseComplete = function(t) {
  this.reset(), this.end(t);
};
V.prototype.write = function(t) {
  this._tokenizer.write(t);
};
V.prototype.end = function(t) {
  this._tokenizer.end(t);
};
V.prototype.pause = function() {
  this._tokenizer.pause();
};
V.prototype.resume = function() {
  this._tokenizer.resume();
};
V.prototype.parseChunk = V.prototype.write;
V.prototype.done = V.prototype.end;
var Ro = V, ge = {
  Text: "text",
  //Text
  Directive: "directive",
  //<? ... ?>
  Comment: "comment",
  //<!-- ... -->
  Script: "script",
  //<script> tags
  Style: "style",
  //<style> tags
  Tag: "tag",
  //Any tag
  CDATA: "cdata",
  //<![CDATA[ ... ]]>
  Doctype: "doctype",
  isTag: function(t) {
    return t.type === "tag" || t.type === "script" || t.type === "style";
  }
}, Io = { exports: {} };
Io.exports = {
  get firstChild() {
    var t = this.children;
    return t && t[0] || null;
  },
  get lastChild() {
    var t = this.children;
    return t && t[t.length - 1] || null;
  },
  get nodeType() {
    return tr[this.type] || tr.element;
  }
};
var sH = {
  tagName: "name",
  childNodes: "children",
  parentNode: "parent",
  previousSibling: "prev",
  nextSibling: "next",
  nodeValue: "data"
}, tr = {
  element: 1,
  text: 3,
  cdata: 4,
  comment: 8
};
Object.keys(sH).forEach(function(t) {
});
var Bo = Io.exports, Oo = { exports: {} }, cH = Bo, iH = Oo.exports = Object.create(cH), er = {
  tagName: "name"
};
Object.keys(er).forEach(function(t) {
  var e = er[t];
  Object.defineProperty(iH, t, {
    get: function() {
      return this[e] || null;
    },
    set: function(n) {
      return this[e] = n, n;
    }
  });
});
var aH = Oo.exports, $t = ge, Ve = /\s+/g, lH = Bo, uH = aH;
function et(t, e, n) {
  typeof t == "object" ? (n = e, e = t, t = null) : typeof e == "function" && (n = e, e = nr), this._callback = t, this._options = e || nr, this._elementCB = n, this.dom = [], this._done = !1, this._tagStack = [], this._parser = this._parser || null;
}
var nr = {
  normalizeWhitespace: !1,
  //Replace all whitespace with single spaces
  withStartIndices: !1,
  //Add startIndex properties to nodes
  withEndIndices: !1
  //Add endIndex properties to nodes
};
et.prototype.onparserinit = function(t) {
  this._parser = t;
};
et.prototype.onreset = function() {
  et.call(this, this._callback, this._options, this._elementCB);
};
et.prototype.onend = function() {
  this._done || (this._done = !0, this._parser = null, this._handleCallback(null));
};
et.prototype._handleCallback = et.prototype.onerror = function(t) {
  if (typeof this._callback == "function")
    this._callback(t, this.dom);
  else if (t)
    throw t;
};
et.prototype.onclosetag = function() {
  var t = this._tagStack.pop();
  this._options.withEndIndices && t && (t.endIndex = this._parser.endIndex), this._elementCB && this._elementCB(t);
};
et.prototype._createDomElement = function(t) {
  if (!this._options.withDomLvl1)
    return t;
  var e;
  t.type === "tag" ? e = Object.create(uH) : e = Object.create(lH);
  for (var n in t)
    t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
};
et.prototype._addDomElement = function(t) {
  var e = this._tagStack[this._tagStack.length - 1], n = e ? e.children : this.dom, s = n[n.length - 1];
  t.next = null, this._options.withStartIndices && (t.startIndex = this._parser.startIndex), this._options.withEndIndices && (t.endIndex = this._parser.endIndex), s ? (t.prev = s, s.next = t) : t.prev = null, n.push(t), t.parent = e || null;
};
et.prototype.onopentag = function(t, e) {
  var n = {
    type: t === "script" ? $t.Script : t === "style" ? $t.Style : $t.Tag,
    name: t,
    attribs: e,
    children: []
  }, s = this._createDomElement(n);
  this._addDomElement(s), this._tagStack.push(s);
};
et.prototype.ontext = function(t) {
  var e = this._options.normalizeWhitespace || this._options.ignoreWhitespace, n;
  if (!this._tagStack.length && this.dom.length && (n = this.dom[this.dom.length - 1]).type === $t.Text)
    e ? n.data = (n.data + t).replace(Ve, " ") : n.data += t;
  else if (this._tagStack.length && (n = this._tagStack[this._tagStack.length - 1]) && (n = n.children[n.children.length - 1]) && n.type === $t.Text)
    e ? n.data = (n.data + t).replace(Ve, " ") : n.data += t;
  else {
    e && (t = t.replace(Ve, " "));
    var s = this._createDomElement({
      data: t,
      type: $t.Text
    });
    this._addDomElement(s);
  }
};
et.prototype.oncomment = function(t) {
  var e = this._tagStack[this._tagStack.length - 1];
  if (e && e.type === $t.Comment) {
    e.data += t;
    return;
  }
  var n = {
    data: t,
    type: $t.Comment
  }, s = this._createDomElement(n);
  this._addDomElement(s), this._tagStack.push(s);
};
et.prototype.oncdatastart = function() {
  var t = {
    children: [{
      data: "",
      type: $t.Text
    }],
    type: $t.CDATA
  }, e = this._createDomElement(t);
  this._addDomElement(e), this._tagStack.push(e);
};
et.prototype.oncommentend = et.prototype.oncdataend = function() {
  this._tagStack.pop();
};
et.prototype.onprocessinginstruction = function(t, e) {
  var n = this._createDomElement({
    name: t,
    data: e,
    type: $t.Directive
  });
  this._addDomElement(n);
};
var Uo = et, Me = { exports: {} }, He = { exports: {} }, Ge = {}, rr;
function pH() {
  return rr || (rr = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0;
    var e;
    (function(s) {
      s.Root = "root", s.Text = "text", s.Directive = "directive", s.Comment = "comment", s.Script = "script", s.Style = "style", s.Tag = "tag", s.CDATA = "cdata", s.Doctype = "doctype";
    })(e = t.ElementType || (t.ElementType = {}));
    function n(s) {
      return s.type === e.Tag || s.type === e.Script || s.type === e.Style;
    }
    t.isTag = n, t.Root = e.Root, t.Text = e.Text, t.Directive = e.Directive, t.Comment = e.Comment, t.Script = e.Script, t.Style = e.Style, t.Tag = e.Tag, t.CDATA = e.CDATA, t.Doctype = e.Doctype;
  }(Ge)), Ge;
}
var je = {}, qt = {};
const fH = "Á", dH = "á", hH = "Ă", gH = "ă", $H = "∾", mH = "∿", bH = "∾̳", yH = "Â", vH = "â", wH = "´", _H = "А", EH = "а", xH = "Æ", qH = "æ", SH = "⁡", TH = "𝔄", AH = "𝔞", kH = "À", DH = "à", LH = "ℵ", CH = "ℵ", NH = "Α", RH = "α", IH = "Ā", BH = "ā", OH = "⨿", UH = "&", PH = "&", FH = "⩕", VH = "⩓", MH = "∧", HH = "⩜", GH = "⩘", jH = "⩚", zH = "∠", YH = "⦤", WH = "∠", JH = "⦨", XH = "⦩", ZH = "⦪", QH = "⦫", KH = "⦬", t8 = "⦭", e8 = "⦮", n8 = "⦯", r8 = "∡", o8 = "∟", s8 = "⊾", c8 = "⦝", i8 = "∢", a8 = "Å", l8 = "⍼", u8 = "Ą", p8 = "ą", f8 = "𝔸", d8 = "𝕒", h8 = "⩯", g8 = "≈", $8 = "⩰", m8 = "≊", b8 = "≋", y8 = "'", v8 = "⁡", w8 = "≈", _8 = "≊", E8 = "Å", x8 = "å", q8 = "𝒜", S8 = "𝒶", T8 = "≔", A8 = "*", k8 = "≈", D8 = "≍", L8 = "Ã", C8 = "ã", N8 = "Ä", R8 = "ä", I8 = "∳", B8 = "⨑", O8 = "≌", U8 = "϶", P8 = "‵", F8 = "∽", V8 = "⋍", M8 = "∖", H8 = "⫧", G8 = "⊽", j8 = "⌅", z8 = "⌆", Y8 = "⌅", W8 = "⎵", J8 = "⎶", X8 = "≌", Z8 = "Б", Q8 = "б", K8 = "„", t4 = "∵", e4 = "∵", n4 = "∵", r4 = "⦰", o4 = "϶", s4 = "ℬ", c4 = "ℬ", i4 = "Β", a4 = "β", l4 = "ℶ", u4 = "≬", p4 = "𝔅", f4 = "𝔟", d4 = "⋂", h4 = "◯", g4 = "⋃", $4 = "⨀", m4 = "⨁", b4 = "⨂", y4 = "⨆", v4 = "★", w4 = "▽", _4 = "△", E4 = "⨄", x4 = "⋁", q4 = "⋀", S4 = "⤍", T4 = "⧫", A4 = "▪", k4 = "▴", D4 = "▾", L4 = "◂", C4 = "▸", N4 = "␣", R4 = "▒", I4 = "░", B4 = "▓", O4 = "█", U4 = "=⃥", P4 = "≡⃥", F4 = "⫭", V4 = "⌐", M4 = "𝔹", H4 = "𝕓", G4 = "⊥", j4 = "⊥", z4 = "⋈", Y4 = "⧉", W4 = "┐", J4 = "╕", X4 = "╖", Z4 = "╗", Q4 = "┌", K4 = "╒", tG = "╓", eG = "╔", nG = "─", rG = "═", oG = "┬", sG = "╤", cG = "╥", iG = "╦", aG = "┴", lG = "╧", uG = "╨", pG = "╩", fG = "⊟", dG = "⊞", hG = "⊠", gG = "┘", $G = "╛", mG = "╜", bG = "╝", yG = "└", vG = "╘", wG = "╙", _G = "╚", EG = "│", xG = "║", qG = "┼", SG = "╪", TG = "╫", AG = "╬", kG = "┤", DG = "╡", LG = "╢", CG = "╣", NG = "├", RG = "╞", IG = "╟", BG = "╠", OG = "‵", UG = "˘", PG = "˘", FG = "¦", VG = "𝒷", MG = "ℬ", HG = "⁏", GG = "∽", jG = "⋍", zG = "⧅", YG = "\\", WG = "⟈", JG = "•", XG = "•", ZG = "≎", QG = "⪮", KG = "≏", tj = "≎", ej = "≏", nj = "Ć", rj = "ć", oj = "⩄", sj = "⩉", cj = "⩋", ij = "∩", aj = "⋒", lj = "⩇", uj = "⩀", pj = "ⅅ", fj = "∩︀", dj = "⁁", hj = "ˇ", gj = "ℭ", $j = "⩍", mj = "Č", bj = "č", yj = "Ç", vj = "ç", wj = "Ĉ", _j = "ĉ", Ej = "∰", xj = "⩌", qj = "⩐", Sj = "Ċ", Tj = "ċ", Aj = "¸", kj = "¸", Dj = "⦲", Lj = "¢", Cj = "·", Nj = "·", Rj = "𝔠", Ij = "ℭ", Bj = "Ч", Oj = "ч", Uj = "✓", Pj = "✓", Fj = "Χ", Vj = "χ", Mj = "ˆ", Hj = "≗", Gj = "↺", jj = "↻", zj = "⊛", Yj = "⊚", Wj = "⊝", Jj = "⊙", Xj = "®", Zj = "Ⓢ", Qj = "⊖", Kj = "⊕", t5 = "⊗", e5 = "○", n5 = "⧃", r5 = "≗", o5 = "⨐", s5 = "⫯", c5 = "⧂", i5 = "∲", a5 = "”", l5 = "’", u5 = "♣", p5 = "♣", f5 = ":", d5 = "∷", h5 = "⩴", g5 = "≔", $5 = "≔", m5 = ",", b5 = "@", y5 = "∁", v5 = "∘", w5 = "∁", _5 = "ℂ", E5 = "≅", x5 = "⩭", q5 = "≡", S5 = "∮", T5 = "∯", A5 = "∮", k5 = "𝕔", D5 = "ℂ", L5 = "∐", C5 = "∐", N5 = "©", R5 = "©", I5 = "℗", B5 = "∳", O5 = "↵", U5 = "✗", P5 = "⨯", F5 = "𝒞", V5 = "𝒸", M5 = "⫏", H5 = "⫑", G5 = "⫐", j5 = "⫒", z5 = "⋯", Y5 = "⤸", W5 = "⤵", J5 = "⋞", X5 = "⋟", Z5 = "↶", Q5 = "⤽", K5 = "⩈", t6 = "⩆", e6 = "≍", n6 = "∪", r6 = "⋓", o6 = "⩊", s6 = "⊍", c6 = "⩅", i6 = "∪︀", a6 = "↷", l6 = "⤼", u6 = "⋞", p6 = "⋟", f6 = "⋎", d6 = "⋏", h6 = "¤", g6 = "↶", $6 = "↷", m6 = "⋎", b6 = "⋏", y6 = "∲", v6 = "∱", w6 = "⌭", _6 = "†", E6 = "‡", x6 = "ℸ", q6 = "↓", S6 = "↡", T6 = "⇓", A6 = "‐", k6 = "⫤", D6 = "⊣", L6 = "⤏", C6 = "˝", N6 = "Ď", R6 = "ď", I6 = "Д", B6 = "д", O6 = "‡", U6 = "⇊", P6 = "ⅅ", F6 = "ⅆ", V6 = "⤑", M6 = "⩷", H6 = "°", G6 = "∇", j6 = "Δ", z6 = "δ", Y6 = "⦱", W6 = "⥿", J6 = "𝔇", X6 = "𝔡", Z6 = "⥥", Q6 = "⇃", K6 = "⇂", tz = "´", ez = "˙", nz = "˝", rz = "`", oz = "˜", sz = "⋄", cz = "⋄", iz = "⋄", az = "♦", lz = "♦", uz = "¨", pz = "ⅆ", fz = "ϝ", dz = "⋲", hz = "÷", gz = "÷", $z = "⋇", mz = "⋇", bz = "Ђ", yz = "ђ", vz = "⌞", wz = "⌍", _z = "$", Ez = "𝔻", xz = "𝕕", qz = "¨", Sz = "˙", Tz = "⃜", Az = "≐", kz = "≑", Dz = "≐", Lz = "∸", Cz = "∔", Nz = "⊡", Rz = "⌆", Iz = "∯", Bz = "¨", Oz = "⇓", Uz = "⇐", Pz = "⇔", Fz = "⫤", Vz = "⟸", Mz = "⟺", Hz = "⟹", Gz = "⇒", jz = "⊨", zz = "⇑", Yz = "⇕", Wz = "∥", Jz = "⤓", Xz = "↓", Zz = "↓", Qz = "⇓", Kz = "⇵", tY = "̑", eY = "⇊", nY = "⇃", rY = "⇂", oY = "⥐", sY = "⥞", cY = "⥖", iY = "↽", aY = "⥟", lY = "⥗", uY = "⇁", pY = "↧", fY = "⊤", dY = "⤐", hY = "⌟", gY = "⌌", $Y = "𝒟", mY = "𝒹", bY = "Ѕ", yY = "ѕ", vY = "⧶", wY = "Đ", _Y = "đ", EY = "⋱", xY = "▿", qY = "▾", SY = "⇵", TY = "⥯", AY = "⦦", kY = "Џ", DY = "џ", LY = "⟿", CY = "É", NY = "é", RY = "⩮", IY = "Ě", BY = "ě", OY = "Ê", UY = "ê", PY = "≖", FY = "≕", VY = "Э", MY = "э", HY = "⩷", GY = "Ė", jY = "ė", zY = "≑", YY = "ⅇ", WY = "≒", JY = "𝔈", XY = "𝔢", ZY = "⪚", QY = "È", KY = "è", t7 = "⪖", e7 = "⪘", n7 = "⪙", r7 = "∈", o7 = "⏧", s7 = "ℓ", c7 = "⪕", i7 = "⪗", a7 = "Ē", l7 = "ē", u7 = "∅", p7 = "∅", f7 = "◻", d7 = "∅", h7 = "▫", g7 = " ", $7 = " ", m7 = " ", b7 = "Ŋ", y7 = "ŋ", v7 = " ", w7 = "Ę", _7 = "ę", E7 = "𝔼", x7 = "𝕖", q7 = "⋕", S7 = "⧣", T7 = "⩱", A7 = "ε", k7 = "Ε", D7 = "ε", L7 = "ϵ", C7 = "≖", N7 = "≕", R7 = "≂", I7 = "⪖", B7 = "⪕", O7 = "⩵", U7 = "=", P7 = "≂", F7 = "≟", V7 = "⇌", M7 = "≡", H7 = "⩸", G7 = "⧥", j7 = "⥱", z7 = "≓", Y7 = "ℯ", W7 = "ℰ", J7 = "≐", X7 = "⩳", Z7 = "≂", Q7 = "Η", K7 = "η", t9 = "Ð", e9 = "ð", n9 = "Ë", r9 = "ë", o9 = "€", s9 = "!", c9 = "∃", i9 = "∃", a9 = "ℰ", l9 = "ⅇ", u9 = "ⅇ", p9 = "≒", f9 = "Ф", d9 = "ф", h9 = "♀", g9 = "ﬃ", $9 = "ﬀ", m9 = "ﬄ", b9 = "𝔉", y9 = "𝔣", v9 = "ﬁ", w9 = "◼", _9 = "▪", E9 = "fj", x9 = "♭", q9 = "ﬂ", S9 = "▱", T9 = "ƒ", A9 = "𝔽", k9 = "𝕗", D9 = "∀", L9 = "∀", C9 = "⋔", N9 = "⫙", R9 = "ℱ", I9 = "⨍", B9 = "½", O9 = "⅓", U9 = "¼", P9 = "⅕", F9 = "⅙", V9 = "⅛", M9 = "⅔", H9 = "⅖", G9 = "¾", j9 = "⅗", z9 = "⅜", Y9 = "⅘", W9 = "⅚", J9 = "⅝", X9 = "⅞", Z9 = "⁄", Q9 = "⌢", K9 = "𝒻", tW = "ℱ", eW = "ǵ", nW = "Γ", rW = "γ", oW = "Ϝ", sW = "ϝ", cW = "⪆", iW = "Ğ", aW = "ğ", lW = "Ģ", uW = "Ĝ", pW = "ĝ", fW = "Г", dW = "г", hW = "Ġ", gW = "ġ", $W = "≥", mW = "≧", bW = "⪌", yW = "⋛", vW = "≥", wW = "≧", _W = "⩾", EW = "⪩", xW = "⩾", qW = "⪀", SW = "⪂", TW = "⪄", AW = "⋛︀", kW = "⪔", DW = "𝔊", LW = "𝔤", CW = "≫", NW = "⋙", RW = "⋙", IW = "ℷ", BW = "Ѓ", OW = "ѓ", UW = "⪥", PW = "≷", FW = "⪒", VW = "⪤", MW = "⪊", HW = "⪊", GW = "⪈", jW = "≩", zW = "⪈", YW = "≩", WW = "⋧", JW = "𝔾", XW = "𝕘", ZW = "`", QW = "≥", KW = "⋛", tJ = "≧", eJ = "⪢", nJ = "≷", rJ = "⩾", oJ = "≳", sJ = "𝒢", cJ = "ℊ", iJ = "≳", aJ = "⪎", lJ = "⪐", uJ = "⪧", pJ = "⩺", fJ = ">", dJ = ">", hJ = "≫", gJ = "⋗", $J = "⦕", mJ = "⩼", bJ = "⪆", yJ = "⥸", vJ = "⋗", wJ = "⋛", _J = "⪌", EJ = "≷", xJ = "≳", qJ = "≩︀", SJ = "≩︀", TJ = "ˇ", AJ = " ", kJ = "½", DJ = "ℋ", LJ = "Ъ", CJ = "ъ", NJ = "⥈", RJ = "↔", IJ = "⇔", BJ = "↭", OJ = "^", UJ = "ℏ", PJ = "Ĥ", FJ = "ĥ", VJ = "♥", MJ = "♥", HJ = "…", GJ = "⊹", jJ = "𝔥", zJ = "ℌ", YJ = "ℋ", WJ = "⤥", JJ = "⤦", XJ = "⇿", ZJ = "∻", QJ = "↩", KJ = "↪", tX = "𝕙", eX = "ℍ", nX = "―", rX = "─", oX = "𝒽", sX = "ℋ", cX = "ℏ", iX = "Ħ", aX = "ħ", lX = "≎", uX = "≏", pX = "⁃", fX = "‐", dX = "Í", hX = "í", gX = "⁣", $X = "Î", mX = "î", bX = "И", yX = "и", vX = "İ", wX = "Е", _X = "е", EX = "¡", xX = "⇔", qX = "𝔦", SX = "ℑ", TX = "Ì", AX = "ì", kX = "ⅈ", DX = "⨌", LX = "∭", CX = "⧜", NX = "℩", RX = "Ĳ", IX = "ĳ", BX = "Ī", OX = "ī", UX = "ℑ", PX = "ⅈ", FX = "ℐ", VX = "ℑ", MX = "ı", HX = "ℑ", GX = "⊷", jX = "Ƶ", zX = "⇒", YX = "℅", WX = "∞", JX = "⧝", XX = "ı", ZX = "⊺", QX = "∫", KX = "∬", tZ = "ℤ", eZ = "∫", nZ = "⊺", rZ = "⋂", oZ = "⨗", sZ = "⨼", cZ = "⁣", iZ = "⁢", aZ = "Ё", lZ = "ё", uZ = "Į", pZ = "į", fZ = "𝕀", dZ = "𝕚", hZ = "Ι", gZ = "ι", $Z = "⨼", mZ = "¿", bZ = "𝒾", yZ = "ℐ", vZ = "∈", wZ = "⋵", _Z = "⋹", EZ = "⋴", xZ = "⋳", qZ = "∈", SZ = "⁢", TZ = "Ĩ", AZ = "ĩ", kZ = "І", DZ = "і", LZ = "Ï", CZ = "ï", NZ = "Ĵ", RZ = "ĵ", IZ = "Й", BZ = "й", OZ = "𝔍", UZ = "𝔧", PZ = "ȷ", FZ = "𝕁", VZ = "𝕛", MZ = "𝒥", HZ = "𝒿", GZ = "Ј", jZ = "ј", zZ = "Є", YZ = "є", WZ = "Κ", JZ = "κ", XZ = "ϰ", ZZ = "Ķ", QZ = "ķ", KZ = "К", tQ = "к", eQ = "𝔎", nQ = "𝔨", rQ = "ĸ", oQ = "Х", sQ = "х", cQ = "Ќ", iQ = "ќ", aQ = "𝕂", lQ = "𝕜", uQ = "𝒦", pQ = "𝓀", fQ = "⇚", dQ = "Ĺ", hQ = "ĺ", gQ = "⦴", $Q = "ℒ", mQ = "Λ", bQ = "λ", yQ = "⟨", vQ = "⟪", wQ = "⦑", _Q = "⟨", EQ = "⪅", xQ = "ℒ", qQ = "«", SQ = "⇤", TQ = "⤟", AQ = "←", kQ = "↞", DQ = "⇐", LQ = "⤝", CQ = "↩", NQ = "↫", RQ = "⤹", IQ = "⥳", BQ = "↢", OQ = "⤙", UQ = "⤛", PQ = "⪫", FQ = "⪭", VQ = "⪭︀", MQ = "⤌", HQ = "⤎", GQ = "❲", jQ = "{", zQ = "[", YQ = "⦋", WQ = "⦏", JQ = "⦍", XQ = "Ľ", ZQ = "ľ", QQ = "Ļ", KQ = "ļ", tK = "⌈", eK = "{", nK = "Л", rK = "л", oK = "⤶", sK = "“", cK = "„", iK = "⥧", aK = "⥋", lK = "↲", uK = "≤", pK = "≦", fK = "⟨", dK = "⇤", hK = "←", gK = "←", $K = "⇐", mK = "⇆", bK = "↢", yK = "⌈", vK = "⟦", wK = "⥡", _K = "⥙", EK = "⇃", xK = "⌊", qK = "↽", SK = "↼", TK = "⇇", AK = "↔", kK = "↔", DK = "⇔", LK = "⇆", CK = "⇋", NK = "↭", RK = "⥎", IK = "↤", BK = "⊣", OK = "⥚", UK = "⋋", PK = "⧏", FK = "⊲", VK = "⊴", MK = "⥑", HK = "⥠", GK = "⥘", jK = "↿", zK = "⥒", YK = "↼", WK = "⪋", JK = "⋚", XK = "≤", ZK = "≦", QK = "⩽", KK = "⪨", ttt = "⩽", ett = "⩿", ntt = "⪁", rtt = "⪃", ott = "⋚︀", stt = "⪓", ctt = "⪅", itt = "⋖", att = "⋚", ltt = "⪋", utt = "⋚", ptt = "≦", ftt = "≶", dtt = "≶", htt = "⪡", gtt = "≲", $tt = "⩽", mtt = "≲", btt = "⥼", ytt = "⌊", vtt = "𝔏", wtt = "𝔩", _tt = "≶", Ett = "⪑", xtt = "⥢", qtt = "↽", Stt = "↼", Ttt = "⥪", Att = "▄", ktt = "Љ", Dtt = "љ", Ltt = "⇇", Ctt = "≪", Ntt = "⋘", Rtt = "⌞", Itt = "⇚", Btt = "⥫", Ott = "◺", Utt = "Ŀ", Ptt = "ŀ", Ftt = "⎰", Vtt = "⎰", Mtt = "⪉", Htt = "⪉", Gtt = "⪇", jtt = "≨", ztt = "⪇", Ytt = "≨", Wtt = "⋦", Jtt = "⟬", Xtt = "⇽", Ztt = "⟦", Qtt = "⟵", Ktt = "⟵", tet = "⟸", eet = "⟷", net = "⟷", ret = "⟺", oet = "⟼", set = "⟶", cet = "⟶", iet = "⟹", aet = "↫", uet = "↬", pet = "⦅", fet = "𝕃", det = "𝕝", het = "⨭", get = "⨴", $et = "∗", met = "_", bet = "↙", yet = "↘", vet = "◊", wet = "◊", _et = "⧫", Eet = "(", xet = "⦓", qet = "⇆", Tet = "⌟", Aet = "⇋", ket = "⥭", Det = "‎", Let = "⊿", Cet = "‹", Net = "𝓁", Ret = "ℒ", Iet = "↰", Bet = "↰", Oet = "≲", Uet = "⪍", Pet = "⪏", Fet = "[", Vet = "‘", Met = "‚", Het = "Ł", Get = "ł", jet = "⪦", zet = "⩹", Yet = "<", Wet = "<", Jet = "≪", Xet = "⋖", Zet = "⋋", Qet = "⋉", Ket = "⥶", tnt = "⩻", ent = "◃", nnt = "⊴", rnt = "◂", ont = "⦖", snt = "⥊", cnt = "⥦", int = "≨︀", ant = "≨︀", lnt = "¯", unt = "♂", pnt = "✠", fnt = "✠", dnt = "↦", hnt = "↦", gnt = "↧", $nt = "↤", mnt = "↥", bnt = "▮", ynt = "⨩", vnt = "М", wnt = "м", _nt = "—", Ent = "∺", xnt = "∡", qnt = " ", Snt = "ℳ", Tnt = "𝔐", Ant = "𝔪", knt = "℧", Dnt = "µ", Lnt = "*", Cnt = "⫰", Nnt = "∣", Rnt = "·", Int = "⊟", Bnt = "−", Ont = "∸", Unt = "⨪", Pnt = "∓", Fnt = "⫛", Vnt = "…", Mnt = "∓", Hnt = "⊧", Gnt = "𝕄", jnt = "𝕞", znt = "∓", Ynt = "𝓂", Wnt = "ℳ", Jnt = "∾", Xnt = "Μ", Znt = "μ", Qnt = "⊸", Knt = "⊸", trt = "∇", ert = "Ń", nrt = "ń", rrt = "∠⃒", ort = "≉", srt = "⩰̸", crt = "≋̸", irt = "ŉ", art = "≉", lrt = "♮", urt = "ℕ", prt = "♮", frt = " ", drt = "≎̸", hrt = "≏̸", grt = "⩃", $rt = "Ň", mrt = "ň", brt = "Ņ", yrt = "ņ", vrt = "≇", wrt = "⩭̸", _rt = "⩂", Ert = "Н", xrt = "н", qrt = "–", Srt = "⤤", Trt = "↗", Art = "⇗", krt = "↗", Drt = "≠", Lrt = "≐̸", Crt = "​", Nrt = "​", Rrt = "​", Irt = "​", Brt = "≢", Ort = "⤨", Urt = "≂̸", Prt = "≫", Frt = "≪", Vrt = `
`, Mrt = "∄", Hrt = "∄", Grt = "𝔑", jrt = "𝔫", zrt = "≧̸", Yrt = "≱", Wrt = "≱", Jrt = "≧̸", Xrt = "⩾̸", Zrt = "⩾̸", Qrt = "⋙̸", Krt = "≵", tot = "≫⃒", eot = "≯", not = "≯", rot = "≫̸", oot = "↮", sot = "⇎", cot = "⫲", iot = "∋", aot = "⋼", lot = "⋺", uot = "∋", pot = "Њ", fot = "њ", dot = "↚", hot = "⇍", got = "‥", $ot = "≦̸", mot = "≰", bot = "↚", yot = "⇍", vot = "↮", wot = "⇎", _ot = "≰", Eot = "≦̸", xot = "⩽̸", qot = "⩽̸", Sot = "≮", Tot = "⋘̸", Aot = "≴", kot = "≪⃒", Dot = "≮", Lot = "⋪", Cot = "⋬", Not = "≪̸", Rot = "∤", Iot = "⁠", Bot = " ", Oot = "𝕟", Uot = "ℕ", Pot = "⫬", Fot = "¬", Vot = "≢", Mot = "≭", Hot = "∦", Got = "∉", jot = "≠", zot = "≂̸", Yot = "∄", Wot = "≯", Jot = "≱", Xot = "≧̸", Zot = "≫̸", Qot = "≹", Kot = "⩾̸", tst = "≵", est = "≎̸", nst = "≏̸", rst = "∉", ost = "⋵̸", sst = "⋹̸", cst = "∉", ist = "⋷", ast = "⋶", lst = "⧏̸", ust = "⋪", pst = "⋬", fst = "≮", dst = "≰", hst = "≸", gst = "≪̸", $st = "⩽̸", mst = "≴", bst = "⪢̸", yst = "⪡̸", vst = "∌", wst = "∌", _st = "⋾", Est = "⋽", xst = "⊀", qst = "⪯̸", Sst = "⋠", Tst = "∌", Ast = "⧐̸", kst = "⋫", Dst = "⋭", Lst = "⊏̸", Cst = "⋢", Nst = "⊐̸", Rst = "⋣", Ist = "⊂⃒", Bst = "⊈", Ost = "⊁", Ust = "⪰̸", Pst = "⋡", Fst = "≿̸", Vst = "⊃⃒", Mst = "⊉", Hst = "≁", Gst = "≄", jst = "≇", zst = "≉", Yst = "∤", Wst = "∦", Jst = "∦", Xst = "⫽⃥", Zst = "∂̸", Qst = "⨔", Kst = "⊀", tct = "⋠", ect = "⊀", nct = "⪯̸", rct = "⪯̸", oct = "⤳̸", sct = "↛", cct = "⇏", ict = "↝̸", act = "↛", lct = "⇏", uct = "⋫", pct = "⋭", fct = "⊁", dct = "⋡", hct = "⪰̸", gct = "𝒩", $ct = "𝓃", mct = "∤", bct = "∦", yct = "≁", vct = "≄", wct = "≄", _ct = "∤", Ect = "∦", xct = "⋢", qct = "⋣", Sct = "⊄", Tct = "⫅̸", Act = "⊈", kct = "⊂⃒", Dct = "⊈", Lct = "⫅̸", Cct = "⊁", Nct = "⪰̸", Rct = "⊅", Ict = "⫆̸", Bct = "⊉", Oct = "⊃⃒", Uct = "⊉", Pct = "⫆̸", Fct = "≹", Vct = "Ñ", Mct = "ñ", Hct = "≸", Gct = "⋪", jct = "⋬", zct = "⋫", Yct = "⋭", Wct = "Ν", Jct = "ν", Xct = "#", Zct = "№", Qct = " ", Kct = "≍⃒", tit = "⊬", eit = "⊭", nit = "⊮", rit = "⊯", oit = "≥⃒", sit = ">⃒", cit = "⤄", iit = "⧞", ait = "⤂", lit = "≤⃒", uit = "<⃒", pit = "⊴⃒", fit = "⤃", dit = "⊵⃒", hit = "∼⃒", git = "⤣", $it = "↖", mit = "⇖", bit = "↖", yit = "⤧", vit = "Ó", wit = "ó", _it = "⊛", Eit = "Ô", xit = "ô", qit = "⊚", Sit = "О", Tit = "о", Ait = "⊝", kit = "Ő", Dit = "ő", Lit = "⨸", Cit = "⊙", Nit = "⦼", Rit = "Œ", Iit = "œ", Bit = "⦿", Oit = "𝔒", Uit = "𝔬", Pit = "˛", Fit = "Ò", Vit = "ò", Mit = "⧁", Hit = "⦵", Git = "Ω", jit = "∮", zit = "↺", Yit = "⦾", Wit = "⦻", Jit = "‾", Xit = "⧀", Zit = "Ō", Qit = "ō", Kit = "Ω", tat = "ω", eat = "Ο", nat = "ο", rat = "⦶", oat = "⊖", sat = "𝕆", cat = "𝕠", iat = "⦷", aat = "“", lat = "‘", uat = "⦹", pat = "⊕", fat = "↻", dat = "⩔", hat = "∨", gat = "⩝", $at = "ℴ", mat = "ℴ", bat = "ª", yat = "º", vat = "⊶", wat = "⩖", _at = "⩗", Eat = "⩛", xat = "Ⓢ", qat = "𝒪", Sat = "ℴ", Tat = "Ø", Aat = "ø", kat = "⊘", Dat = "Õ", Lat = "õ", Cat = "⨶", Nat = "⨷", Rat = "⊗", Iat = "Ö", Bat = "ö", Oat = "⌽", Uat = "‾", Pat = "⏞", Fat = "⎴", Vat = "⏜", Mat = "¶", Hat = "∥", Gat = "∥", jat = "⫳", zat = "⫽", Yat = "∂", Wat = "∂", Jat = "П", Xat = "п", Zat = "%", Qat = ".", Kat = "‰", tlt = "⊥", elt = "‱", nlt = "𝔓", rlt = "𝔭", olt = "Φ", slt = "φ", clt = "ϕ", ilt = "ℳ", alt = "☎", llt = "Π", ult = "π", plt = "⋔", flt = "ϖ", dlt = "ℏ", hlt = "ℎ", glt = "ℏ", $lt = "⨣", mlt = "⊞", blt = "⨢", ylt = "+", vlt = "∔", wlt = "⨥", _lt = "⩲", Elt = "±", xlt = "±", qlt = "⨦", Slt = "⨧", Tlt = "±", Alt = "ℌ", klt = "⨕", Dlt = "𝕡", Llt = "ℙ", Clt = "£", Nlt = "⪷", Rlt = "⪻", Ilt = "≺", Blt = "≼", Olt = "⪷", Ult = "≺", Plt = "≼", Flt = "≺", Vlt = "⪯", Mlt = "≼", Hlt = "≾", Glt = "⪯", jlt = "⪹", zlt = "⪵", Ylt = "⋨", Wlt = "⪯", Jlt = "⪳", Xlt = "≾", Zlt = "′", Qlt = "″", Klt = "ℙ", tut = "⪹", eut = "⪵", nut = "⋨", rut = "∏", out = "∏", sut = "⌮", cut = "⌒", iut = "⌓", aut = "∝", lut = "∝", uut = "∷", put = "∝", fut = "≾", dut = "⊰", hut = "𝒫", gut = "𝓅", $ut = "Ψ", mut = "ψ", but = " ", yut = "𝔔", vut = "𝔮", wut = "⨌", _ut = "𝕢", Eut = "ℚ", xut = "⁗", qut = "𝒬", Sut = "𝓆", Tut = "ℍ", Aut = "⨖", kut = "?", Dut = "≟", Lut = '"', Cut = '"', Nut = "⇛", Rut = "∽̱", Iut = "Ŕ", But = "ŕ", Out = "√", Uut = "⦳", Put = "⟩", Fut = "⟫", Vut = "⦒", Mut = "⦥", Hut = "⟩", Gut = "»", jut = "⥵", zut = "⇥", Yut = "⤠", Wut = "⤳", Jut = "→", Xut = "↠", Zut = "⇒", Qut = "⤞", Kut = "↪", tpt = "↬", ept = "⥅", npt = "⥴", rpt = "⤖", opt = "↣", spt = "↝", cpt = "⤚", ipt = "⤜", apt = "∶", lpt = "ℚ", upt = "⤍", ppt = "⤏", fpt = "⤐", dpt = "❳", hpt = "}", gpt = "]", $pt = "⦌", mpt = "⦎", bpt = "⦐", ypt = "Ř", vpt = "ř", wpt = "Ŗ", _pt = "ŗ", Ept = "⌉", xpt = "}", qpt = "Р", Spt = "р", Tpt = "⤷", Apt = "⥩", kpt = "”", Dpt = "”", Lpt = "↳", Cpt = "ℜ", Npt = "ℛ", Rpt = "ℜ", Ipt = "ℝ", Bpt = "ℜ", Opt = "▭", Upt = "®", Ppt = "®", Fpt = "∋", Vpt = "⇋", Mpt = "⥯", Hpt = "⥽", Gpt = "⌋", jpt = "𝔯", zpt = "ℜ", Ypt = "⥤", Wpt = "⇁", Jpt = "⇀", Xpt = "⥬", Zpt = "Ρ", Qpt = "ρ", Kpt = "ϱ", tft = "⟩", eft = "⇥", nft = "→", rft = "→", oft = "⇒", sft = "⇄", cft = "↣", ift = "⌉", aft = "⟧", lft = "⥝", uft = "⥕", pft = "⇂", fft = "⌋", dft = "⇁", hft = "⇀", gft = "⇄", $ft = "⇌", mft = "⇉", bft = "↝", yft = "↦", vft = "⊢", wft = "⥛", _ft = "⋌", Eft = "⧐", xft = "⊳", qft = "⊵", Sft = "⥏", Tft = "⥜", Aft = "⥔", kft = "↾", Dft = "⥓", Lft = "⇀", Cft = "˚", Nft = "≓", Rft = "⇄", Ift = "⇌", Bft = "‏", Oft = "⎱", Uft = "⎱", Pft = "⫮", Fft = "⟭", Vft = "⇾", Mft = "⟧", Hft = "⦆", Gft = "𝕣", jft = "ℝ", zft = "⨮", Yft = "⨵", Wft = "⥰", Jft = ")", Xft = "⦔", Zft = "⨒", Qft = "⇉", Kft = "⇛", tdt = "›", edt = "𝓇", ndt = "ℛ", rdt = "↱", odt = "↱", sdt = "]", cdt = "’", idt = "’", adt = "⋌", ldt = "⋊", udt = "▹", pdt = "⊵", fdt = "▸", ddt = "⧎", hdt = "⧴", gdt = "⥨", $dt = "℞", mdt = "Ś", bdt = "ś", ydt = "‚", vdt = "⪸", wdt = "Š", _dt = "š", Edt = "⪼", xdt = "≻", qdt = "≽", Sdt = "⪰", Tdt = "⪴", Adt = "Ş", kdt = "ş", Ddt = "Ŝ", Ldt = "ŝ", Cdt = "⪺", Ndt = "⪶", Rdt = "⋩", Idt = "⨓", Bdt = "≿", Odt = "С", Udt = "с", Pdt = "⊡", Fdt = "⋅", Vdt = "⩦", Mdt = "⤥", Hdt = "↘", Gdt = "⇘", jdt = "↘", zdt = "§", Ydt = ";", Wdt = "⤩", Jdt = "∖", Xdt = "∖", Zdt = "✶", Qdt = "𝔖", Kdt = "𝔰", tht = "⌢", eht = "♯", nht = "Щ", rht = "щ", oht = "Ш", sht = "ш", cht = "↓", iht = "←", aht = "∣", lht = "∥", uht = "→", pht = "↑", fht = "­", dht = "Σ", hht = "σ", ght = "ς", $ht = "ς", mht = "∼", bht = "⩪", yht = "≃", vht = "≃", wht = "⪞", _ht = "⪠", Eht = "⪝", xht = "⪟", qht = "≆", Sht = "⨤", Tht = "⥲", Aht = "←", kht = "∘", Dht = "∖", Lht = "⨳", Cht = "⧤", Nht = "∣", Rht = "⌣", Iht = "⪪", Bht = "⪬", Oht = "⪬︀", Uht = "Ь", Pht = "ь", Fht = "⌿", Vht = "⧄", Mht = "/", Hht = "𝕊", Ght = "𝕤", jht = "♠", zht = "♠", Yht = "∥", Wht = "⊓", Jht = "⊓︀", Xht = "⊔", Zht = "⊔︀", Qht = "√", Kht = "⊏", t1t = "⊑", e1t = "⊏", n1t = "⊑", r1t = "⊐", o1t = "⊒", s1t = "⊐", c1t = "⊒", i1t = "□", a1t = "□", l1t = "⊓", u1t = "⊏", p1t = "⊑", f1t = "⊐", d1t = "⊒", h1t = "⊔", g1t = "▪", $1t = "□", m1t = "▪", b1t = "→", y1t = "𝒮", v1t = "𝓈", w1t = "∖", _1t = "⌣", E1t = "⋆", x1t = "⋆", q1t = "☆", S1t = "★", T1t = "ϵ", A1t = "ϕ", k1t = "¯", D1t = "⊂", L1t = "⋐", C1t = "⪽", N1t = "⫅", R1t = "⊆", I1t = "⫃", B1t = "⫁", O1t = "⫋", U1t = "⊊", P1t = "⪿", F1t = "⥹", V1t = "⊂", M1t = "⋐", H1t = "⊆", G1t = "⫅", j1t = "⊆", z1t = "⊊", Y1t = "⫋", W1t = "⫇", J1t = "⫕", X1t = "⫓", Z1t = "⪸", Q1t = "≻", K1t = "≽", tgt = "≻", egt = "⪰", ngt = "≽", rgt = "≿", ogt = "⪰", sgt = "⪺", cgt = "⪶", igt = "⋩", agt = "≿", lgt = "∋", ugt = "∑", pgt = "∑", fgt = "♪", dgt = "¹", hgt = "²", ggt = "³", $gt = "⊃", mgt = "⋑", bgt = "⪾", ygt = "⫘", vgt = "⫆", wgt = "⊇", _gt = "⫄", Egt = "⊃", xgt = "⊇", qgt = "⟉", Sgt = "⫗", Tgt = "⥻", Agt = "⫂", kgt = "⫌", Dgt = "⊋", Lgt = "⫀", Cgt = "⊃", Ngt = "⋑", Rgt = "⊇", Igt = "⫆", Bgt = "⊋", Ogt = "⫌", Ugt = "⫈", Pgt = "⫔", Fgt = "⫖", Vgt = "⤦", Mgt = "↙", Hgt = "⇙", Ggt = "↙", jgt = "⤪", zgt = "ß", Ygt = "	", Wgt = "⌖", Jgt = "Τ", Xgt = "τ", Zgt = "⎴", Qgt = "Ť", Kgt = "ť", t$t = "Ţ", e$t = "ţ", n$t = "Т", r$t = "т", o$t = "⃛", s$t = "⌕", c$t = "𝔗", i$t = "𝔱", a$t = "∴", l$t = "∴", u$t = "∴", p$t = "Θ", f$t = "θ", d$t = "ϑ", h$t = "ϑ", g$t = "≈", $$t = "∼", m$t = "  ", b$t = " ", y$t = " ", v$t = "≈", w$t = "∼", _$t = "Þ", E$t = "þ", x$t = "˜", q$t = "∼", S$t = "≃", T$t = "≅", A$t = "≈", k$t = "⨱", D$t = "⊠", L$t = "×", C$t = "⨰", N$t = "∭", R$t = "⤨", I$t = "⌶", B$t = "⫱", O$t = "⊤", U$t = "𝕋", P$t = "𝕥", F$t = "⫚", V$t = "⤩", M$t = "‴", H$t = "™", G$t = "™", j$t = "▵", z$t = "▿", Y$t = "◃", W$t = "⊴", J$t = "≜", X$t = "▹", Z$t = "⊵", Q$t = "◬", K$t = "≜", tmt = "⨺", emt = "⃛", nmt = "⨹", rmt = "⧍", omt = "⨻", smt = "⏢", cmt = "𝒯", imt = "𝓉", amt = "Ц", lmt = "ц", umt = "Ћ", pmt = "ћ", fmt = "Ŧ", dmt = "ŧ", hmt = "≬", gmt = "↞", $mt = "↠", mmt = "Ú", bmt = "ú", ymt = "↑", vmt = "↟", wmt = "⇑", _mt = "⥉", Emt = "Ў", xmt = "ў", qmt = "Ŭ", Smt = "ŭ", Tmt = "Û", Amt = "û", kmt = "У", Dmt = "у", Lmt = "⇅", Cmt = "Ű", Nmt = "ű", Rmt = "⥮", Imt = "⥾", Bmt = "𝔘", Omt = "𝔲", Umt = "Ù", Pmt = "ù", Fmt = "⥣", Vmt = "↿", Mmt = "↾", Hmt = "▀", Gmt = "⌜", jmt = "⌜", zmt = "⌏", Ymt = "◸", Wmt = "Ū", Jmt = "ū", Xmt = "¨", Zmt = "_", Qmt = "⏟", Kmt = "⎵", tbt = "⏝", ebt = "⋃", nbt = "⊎", rbt = "Ų", obt = "ų", sbt = "𝕌", cbt = "𝕦", ibt = "⤒", abt = "↑", lbt = "↑", ubt = "⇑", pbt = "⇅", fbt = "↕", dbt = "↕", hbt = "⇕", gbt = "⥮", $bt = "↿", mbt = "↾", bbt = "⊎", ybt = "↖", vbt = "↗", wbt = "υ", _bt = "ϒ", Ebt = "ϒ", xbt = "Υ", qbt = "υ", Sbt = "↥", Tbt = "⊥", Abt = "⇈", kbt = "⌝", Dbt = "⌝", Lbt = "⌎", Cbt = "Ů", Nbt = "ů", Rbt = "◹", Ibt = "𝒰", Bbt = "𝓊", Obt = "⋰", Ubt = "Ũ", Pbt = "ũ", Fbt = "▵", Vbt = "▴", Mbt = "⇈", Hbt = "Ü", Gbt = "ü", jbt = "⦧", zbt = "⦜", Ybt = "ϵ", Wbt = "ϰ", Jbt = "∅", Xbt = "ϕ", Zbt = "ϖ", Qbt = "∝", Kbt = "↕", tyt = "⇕", eyt = "ϱ", nyt = "ς", ryt = "⊊︀", oyt = "⫋︀", syt = "⊋︀", cyt = "⫌︀", iyt = "ϑ", ayt = "⊲", lyt = "⊳", uyt = "⫨", pyt = "⫫", fyt = "⫩", dyt = "В", hyt = "в", gyt = "⊢", $yt = "⊨", myt = "⊩", byt = "⊫", yyt = "⫦", vyt = "⊻", wyt = "∨", _yt = "⋁", Eyt = "≚", xyt = "⋮", qyt = "|", Syt = "‖", Tyt = "|", Ayt = "‖", kyt = "∣", Dyt = "|", Lyt = "❘", Cyt = "≀", Nyt = " ", Ryt = "𝔙", Iyt = "𝔳", Byt = "⊲", Oyt = "⊂⃒", Uyt = "⊃⃒", Pyt = "𝕍", Fyt = "𝕧", Vyt = "∝", Myt = "⊳", Hyt = "𝒱", Gyt = "𝓋", jyt = "⫋︀", zyt = "⊊︀", Yyt = "⫌︀", Wyt = "⊋︀", Jyt = "⊪", Xyt = "⦚", Zyt = "Ŵ", Qyt = "ŵ", Kyt = "⩟", tvt = "∧", evt = "⋀", nvt = "≙", rvt = "℘", ovt = "𝔚", svt = "𝔴", cvt = "𝕎", ivt = "𝕨", avt = "℘", lvt = "≀", uvt = "≀", pvt = "𝒲", fvt = "𝓌", dvt = "⋂", hvt = "◯", gvt = "⋃", $vt = "▽", mvt = "𝔛", bvt = "𝔵", yvt = "⟷", vvt = "⟺", wvt = "Ξ", _vt = "ξ", Evt = "⟵", xvt = "⟸", qvt = "⟼", Svt = "⋻", Tvt = "⨀", Avt = "𝕏", kvt = "𝕩", Dvt = "⨁", Lvt = "⨂", Cvt = "⟶", Nvt = "⟹", Rvt = "𝒳", Ivt = "𝓍", Bvt = "⨆", Ovt = "⨄", Uvt = "△", Pvt = "⋁", Fvt = "⋀", Vvt = "Ý", Mvt = "ý", Hvt = "Я", Gvt = "я", jvt = "Ŷ", zvt = "ŷ", Yvt = "Ы", Wvt = "ы", Jvt = "¥", Xvt = "𝔜", Zvt = "𝔶", Qvt = "Ї", Kvt = "ї", twt = "𝕐", ewt = "𝕪", nwt = "𝒴", rwt = "𝓎", owt = "Ю", swt = "ю", cwt = "ÿ", iwt = "Ÿ", awt = "Ź", lwt = "ź", uwt = "Ž", pwt = "ž", fwt = "З", dwt = "з", hwt = "Ż", gwt = "ż", $wt = "ℨ", mwt = "​", bwt = "Ζ", ywt = "ζ", vwt = "𝔷", wwt = "ℨ", _wt = "Ж", Ewt = "ж", xwt = "⇝", qwt = "𝕫", Swt = "ℤ", Twt = "𝒵", Awt = "𝓏", kwt = "‍", Dwt = "‌", Po = {
  Aacute: fH,
  aacute: dH,
  Abreve: hH,
  abreve: gH,
  ac: $H,
  acd: mH,
  acE: bH,
  Acirc: yH,
  acirc: vH,
  acute: wH,
  Acy: _H,
  acy: EH,
  AElig: xH,
  aelig: qH,
  af: SH,
  Afr: TH,
  afr: AH,
  Agrave: kH,
  agrave: DH,
  alefsym: LH,
  aleph: CH,
  Alpha: NH,
  alpha: RH,
  Amacr: IH,
  amacr: BH,
  amalg: OH,
  amp: UH,
  AMP: PH,
  andand: FH,
  And: VH,
  and: MH,
  andd: HH,
  andslope: GH,
  andv: jH,
  ang: zH,
  ange: YH,
  angle: WH,
  angmsdaa: JH,
  angmsdab: XH,
  angmsdac: ZH,
  angmsdad: QH,
  angmsdae: KH,
  angmsdaf: t8,
  angmsdag: e8,
  angmsdah: n8,
  angmsd: r8,
  angrt: o8,
  angrtvb: s8,
  angrtvbd: c8,
  angsph: i8,
  angst: a8,
  angzarr: l8,
  Aogon: u8,
  aogon: p8,
  Aopf: f8,
  aopf: d8,
  apacir: h8,
  ap: g8,
  apE: $8,
  ape: m8,
  apid: b8,
  apos: y8,
  ApplyFunction: v8,
  approx: w8,
  approxeq: _8,
  Aring: E8,
  aring: x8,
  Ascr: q8,
  ascr: S8,
  Assign: T8,
  ast: A8,
  asymp: k8,
  asympeq: D8,
  Atilde: L8,
  atilde: C8,
  Auml: N8,
  auml: R8,
  awconint: I8,
  awint: B8,
  backcong: O8,
  backepsilon: U8,
  backprime: P8,
  backsim: F8,
  backsimeq: V8,
  Backslash: M8,
  Barv: H8,
  barvee: G8,
  barwed: j8,
  Barwed: z8,
  barwedge: Y8,
  bbrk: W8,
  bbrktbrk: J8,
  bcong: X8,
  Bcy: Z8,
  bcy: Q8,
  bdquo: K8,
  becaus: t4,
  because: e4,
  Because: n4,
  bemptyv: r4,
  bepsi: o4,
  bernou: s4,
  Bernoullis: c4,
  Beta: i4,
  beta: a4,
  beth: l4,
  between: u4,
  Bfr: p4,
  bfr: f4,
  bigcap: d4,
  bigcirc: h4,
  bigcup: g4,
  bigodot: $4,
  bigoplus: m4,
  bigotimes: b4,
  bigsqcup: y4,
  bigstar: v4,
  bigtriangledown: w4,
  bigtriangleup: _4,
  biguplus: E4,
  bigvee: x4,
  bigwedge: q4,
  bkarow: S4,
  blacklozenge: T4,
  blacksquare: A4,
  blacktriangle: k4,
  blacktriangledown: D4,
  blacktriangleleft: L4,
  blacktriangleright: C4,
  blank: N4,
  blk12: R4,
  blk14: I4,
  blk34: B4,
  block: O4,
  bne: U4,
  bnequiv: P4,
  bNot: F4,
  bnot: V4,
  Bopf: M4,
  bopf: H4,
  bot: G4,
  bottom: j4,
  bowtie: z4,
  boxbox: Y4,
  boxdl: W4,
  boxdL: J4,
  boxDl: X4,
  boxDL: Z4,
  boxdr: Q4,
  boxdR: K4,
  boxDr: tG,
  boxDR: eG,
  boxh: nG,
  boxH: rG,
  boxhd: oG,
  boxHd: sG,
  boxhD: cG,
  boxHD: iG,
  boxhu: aG,
  boxHu: lG,
  boxhU: uG,
  boxHU: pG,
  boxminus: fG,
  boxplus: dG,
  boxtimes: hG,
  boxul: gG,
  boxuL: $G,
  boxUl: mG,
  boxUL: bG,
  boxur: yG,
  boxuR: vG,
  boxUr: wG,
  boxUR: _G,
  boxv: EG,
  boxV: xG,
  boxvh: qG,
  boxvH: SG,
  boxVh: TG,
  boxVH: AG,
  boxvl: kG,
  boxvL: DG,
  boxVl: LG,
  boxVL: CG,
  boxvr: NG,
  boxvR: RG,
  boxVr: IG,
  boxVR: BG,
  bprime: OG,
  breve: UG,
  Breve: PG,
  brvbar: FG,
  bscr: VG,
  Bscr: MG,
  bsemi: HG,
  bsim: GG,
  bsime: jG,
  bsolb: zG,
  bsol: YG,
  bsolhsub: WG,
  bull: JG,
  bullet: XG,
  bump: ZG,
  bumpE: QG,
  bumpe: KG,
  Bumpeq: tj,
  bumpeq: ej,
  Cacute: nj,
  cacute: rj,
  capand: oj,
  capbrcup: sj,
  capcap: cj,
  cap: ij,
  Cap: aj,
  capcup: lj,
  capdot: uj,
  CapitalDifferentialD: pj,
  caps: fj,
  caret: dj,
  caron: hj,
  Cayleys: gj,
  ccaps: $j,
  Ccaron: mj,
  ccaron: bj,
  Ccedil: yj,
  ccedil: vj,
  Ccirc: wj,
  ccirc: _j,
  Cconint: Ej,
  ccups: xj,
  ccupssm: qj,
  Cdot: Sj,
  cdot: Tj,
  cedil: Aj,
  Cedilla: kj,
  cemptyv: Dj,
  cent: Lj,
  centerdot: Cj,
  CenterDot: Nj,
  cfr: Rj,
  Cfr: Ij,
  CHcy: Bj,
  chcy: Oj,
  check: Uj,
  checkmark: Pj,
  Chi: Fj,
  chi: Vj,
  circ: Mj,
  circeq: Hj,
  circlearrowleft: Gj,
  circlearrowright: jj,
  circledast: zj,
  circledcirc: Yj,
  circleddash: Wj,
  CircleDot: Jj,
  circledR: Xj,
  circledS: Zj,
  CircleMinus: Qj,
  CirclePlus: Kj,
  CircleTimes: t5,
  cir: e5,
  cirE: n5,
  cire: r5,
  cirfnint: o5,
  cirmid: s5,
  cirscir: c5,
  ClockwiseContourIntegral: i5,
  CloseCurlyDoubleQuote: a5,
  CloseCurlyQuote: l5,
  clubs: u5,
  clubsuit: p5,
  colon: f5,
  Colon: d5,
  Colone: h5,
  colone: g5,
  coloneq: $5,
  comma: m5,
  commat: b5,
  comp: y5,
  compfn: v5,
  complement: w5,
  complexes: _5,
  cong: E5,
  congdot: x5,
  Congruent: q5,
  conint: S5,
  Conint: T5,
  ContourIntegral: A5,
  copf: k5,
  Copf: D5,
  coprod: L5,
  Coproduct: C5,
  copy: N5,
  COPY: R5,
  copysr: I5,
  CounterClockwiseContourIntegral: B5,
  crarr: O5,
  cross: U5,
  Cross: P5,
  Cscr: F5,
  cscr: V5,
  csub: M5,
  csube: H5,
  csup: G5,
  csupe: j5,
  ctdot: z5,
  cudarrl: Y5,
  cudarrr: W5,
  cuepr: J5,
  cuesc: X5,
  cularr: Z5,
  cularrp: Q5,
  cupbrcap: K5,
  cupcap: t6,
  CupCap: e6,
  cup: n6,
  Cup: r6,
  cupcup: o6,
  cupdot: s6,
  cupor: c6,
  cups: i6,
  curarr: a6,
  curarrm: l6,
  curlyeqprec: u6,
  curlyeqsucc: p6,
  curlyvee: f6,
  curlywedge: d6,
  curren: h6,
  curvearrowleft: g6,
  curvearrowright: $6,
  cuvee: m6,
  cuwed: b6,
  cwconint: y6,
  cwint: v6,
  cylcty: w6,
  dagger: _6,
  Dagger: E6,
  daleth: x6,
  darr: q6,
  Darr: S6,
  dArr: T6,
  dash: A6,
  Dashv: k6,
  dashv: D6,
  dbkarow: L6,
  dblac: C6,
  Dcaron: N6,
  dcaron: R6,
  Dcy: I6,
  dcy: B6,
  ddagger: O6,
  ddarr: U6,
  DD: P6,
  dd: F6,
  DDotrahd: V6,
  ddotseq: M6,
  deg: H6,
  Del: G6,
  Delta: j6,
  delta: z6,
  demptyv: Y6,
  dfisht: W6,
  Dfr: J6,
  dfr: X6,
  dHar: Z6,
  dharl: Q6,
  dharr: K6,
  DiacriticalAcute: tz,
  DiacriticalDot: ez,
  DiacriticalDoubleAcute: nz,
  DiacriticalGrave: rz,
  DiacriticalTilde: oz,
  diam: sz,
  diamond: cz,
  Diamond: iz,
  diamondsuit: az,
  diams: lz,
  die: uz,
  DifferentialD: pz,
  digamma: fz,
  disin: dz,
  div: hz,
  divide: gz,
  divideontimes: $z,
  divonx: mz,
  DJcy: bz,
  djcy: yz,
  dlcorn: vz,
  dlcrop: wz,
  dollar: _z,
  Dopf: Ez,
  dopf: xz,
  Dot: qz,
  dot: Sz,
  DotDot: Tz,
  doteq: Az,
  doteqdot: kz,
  DotEqual: Dz,
  dotminus: Lz,
  dotplus: Cz,
  dotsquare: Nz,
  doublebarwedge: Rz,
  DoubleContourIntegral: Iz,
  DoubleDot: Bz,
  DoubleDownArrow: Oz,
  DoubleLeftArrow: Uz,
  DoubleLeftRightArrow: Pz,
  DoubleLeftTee: Fz,
  DoubleLongLeftArrow: Vz,
  DoubleLongLeftRightArrow: Mz,
  DoubleLongRightArrow: Hz,
  DoubleRightArrow: Gz,
  DoubleRightTee: jz,
  DoubleUpArrow: zz,
  DoubleUpDownArrow: Yz,
  DoubleVerticalBar: Wz,
  DownArrowBar: Jz,
  downarrow: Xz,
  DownArrow: Zz,
  Downarrow: Qz,
  DownArrowUpArrow: Kz,
  DownBreve: tY,
  downdownarrows: eY,
  downharpoonleft: nY,
  downharpoonright: rY,
  DownLeftRightVector: oY,
  DownLeftTeeVector: sY,
  DownLeftVectorBar: cY,
  DownLeftVector: iY,
  DownRightTeeVector: aY,
  DownRightVectorBar: lY,
  DownRightVector: uY,
  DownTeeArrow: pY,
  DownTee: fY,
  drbkarow: dY,
  drcorn: hY,
  drcrop: gY,
  Dscr: $Y,
  dscr: mY,
  DScy: bY,
  dscy: yY,
  dsol: vY,
  Dstrok: wY,
  dstrok: _Y,
  dtdot: EY,
  dtri: xY,
  dtrif: qY,
  duarr: SY,
  duhar: TY,
  dwangle: AY,
  DZcy: kY,
  dzcy: DY,
  dzigrarr: LY,
  Eacute: CY,
  eacute: NY,
  easter: RY,
  Ecaron: IY,
  ecaron: BY,
  Ecirc: OY,
  ecirc: UY,
  ecir: PY,
  ecolon: FY,
  Ecy: VY,
  ecy: MY,
  eDDot: HY,
  Edot: GY,
  edot: jY,
  eDot: zY,
  ee: YY,
  efDot: WY,
  Efr: JY,
  efr: XY,
  eg: ZY,
  Egrave: QY,
  egrave: KY,
  egs: t7,
  egsdot: e7,
  el: n7,
  Element: r7,
  elinters: o7,
  ell: s7,
  els: c7,
  elsdot: i7,
  Emacr: a7,
  emacr: l7,
  empty: u7,
  emptyset: p7,
  EmptySmallSquare: f7,
  emptyv: d7,
  EmptyVerySmallSquare: h7,
  emsp13: g7,
  emsp14: $7,
  emsp: m7,
  ENG: b7,
  eng: y7,
  ensp: v7,
  Eogon: w7,
  eogon: _7,
  Eopf: E7,
  eopf: x7,
  epar: q7,
  eparsl: S7,
  eplus: T7,
  epsi: A7,
  Epsilon: k7,
  epsilon: D7,
  epsiv: L7,
  eqcirc: C7,
  eqcolon: N7,
  eqsim: R7,
  eqslantgtr: I7,
  eqslantless: B7,
  Equal: O7,
  equals: U7,
  EqualTilde: P7,
  equest: F7,
  Equilibrium: V7,
  equiv: M7,
  equivDD: H7,
  eqvparsl: G7,
  erarr: j7,
  erDot: z7,
  escr: Y7,
  Escr: W7,
  esdot: J7,
  Esim: X7,
  esim: Z7,
  Eta: Q7,
  eta: K7,
  ETH: t9,
  eth: e9,
  Euml: n9,
  euml: r9,
  euro: o9,
  excl: s9,
  exist: c9,
  Exists: i9,
  expectation: a9,
  exponentiale: l9,
  ExponentialE: u9,
  fallingdotseq: p9,
  Fcy: f9,
  fcy: d9,
  female: h9,
  ffilig: g9,
  fflig: $9,
  ffllig: m9,
  Ffr: b9,
  ffr: y9,
  filig: v9,
  FilledSmallSquare: w9,
  FilledVerySmallSquare: _9,
  fjlig: E9,
  flat: x9,
  fllig: q9,
  fltns: S9,
  fnof: T9,
  Fopf: A9,
  fopf: k9,
  forall: D9,
  ForAll: L9,
  fork: C9,
  forkv: N9,
  Fouriertrf: R9,
  fpartint: I9,
  frac12: B9,
  frac13: O9,
  frac14: U9,
  frac15: P9,
  frac16: F9,
  frac18: V9,
  frac23: M9,
  frac25: H9,
  frac34: G9,
  frac35: j9,
  frac38: z9,
  frac45: Y9,
  frac56: W9,
  frac58: J9,
  frac78: X9,
  frasl: Z9,
  frown: Q9,
  fscr: K9,
  Fscr: tW,
  gacute: eW,
  Gamma: nW,
  gamma: rW,
  Gammad: oW,
  gammad: sW,
  gap: cW,
  Gbreve: iW,
  gbreve: aW,
  Gcedil: lW,
  Gcirc: uW,
  gcirc: pW,
  Gcy: fW,
  gcy: dW,
  Gdot: hW,
  gdot: gW,
  ge: $W,
  gE: mW,
  gEl: bW,
  gel: yW,
  geq: vW,
  geqq: wW,
  geqslant: _W,
  gescc: EW,
  ges: xW,
  gesdot: qW,
  gesdoto: SW,
  gesdotol: TW,
  gesl: AW,
  gesles: kW,
  Gfr: DW,
  gfr: LW,
  gg: CW,
  Gg: NW,
  ggg: RW,
  gimel: IW,
  GJcy: BW,
  gjcy: OW,
  gla: UW,
  gl: PW,
  glE: FW,
  glj: VW,
  gnap: MW,
  gnapprox: HW,
  gne: GW,
  gnE: jW,
  gneq: zW,
  gneqq: YW,
  gnsim: WW,
  Gopf: JW,
  gopf: XW,
  grave: ZW,
  GreaterEqual: QW,
  GreaterEqualLess: KW,
  GreaterFullEqual: tJ,
  GreaterGreater: eJ,
  GreaterLess: nJ,
  GreaterSlantEqual: rJ,
  GreaterTilde: oJ,
  Gscr: sJ,
  gscr: cJ,
  gsim: iJ,
  gsime: aJ,
  gsiml: lJ,
  gtcc: uJ,
  gtcir: pJ,
  gt: fJ,
  GT: dJ,
  Gt: hJ,
  gtdot: gJ,
  gtlPar: $J,
  gtquest: mJ,
  gtrapprox: bJ,
  gtrarr: yJ,
  gtrdot: vJ,
  gtreqless: wJ,
  gtreqqless: _J,
  gtrless: EJ,
  gtrsim: xJ,
  gvertneqq: qJ,
  gvnE: SJ,
  Hacek: TJ,
  hairsp: AJ,
  half: kJ,
  hamilt: DJ,
  HARDcy: LJ,
  hardcy: CJ,
  harrcir: NJ,
  harr: RJ,
  hArr: IJ,
  harrw: BJ,
  Hat: OJ,
  hbar: UJ,
  Hcirc: PJ,
  hcirc: FJ,
  hearts: VJ,
  heartsuit: MJ,
  hellip: HJ,
  hercon: GJ,
  hfr: jJ,
  Hfr: zJ,
  HilbertSpace: YJ,
  hksearow: WJ,
  hkswarow: JJ,
  hoarr: XJ,
  homtht: ZJ,
  hookleftarrow: QJ,
  hookrightarrow: KJ,
  hopf: tX,
  Hopf: eX,
  horbar: nX,
  HorizontalLine: rX,
  hscr: oX,
  Hscr: sX,
  hslash: cX,
  Hstrok: iX,
  hstrok: aX,
  HumpDownHump: lX,
  HumpEqual: uX,
  hybull: pX,
  hyphen: fX,
  Iacute: dX,
  iacute: hX,
  ic: gX,
  Icirc: $X,
  icirc: mX,
  Icy: bX,
  icy: yX,
  Idot: vX,
  IEcy: wX,
  iecy: _X,
  iexcl: EX,
  iff: xX,
  ifr: qX,
  Ifr: SX,
  Igrave: TX,
  igrave: AX,
  ii: kX,
  iiiint: DX,
  iiint: LX,
  iinfin: CX,
  iiota: NX,
  IJlig: RX,
  ijlig: IX,
  Imacr: BX,
  imacr: OX,
  image: UX,
  ImaginaryI: PX,
  imagline: FX,
  imagpart: VX,
  imath: MX,
  Im: HX,
  imof: GX,
  imped: jX,
  Implies: zX,
  incare: YX,
  in: "∈",
  infin: WX,
  infintie: JX,
  inodot: XX,
  intcal: ZX,
  int: QX,
  Int: KX,
  integers: tZ,
  Integral: eZ,
  intercal: nZ,
  Intersection: rZ,
  intlarhk: oZ,
  intprod: sZ,
  InvisibleComma: cZ,
  InvisibleTimes: iZ,
  IOcy: aZ,
  iocy: lZ,
  Iogon: uZ,
  iogon: pZ,
  Iopf: fZ,
  iopf: dZ,
  Iota: hZ,
  iota: gZ,
  iprod: $Z,
  iquest: mZ,
  iscr: bZ,
  Iscr: yZ,
  isin: vZ,
  isindot: wZ,
  isinE: _Z,
  isins: EZ,
  isinsv: xZ,
  isinv: qZ,
  it: SZ,
  Itilde: TZ,
  itilde: AZ,
  Iukcy: kZ,
  iukcy: DZ,
  Iuml: LZ,
  iuml: CZ,
  Jcirc: NZ,
  jcirc: RZ,
  Jcy: IZ,
  jcy: BZ,
  Jfr: OZ,
  jfr: UZ,
  jmath: PZ,
  Jopf: FZ,
  jopf: VZ,
  Jscr: MZ,
  jscr: HZ,
  Jsercy: GZ,
  jsercy: jZ,
  Jukcy: zZ,
  jukcy: YZ,
  Kappa: WZ,
  kappa: JZ,
  kappav: XZ,
  Kcedil: ZZ,
  kcedil: QZ,
  Kcy: KZ,
  kcy: tQ,
  Kfr: eQ,
  kfr: nQ,
  kgreen: rQ,
  KHcy: oQ,
  khcy: sQ,
  KJcy: cQ,
  kjcy: iQ,
  Kopf: aQ,
  kopf: lQ,
  Kscr: uQ,
  kscr: pQ,
  lAarr: fQ,
  Lacute: dQ,
  lacute: hQ,
  laemptyv: gQ,
  lagran: $Q,
  Lambda: mQ,
  lambda: bQ,
  lang: yQ,
  Lang: vQ,
  langd: wQ,
  langle: _Q,
  lap: EQ,
  Laplacetrf: xQ,
  laquo: qQ,
  larrb: SQ,
  larrbfs: TQ,
  larr: AQ,
  Larr: kQ,
  lArr: DQ,
  larrfs: LQ,
  larrhk: CQ,
  larrlp: NQ,
  larrpl: RQ,
  larrsim: IQ,
  larrtl: BQ,
  latail: OQ,
  lAtail: UQ,
  lat: PQ,
  late: FQ,
  lates: VQ,
  lbarr: MQ,
  lBarr: HQ,
  lbbrk: GQ,
  lbrace: jQ,
  lbrack: zQ,
  lbrke: YQ,
  lbrksld: WQ,
  lbrkslu: JQ,
  Lcaron: XQ,
  lcaron: ZQ,
  Lcedil: QQ,
  lcedil: KQ,
  lceil: tK,
  lcub: eK,
  Lcy: nK,
  lcy: rK,
  ldca: oK,
  ldquo: sK,
  ldquor: cK,
  ldrdhar: iK,
  ldrushar: aK,
  ldsh: lK,
  le: uK,
  lE: pK,
  LeftAngleBracket: fK,
  LeftArrowBar: dK,
  leftarrow: hK,
  LeftArrow: gK,
  Leftarrow: $K,
  LeftArrowRightArrow: mK,
  leftarrowtail: bK,
  LeftCeiling: yK,
  LeftDoubleBracket: vK,
  LeftDownTeeVector: wK,
  LeftDownVectorBar: _K,
  LeftDownVector: EK,
  LeftFloor: xK,
  leftharpoondown: qK,
  leftharpoonup: SK,
  leftleftarrows: TK,
  leftrightarrow: AK,
  LeftRightArrow: kK,
  Leftrightarrow: DK,
  leftrightarrows: LK,
  leftrightharpoons: CK,
  leftrightsquigarrow: NK,
  LeftRightVector: RK,
  LeftTeeArrow: IK,
  LeftTee: BK,
  LeftTeeVector: OK,
  leftthreetimes: UK,
  LeftTriangleBar: PK,
  LeftTriangle: FK,
  LeftTriangleEqual: VK,
  LeftUpDownVector: MK,
  LeftUpTeeVector: HK,
  LeftUpVectorBar: GK,
  LeftUpVector: jK,
  LeftVectorBar: zK,
  LeftVector: YK,
  lEg: WK,
  leg: JK,
  leq: XK,
  leqq: ZK,
  leqslant: QK,
  lescc: KK,
  les: ttt,
  lesdot: ett,
  lesdoto: ntt,
  lesdotor: rtt,
  lesg: ott,
  lesges: stt,
  lessapprox: ctt,
  lessdot: itt,
  lesseqgtr: att,
  lesseqqgtr: ltt,
  LessEqualGreater: utt,
  LessFullEqual: ptt,
  LessGreater: ftt,
  lessgtr: dtt,
  LessLess: htt,
  lesssim: gtt,
  LessSlantEqual: $tt,
  LessTilde: mtt,
  lfisht: btt,
  lfloor: ytt,
  Lfr: vtt,
  lfr: wtt,
  lg: _tt,
  lgE: Ett,
  lHar: xtt,
  lhard: qtt,
  lharu: Stt,
  lharul: Ttt,
  lhblk: Att,
  LJcy: ktt,
  ljcy: Dtt,
  llarr: Ltt,
  ll: Ctt,
  Ll: Ntt,
  llcorner: Rtt,
  Lleftarrow: Itt,
  llhard: Btt,
  lltri: Ott,
  Lmidot: Utt,
  lmidot: Ptt,
  lmoustache: Ftt,
  lmoust: Vtt,
  lnap: Mtt,
  lnapprox: Htt,
  lne: Gtt,
  lnE: jtt,
  lneq: ztt,
  lneqq: Ytt,
  lnsim: Wtt,
  loang: Jtt,
  loarr: Xtt,
  lobrk: Ztt,
  longleftarrow: Qtt,
  LongLeftArrow: Ktt,
  Longleftarrow: tet,
  longleftrightarrow: eet,
  LongLeftRightArrow: net,
  Longleftrightarrow: ret,
  longmapsto: oet,
  longrightarrow: set,
  LongRightArrow: cet,
  Longrightarrow: iet,
  looparrowleft: aet,
  looparrowright: uet,
  lopar: pet,
  Lopf: fet,
  lopf: det,
  loplus: het,
  lotimes: get,
  lowast: $et,
  lowbar: met,
  LowerLeftArrow: bet,
  LowerRightArrow: yet,
  loz: vet,
  lozenge: wet,
  lozf: _et,
  lpar: Eet,
  lparlt: xet,
  lrarr: qet,
  lrcorner: Tet,
  lrhar: Aet,
  lrhard: ket,
  lrm: Det,
  lrtri: Let,
  lsaquo: Cet,
  lscr: Net,
  Lscr: Ret,
  lsh: Iet,
  Lsh: Bet,
  lsim: Oet,
  lsime: Uet,
  lsimg: Pet,
  lsqb: Fet,
  lsquo: Vet,
  lsquor: Met,
  Lstrok: Het,
  lstrok: Get,
  ltcc: jet,
  ltcir: zet,
  lt: Yet,
  LT: Wet,
  Lt: Jet,
  ltdot: Xet,
  lthree: Zet,
  ltimes: Qet,
  ltlarr: Ket,
  ltquest: tnt,
  ltri: ent,
  ltrie: nnt,
  ltrif: rnt,
  ltrPar: ont,
  lurdshar: snt,
  luruhar: cnt,
  lvertneqq: int,
  lvnE: ant,
  macr: lnt,
  male: unt,
  malt: pnt,
  maltese: fnt,
  Map: "⤅",
  map: dnt,
  mapsto: hnt,
  mapstodown: gnt,
  mapstoleft: $nt,
  mapstoup: mnt,
  marker: bnt,
  mcomma: ynt,
  Mcy: vnt,
  mcy: wnt,
  mdash: _nt,
  mDDot: Ent,
  measuredangle: xnt,
  MediumSpace: qnt,
  Mellintrf: Snt,
  Mfr: Tnt,
  mfr: Ant,
  mho: knt,
  micro: Dnt,
  midast: Lnt,
  midcir: Cnt,
  mid: Nnt,
  middot: Rnt,
  minusb: Int,
  minus: Bnt,
  minusd: Ont,
  minusdu: Unt,
  MinusPlus: Pnt,
  mlcp: Fnt,
  mldr: Vnt,
  mnplus: Mnt,
  models: Hnt,
  Mopf: Gnt,
  mopf: jnt,
  mp: znt,
  mscr: Ynt,
  Mscr: Wnt,
  mstpos: Jnt,
  Mu: Xnt,
  mu: Znt,
  multimap: Qnt,
  mumap: Knt,
  nabla: trt,
  Nacute: ert,
  nacute: nrt,
  nang: rrt,
  nap: ort,
  napE: srt,
  napid: crt,
  napos: irt,
  napprox: art,
  natural: lrt,
  naturals: urt,
  natur: prt,
  nbsp: frt,
  nbump: drt,
  nbumpe: hrt,
  ncap: grt,
  Ncaron: $rt,
  ncaron: mrt,
  Ncedil: brt,
  ncedil: yrt,
  ncong: vrt,
  ncongdot: wrt,
  ncup: _rt,
  Ncy: Ert,
  ncy: xrt,
  ndash: qrt,
  nearhk: Srt,
  nearr: Trt,
  neArr: Art,
  nearrow: krt,
  ne: Drt,
  nedot: Lrt,
  NegativeMediumSpace: Crt,
  NegativeThickSpace: Nrt,
  NegativeThinSpace: Rrt,
  NegativeVeryThinSpace: Irt,
  nequiv: Brt,
  nesear: Ort,
  nesim: Urt,
  NestedGreaterGreater: Prt,
  NestedLessLess: Frt,
  NewLine: Vrt,
  nexist: Mrt,
  nexists: Hrt,
  Nfr: Grt,
  nfr: jrt,
  ngE: zrt,
  nge: Yrt,
  ngeq: Wrt,
  ngeqq: Jrt,
  ngeqslant: Xrt,
  nges: Zrt,
  nGg: Qrt,
  ngsim: Krt,
  nGt: tot,
  ngt: eot,
  ngtr: not,
  nGtv: rot,
  nharr: oot,
  nhArr: sot,
  nhpar: cot,
  ni: iot,
  nis: aot,
  nisd: lot,
  niv: uot,
  NJcy: pot,
  njcy: fot,
  nlarr: dot,
  nlArr: hot,
  nldr: got,
  nlE: $ot,
  nle: mot,
  nleftarrow: bot,
  nLeftarrow: yot,
  nleftrightarrow: vot,
  nLeftrightarrow: wot,
  nleq: _ot,
  nleqq: Eot,
  nleqslant: xot,
  nles: qot,
  nless: Sot,
  nLl: Tot,
  nlsim: Aot,
  nLt: kot,
  nlt: Dot,
  nltri: Lot,
  nltrie: Cot,
  nLtv: Not,
  nmid: Rot,
  NoBreak: Iot,
  NonBreakingSpace: Bot,
  nopf: Oot,
  Nopf: Uot,
  Not: Pot,
  not: Fot,
  NotCongruent: Vot,
  NotCupCap: Mot,
  NotDoubleVerticalBar: Hot,
  NotElement: Got,
  NotEqual: jot,
  NotEqualTilde: zot,
  NotExists: Yot,
  NotGreater: Wot,
  NotGreaterEqual: Jot,
  NotGreaterFullEqual: Xot,
  NotGreaterGreater: Zot,
  NotGreaterLess: Qot,
  NotGreaterSlantEqual: Kot,
  NotGreaterTilde: tst,
  NotHumpDownHump: est,
  NotHumpEqual: nst,
  notin: rst,
  notindot: ost,
  notinE: sst,
  notinva: cst,
  notinvb: ist,
  notinvc: ast,
  NotLeftTriangleBar: lst,
  NotLeftTriangle: ust,
  NotLeftTriangleEqual: pst,
  NotLess: fst,
  NotLessEqual: dst,
  NotLessGreater: hst,
  NotLessLess: gst,
  NotLessSlantEqual: $st,
  NotLessTilde: mst,
  NotNestedGreaterGreater: bst,
  NotNestedLessLess: yst,
  notni: vst,
  notniva: wst,
  notnivb: _st,
  notnivc: Est,
  NotPrecedes: xst,
  NotPrecedesEqual: qst,
  NotPrecedesSlantEqual: Sst,
  NotReverseElement: Tst,
  NotRightTriangleBar: Ast,
  NotRightTriangle: kst,
  NotRightTriangleEqual: Dst,
  NotSquareSubset: Lst,
  NotSquareSubsetEqual: Cst,
  NotSquareSuperset: Nst,
  NotSquareSupersetEqual: Rst,
  NotSubset: Ist,
  NotSubsetEqual: Bst,
  NotSucceeds: Ost,
  NotSucceedsEqual: Ust,
  NotSucceedsSlantEqual: Pst,
  NotSucceedsTilde: Fst,
  NotSuperset: Vst,
  NotSupersetEqual: Mst,
  NotTilde: Hst,
  NotTildeEqual: Gst,
  NotTildeFullEqual: jst,
  NotTildeTilde: zst,
  NotVerticalBar: Yst,
  nparallel: Wst,
  npar: Jst,
  nparsl: Xst,
  npart: Zst,
  npolint: Qst,
  npr: Kst,
  nprcue: tct,
  nprec: ect,
  npreceq: nct,
  npre: rct,
  nrarrc: oct,
  nrarr: sct,
  nrArr: cct,
  nrarrw: ict,
  nrightarrow: act,
  nRightarrow: lct,
  nrtri: uct,
  nrtrie: pct,
  nsc: fct,
  nsccue: dct,
  nsce: hct,
  Nscr: gct,
  nscr: $ct,
  nshortmid: mct,
  nshortparallel: bct,
  nsim: yct,
  nsime: vct,
  nsimeq: wct,
  nsmid: _ct,
  nspar: Ect,
  nsqsube: xct,
  nsqsupe: qct,
  nsub: Sct,
  nsubE: Tct,
  nsube: Act,
  nsubset: kct,
  nsubseteq: Dct,
  nsubseteqq: Lct,
  nsucc: Cct,
  nsucceq: Nct,
  nsup: Rct,
  nsupE: Ict,
  nsupe: Bct,
  nsupset: Oct,
  nsupseteq: Uct,
  nsupseteqq: Pct,
  ntgl: Fct,
  Ntilde: Vct,
  ntilde: Mct,
  ntlg: Hct,
  ntriangleleft: Gct,
  ntrianglelefteq: jct,
  ntriangleright: zct,
  ntrianglerighteq: Yct,
  Nu: Wct,
  nu: Jct,
  num: Xct,
  numero: Zct,
  numsp: Qct,
  nvap: Kct,
  nvdash: tit,
  nvDash: eit,
  nVdash: nit,
  nVDash: rit,
  nvge: oit,
  nvgt: sit,
  nvHarr: cit,
  nvinfin: iit,
  nvlArr: ait,
  nvle: lit,
  nvlt: uit,
  nvltrie: pit,
  nvrArr: fit,
  nvrtrie: dit,
  nvsim: hit,
  nwarhk: git,
  nwarr: $it,
  nwArr: mit,
  nwarrow: bit,
  nwnear: yit,
  Oacute: vit,
  oacute: wit,
  oast: _it,
  Ocirc: Eit,
  ocirc: xit,
  ocir: qit,
  Ocy: Sit,
  ocy: Tit,
  odash: Ait,
  Odblac: kit,
  odblac: Dit,
  odiv: Lit,
  odot: Cit,
  odsold: Nit,
  OElig: Rit,
  oelig: Iit,
  ofcir: Bit,
  Ofr: Oit,
  ofr: Uit,
  ogon: Pit,
  Ograve: Fit,
  ograve: Vit,
  ogt: Mit,
  ohbar: Hit,
  ohm: Git,
  oint: jit,
  olarr: zit,
  olcir: Yit,
  olcross: Wit,
  oline: Jit,
  olt: Xit,
  Omacr: Zit,
  omacr: Qit,
  Omega: Kit,
  omega: tat,
  Omicron: eat,
  omicron: nat,
  omid: rat,
  ominus: oat,
  Oopf: sat,
  oopf: cat,
  opar: iat,
  OpenCurlyDoubleQuote: aat,
  OpenCurlyQuote: lat,
  operp: uat,
  oplus: pat,
  orarr: fat,
  Or: dat,
  or: hat,
  ord: gat,
  order: $at,
  orderof: mat,
  ordf: bat,
  ordm: yat,
  origof: vat,
  oror: wat,
  orslope: _at,
  orv: Eat,
  oS: xat,
  Oscr: qat,
  oscr: Sat,
  Oslash: Tat,
  oslash: Aat,
  osol: kat,
  Otilde: Dat,
  otilde: Lat,
  otimesas: Cat,
  Otimes: Nat,
  otimes: Rat,
  Ouml: Iat,
  ouml: Bat,
  ovbar: Oat,
  OverBar: Uat,
  OverBrace: Pat,
  OverBracket: Fat,
  OverParenthesis: Vat,
  para: Mat,
  parallel: Hat,
  par: Gat,
  parsim: jat,
  parsl: zat,
  part: Yat,
  PartialD: Wat,
  Pcy: Jat,
  pcy: Xat,
  percnt: Zat,
  period: Qat,
  permil: Kat,
  perp: tlt,
  pertenk: elt,
  Pfr: nlt,
  pfr: rlt,
  Phi: olt,
  phi: slt,
  phiv: clt,
  phmmat: ilt,
  phone: alt,
  Pi: llt,
  pi: ult,
  pitchfork: plt,
  piv: flt,
  planck: dlt,
  planckh: hlt,
  plankv: glt,
  plusacir: $lt,
  plusb: mlt,
  pluscir: blt,
  plus: ylt,
  plusdo: vlt,
  plusdu: wlt,
  pluse: _lt,
  PlusMinus: Elt,
  plusmn: xlt,
  plussim: qlt,
  plustwo: Slt,
  pm: Tlt,
  Poincareplane: Alt,
  pointint: klt,
  popf: Dlt,
  Popf: Llt,
  pound: Clt,
  prap: Nlt,
  Pr: Rlt,
  pr: Ilt,
  prcue: Blt,
  precapprox: Olt,
  prec: Ult,
  preccurlyeq: Plt,
  Precedes: Flt,
  PrecedesEqual: Vlt,
  PrecedesSlantEqual: Mlt,
  PrecedesTilde: Hlt,
  preceq: Glt,
  precnapprox: jlt,
  precneqq: zlt,
  precnsim: Ylt,
  pre: Wlt,
  prE: Jlt,
  precsim: Xlt,
  prime: Zlt,
  Prime: Qlt,
  primes: Klt,
  prnap: tut,
  prnE: eut,
  prnsim: nut,
  prod: rut,
  Product: out,
  profalar: sut,
  profline: cut,
  profsurf: iut,
  prop: aut,
  Proportional: lut,
  Proportion: uut,
  propto: put,
  prsim: fut,
  prurel: dut,
  Pscr: hut,
  pscr: gut,
  Psi: $ut,
  psi: mut,
  puncsp: but,
  Qfr: yut,
  qfr: vut,
  qint: wut,
  qopf: _ut,
  Qopf: Eut,
  qprime: xut,
  Qscr: qut,
  qscr: Sut,
  quaternions: Tut,
  quatint: Aut,
  quest: kut,
  questeq: Dut,
  quot: Lut,
  QUOT: Cut,
  rAarr: Nut,
  race: Rut,
  Racute: Iut,
  racute: But,
  radic: Out,
  raemptyv: Uut,
  rang: Put,
  Rang: Fut,
  rangd: Vut,
  range: Mut,
  rangle: Hut,
  raquo: Gut,
  rarrap: jut,
  rarrb: zut,
  rarrbfs: Yut,
  rarrc: Wut,
  rarr: Jut,
  Rarr: Xut,
  rArr: Zut,
  rarrfs: Qut,
  rarrhk: Kut,
  rarrlp: tpt,
  rarrpl: ept,
  rarrsim: npt,
  Rarrtl: rpt,
  rarrtl: opt,
  rarrw: spt,
  ratail: cpt,
  rAtail: ipt,
  ratio: apt,
  rationals: lpt,
  rbarr: upt,
  rBarr: ppt,
  RBarr: fpt,
  rbbrk: dpt,
  rbrace: hpt,
  rbrack: gpt,
  rbrke: $pt,
  rbrksld: mpt,
  rbrkslu: bpt,
  Rcaron: ypt,
  rcaron: vpt,
  Rcedil: wpt,
  rcedil: _pt,
  rceil: Ept,
  rcub: xpt,
  Rcy: qpt,
  rcy: Spt,
  rdca: Tpt,
  rdldhar: Apt,
  rdquo: kpt,
  rdquor: Dpt,
  rdsh: Lpt,
  real: Cpt,
  realine: Npt,
  realpart: Rpt,
  reals: Ipt,
  Re: Bpt,
  rect: Opt,
  reg: Upt,
  REG: Ppt,
  ReverseElement: Fpt,
  ReverseEquilibrium: Vpt,
  ReverseUpEquilibrium: Mpt,
  rfisht: Hpt,
  rfloor: Gpt,
  rfr: jpt,
  Rfr: zpt,
  rHar: Ypt,
  rhard: Wpt,
  rharu: Jpt,
  rharul: Xpt,
  Rho: Zpt,
  rho: Qpt,
  rhov: Kpt,
  RightAngleBracket: tft,
  RightArrowBar: eft,
  rightarrow: nft,
  RightArrow: rft,
  Rightarrow: oft,
  RightArrowLeftArrow: sft,
  rightarrowtail: cft,
  RightCeiling: ift,
  RightDoubleBracket: aft,
  RightDownTeeVector: lft,
  RightDownVectorBar: uft,
  RightDownVector: pft,
  RightFloor: fft,
  rightharpoondown: dft,
  rightharpoonup: hft,
  rightleftarrows: gft,
  rightleftharpoons: $ft,
  rightrightarrows: mft,
  rightsquigarrow: bft,
  RightTeeArrow: yft,
  RightTee: vft,
  RightTeeVector: wft,
  rightthreetimes: _ft,
  RightTriangleBar: Eft,
  RightTriangle: xft,
  RightTriangleEqual: qft,
  RightUpDownVector: Sft,
  RightUpTeeVector: Tft,
  RightUpVectorBar: Aft,
  RightUpVector: kft,
  RightVectorBar: Dft,
  RightVector: Lft,
  ring: Cft,
  risingdotseq: Nft,
  rlarr: Rft,
  rlhar: Ift,
  rlm: Bft,
  rmoustache: Oft,
  rmoust: Uft,
  rnmid: Pft,
  roang: Fft,
  roarr: Vft,
  robrk: Mft,
  ropar: Hft,
  ropf: Gft,
  Ropf: jft,
  roplus: zft,
  rotimes: Yft,
  RoundImplies: Wft,
  rpar: Jft,
  rpargt: Xft,
  rppolint: Zft,
  rrarr: Qft,
  Rrightarrow: Kft,
  rsaquo: tdt,
  rscr: edt,
  Rscr: ndt,
  rsh: rdt,
  Rsh: odt,
  rsqb: sdt,
  rsquo: cdt,
  rsquor: idt,
  rthree: adt,
  rtimes: ldt,
  rtri: udt,
  rtrie: pdt,
  rtrif: fdt,
  rtriltri: ddt,
  RuleDelayed: hdt,
  ruluhar: gdt,
  rx: $dt,
  Sacute: mdt,
  sacute: bdt,
  sbquo: ydt,
  scap: vdt,
  Scaron: wdt,
  scaron: _dt,
  Sc: Edt,
  sc: xdt,
  sccue: qdt,
  sce: Sdt,
  scE: Tdt,
  Scedil: Adt,
  scedil: kdt,
  Scirc: Ddt,
  scirc: Ldt,
  scnap: Cdt,
  scnE: Ndt,
  scnsim: Rdt,
  scpolint: Idt,
  scsim: Bdt,
  Scy: Odt,
  scy: Udt,
  sdotb: Pdt,
  sdot: Fdt,
  sdote: Vdt,
  searhk: Mdt,
  searr: Hdt,
  seArr: Gdt,
  searrow: jdt,
  sect: zdt,
  semi: Ydt,
  seswar: Wdt,
  setminus: Jdt,
  setmn: Xdt,
  sext: Zdt,
  Sfr: Qdt,
  sfr: Kdt,
  sfrown: tht,
  sharp: eht,
  SHCHcy: nht,
  shchcy: rht,
  SHcy: oht,
  shcy: sht,
  ShortDownArrow: cht,
  ShortLeftArrow: iht,
  shortmid: aht,
  shortparallel: lht,
  ShortRightArrow: uht,
  ShortUpArrow: pht,
  shy: fht,
  Sigma: dht,
  sigma: hht,
  sigmaf: ght,
  sigmav: $ht,
  sim: mht,
  simdot: bht,
  sime: yht,
  simeq: vht,
  simg: wht,
  simgE: _ht,
  siml: Eht,
  simlE: xht,
  simne: qht,
  simplus: Sht,
  simrarr: Tht,
  slarr: Aht,
  SmallCircle: kht,
  smallsetminus: Dht,
  smashp: Lht,
  smeparsl: Cht,
  smid: Nht,
  smile: Rht,
  smt: Iht,
  smte: Bht,
  smtes: Oht,
  SOFTcy: Uht,
  softcy: Pht,
  solbar: Fht,
  solb: Vht,
  sol: Mht,
  Sopf: Hht,
  sopf: Ght,
  spades: jht,
  spadesuit: zht,
  spar: Yht,
  sqcap: Wht,
  sqcaps: Jht,
  sqcup: Xht,
  sqcups: Zht,
  Sqrt: Qht,
  sqsub: Kht,
  sqsube: t1t,
  sqsubset: e1t,
  sqsubseteq: n1t,
  sqsup: r1t,
  sqsupe: o1t,
  sqsupset: s1t,
  sqsupseteq: c1t,
  square: i1t,
  Square: a1t,
  SquareIntersection: l1t,
  SquareSubset: u1t,
  SquareSubsetEqual: p1t,
  SquareSuperset: f1t,
  SquareSupersetEqual: d1t,
  SquareUnion: h1t,
  squarf: g1t,
  squ: $1t,
  squf: m1t,
  srarr: b1t,
  Sscr: y1t,
  sscr: v1t,
  ssetmn: w1t,
  ssmile: _1t,
  sstarf: E1t,
  Star: x1t,
  star: q1t,
  starf: S1t,
  straightepsilon: T1t,
  straightphi: A1t,
  strns: k1t,
  sub: D1t,
  Sub: L1t,
  subdot: C1t,
  subE: N1t,
  sube: R1t,
  subedot: I1t,
  submult: B1t,
  subnE: O1t,
  subne: U1t,
  subplus: P1t,
  subrarr: F1t,
  subset: V1t,
  Subset: M1t,
  subseteq: H1t,
  subseteqq: G1t,
  SubsetEqual: j1t,
  subsetneq: z1t,
  subsetneqq: Y1t,
  subsim: W1t,
  subsub: J1t,
  subsup: X1t,
  succapprox: Z1t,
  succ: Q1t,
  succcurlyeq: K1t,
  Succeeds: tgt,
  SucceedsEqual: egt,
  SucceedsSlantEqual: ngt,
  SucceedsTilde: rgt,
  succeq: ogt,
  succnapprox: sgt,
  succneqq: cgt,
  succnsim: igt,
  succsim: agt,
  SuchThat: lgt,
  sum: ugt,
  Sum: pgt,
  sung: fgt,
  sup1: dgt,
  sup2: hgt,
  sup3: ggt,
  sup: $gt,
  Sup: mgt,
  supdot: bgt,
  supdsub: ygt,
  supE: vgt,
  supe: wgt,
  supedot: _gt,
  Superset: Egt,
  SupersetEqual: xgt,
  suphsol: qgt,
  suphsub: Sgt,
  suplarr: Tgt,
  supmult: Agt,
  supnE: kgt,
  supne: Dgt,
  supplus: Lgt,
  supset: Cgt,
  Supset: Ngt,
  supseteq: Rgt,
  supseteqq: Igt,
  supsetneq: Bgt,
  supsetneqq: Ogt,
  supsim: Ugt,
  supsub: Pgt,
  supsup: Fgt,
  swarhk: Vgt,
  swarr: Mgt,
  swArr: Hgt,
  swarrow: Ggt,
  swnwar: jgt,
  szlig: zgt,
  Tab: Ygt,
  target: Wgt,
  Tau: Jgt,
  tau: Xgt,
  tbrk: Zgt,
  Tcaron: Qgt,
  tcaron: Kgt,
  Tcedil: t$t,
  tcedil: e$t,
  Tcy: n$t,
  tcy: r$t,
  tdot: o$t,
  telrec: s$t,
  Tfr: c$t,
  tfr: i$t,
  there4: a$t,
  therefore: l$t,
  Therefore: u$t,
  Theta: p$t,
  theta: f$t,
  thetasym: d$t,
  thetav: h$t,
  thickapprox: g$t,
  thicksim: $$t,
  ThickSpace: m$t,
  ThinSpace: b$t,
  thinsp: y$t,
  thkap: v$t,
  thksim: w$t,
  THORN: _$t,
  thorn: E$t,
  tilde: x$t,
  Tilde: q$t,
  TildeEqual: S$t,
  TildeFullEqual: T$t,
  TildeTilde: A$t,
  timesbar: k$t,
  timesb: D$t,
  times: L$t,
  timesd: C$t,
  tint: N$t,
  toea: R$t,
  topbot: I$t,
  topcir: B$t,
  top: O$t,
  Topf: U$t,
  topf: P$t,
  topfork: F$t,
  tosa: V$t,
  tprime: M$t,
  trade: H$t,
  TRADE: G$t,
  triangle: j$t,
  triangledown: z$t,
  triangleleft: Y$t,
  trianglelefteq: W$t,
  triangleq: J$t,
  triangleright: X$t,
  trianglerighteq: Z$t,
  tridot: Q$t,
  trie: K$t,
  triminus: tmt,
  TripleDot: emt,
  triplus: nmt,
  trisb: rmt,
  tritime: omt,
  trpezium: smt,
  Tscr: cmt,
  tscr: imt,
  TScy: amt,
  tscy: lmt,
  TSHcy: umt,
  tshcy: pmt,
  Tstrok: fmt,
  tstrok: dmt,
  twixt: hmt,
  twoheadleftarrow: gmt,
  twoheadrightarrow: $mt,
  Uacute: mmt,
  uacute: bmt,
  uarr: ymt,
  Uarr: vmt,
  uArr: wmt,
  Uarrocir: _mt,
  Ubrcy: Emt,
  ubrcy: xmt,
  Ubreve: qmt,
  ubreve: Smt,
  Ucirc: Tmt,
  ucirc: Amt,
  Ucy: kmt,
  ucy: Dmt,
  udarr: Lmt,
  Udblac: Cmt,
  udblac: Nmt,
  udhar: Rmt,
  ufisht: Imt,
  Ufr: Bmt,
  ufr: Omt,
  Ugrave: Umt,
  ugrave: Pmt,
  uHar: Fmt,
  uharl: Vmt,
  uharr: Mmt,
  uhblk: Hmt,
  ulcorn: Gmt,
  ulcorner: jmt,
  ulcrop: zmt,
  ultri: Ymt,
  Umacr: Wmt,
  umacr: Jmt,
  uml: Xmt,
  UnderBar: Zmt,
  UnderBrace: Qmt,
  UnderBracket: Kmt,
  UnderParenthesis: tbt,
  Union: ebt,
  UnionPlus: nbt,
  Uogon: rbt,
  uogon: obt,
  Uopf: sbt,
  uopf: cbt,
  UpArrowBar: ibt,
  uparrow: abt,
  UpArrow: lbt,
  Uparrow: ubt,
  UpArrowDownArrow: pbt,
  updownarrow: fbt,
  UpDownArrow: dbt,
  Updownarrow: hbt,
  UpEquilibrium: gbt,
  upharpoonleft: $bt,
  upharpoonright: mbt,
  uplus: bbt,
  UpperLeftArrow: ybt,
  UpperRightArrow: vbt,
  upsi: wbt,
  Upsi: _bt,
  upsih: Ebt,
  Upsilon: xbt,
  upsilon: qbt,
  UpTeeArrow: Sbt,
  UpTee: Tbt,
  upuparrows: Abt,
  urcorn: kbt,
  urcorner: Dbt,
  urcrop: Lbt,
  Uring: Cbt,
  uring: Nbt,
  urtri: Rbt,
  Uscr: Ibt,
  uscr: Bbt,
  utdot: Obt,
  Utilde: Ubt,
  utilde: Pbt,
  utri: Fbt,
  utrif: Vbt,
  uuarr: Mbt,
  Uuml: Hbt,
  uuml: Gbt,
  uwangle: jbt,
  vangrt: zbt,
  varepsilon: Ybt,
  varkappa: Wbt,
  varnothing: Jbt,
  varphi: Xbt,
  varpi: Zbt,
  varpropto: Qbt,
  varr: Kbt,
  vArr: tyt,
  varrho: eyt,
  varsigma: nyt,
  varsubsetneq: ryt,
  varsubsetneqq: oyt,
  varsupsetneq: syt,
  varsupsetneqq: cyt,
  vartheta: iyt,
  vartriangleleft: ayt,
  vartriangleright: lyt,
  vBar: uyt,
  Vbar: pyt,
  vBarv: fyt,
  Vcy: dyt,
  vcy: hyt,
  vdash: gyt,
  vDash: $yt,
  Vdash: myt,
  VDash: byt,
  Vdashl: yyt,
  veebar: vyt,
  vee: wyt,
  Vee: _yt,
  veeeq: Eyt,
  vellip: xyt,
  verbar: qyt,
  Verbar: Syt,
  vert: Tyt,
  Vert: Ayt,
  VerticalBar: kyt,
  VerticalLine: Dyt,
  VerticalSeparator: Lyt,
  VerticalTilde: Cyt,
  VeryThinSpace: Nyt,
  Vfr: Ryt,
  vfr: Iyt,
  vltri: Byt,
  vnsub: Oyt,
  vnsup: Uyt,
  Vopf: Pyt,
  vopf: Fyt,
  vprop: Vyt,
  vrtri: Myt,
  Vscr: Hyt,
  vscr: Gyt,
  vsubnE: jyt,
  vsubne: zyt,
  vsupnE: Yyt,
  vsupne: Wyt,
  Vvdash: Jyt,
  vzigzag: Xyt,
  Wcirc: Zyt,
  wcirc: Qyt,
  wedbar: Kyt,
  wedge: tvt,
  Wedge: evt,
  wedgeq: nvt,
  weierp: rvt,
  Wfr: ovt,
  wfr: svt,
  Wopf: cvt,
  wopf: ivt,
  wp: avt,
  wr: lvt,
  wreath: uvt,
  Wscr: pvt,
  wscr: fvt,
  xcap: dvt,
  xcirc: hvt,
  xcup: gvt,
  xdtri: $vt,
  Xfr: mvt,
  xfr: bvt,
  xharr: yvt,
  xhArr: vvt,
  Xi: wvt,
  xi: _vt,
  xlarr: Evt,
  xlArr: xvt,
  xmap: qvt,
  xnis: Svt,
  xodot: Tvt,
  Xopf: Avt,
  xopf: kvt,
  xoplus: Dvt,
  xotime: Lvt,
  xrarr: Cvt,
  xrArr: Nvt,
  Xscr: Rvt,
  xscr: Ivt,
  xsqcup: Bvt,
  xuplus: Ovt,
  xutri: Uvt,
  xvee: Pvt,
  xwedge: Fvt,
  Yacute: Vvt,
  yacute: Mvt,
  YAcy: Hvt,
  yacy: Gvt,
  Ycirc: jvt,
  ycirc: zvt,
  Ycy: Yvt,
  ycy: Wvt,
  yen: Jvt,
  Yfr: Xvt,
  yfr: Zvt,
  YIcy: Qvt,
  yicy: Kvt,
  Yopf: twt,
  yopf: ewt,
  Yscr: nwt,
  yscr: rwt,
  YUcy: owt,
  yucy: swt,
  yuml: cwt,
  Yuml: iwt,
  Zacute: awt,
  zacute: lwt,
  Zcaron: uwt,
  zcaron: pwt,
  Zcy: fwt,
  zcy: dwt,
  Zdot: hwt,
  zdot: gwt,
  zeetrf: $wt,
  ZeroWidthSpace: mwt,
  Zeta: bwt,
  zeta: ywt,
  zfr: vwt,
  Zfr: wwt,
  ZHcy: _wt,
  zhcy: Ewt,
  zigrarr: xwt,
  zopf: qwt,
  Zopf: Swt,
  Zscr: Twt,
  zscr: Awt,
  zwj: kwt,
  zwnj: Dwt
}, Lwt = "Á", Cwt = "á", Nwt = "Â", Rwt = "â", Iwt = "´", Bwt = "Æ", Owt = "æ", Uwt = "À", Pwt = "à", Fwt = "&", Vwt = "&", Mwt = "Å", Hwt = "å", Gwt = "Ã", jwt = "ã", zwt = "Ä", Ywt = "ä", Wwt = "¦", Jwt = "Ç", Xwt = "ç", Zwt = "¸", Qwt = "¢", Kwt = "©", t0t = "©", e0t = "¤", n0t = "°", r0t = "÷", o0t = "É", s0t = "é", c0t = "Ê", i0t = "ê", a0t = "È", l0t = "è", u0t = "Ð", p0t = "ð", f0t = "Ë", d0t = "ë", h0t = "½", g0t = "¼", $0t = "¾", m0t = ">", b0t = ">", y0t = "Í", v0t = "í", w0t = "Î", _0t = "î", E0t = "¡", x0t = "Ì", q0t = "ì", S0t = "¿", T0t = "Ï", A0t = "ï", k0t = "«", D0t = "<", L0t = "<", C0t = "¯", N0t = "µ", R0t = "·", I0t = " ", B0t = "¬", O0t = "Ñ", U0t = "ñ", P0t = "Ó", F0t = "ó", V0t = "Ô", M0t = "ô", H0t = "Ò", G0t = "ò", j0t = "ª", z0t = "º", Y0t = "Ø", W0t = "ø", J0t = "Õ", X0t = "õ", Z0t = "Ö", Q0t = "ö", K0t = "¶", t_t = "±", e_t = "£", n_t = '"', r_t = '"', o_t = "»", s_t = "®", c_t = "®", i_t = "§", a_t = "­", l_t = "¹", u_t = "²", p_t = "³", f_t = "ß", d_t = "Þ", h_t = "þ", g_t = "×", $_t = "Ú", m_t = "ú", b_t = "Û", y_t = "û", v_t = "Ù", w_t = "ù", __t = "¨", E_t = "Ü", x_t = "ü", q_t = "Ý", S_t = "ý", T_t = "¥", A_t = "ÿ", k_t = {
  Aacute: Lwt,
  aacute: Cwt,
  Acirc: Nwt,
  acirc: Rwt,
  acute: Iwt,
  AElig: Bwt,
  aelig: Owt,
  Agrave: Uwt,
  agrave: Pwt,
  amp: Fwt,
  AMP: Vwt,
  Aring: Mwt,
  aring: Hwt,
  Atilde: Gwt,
  atilde: jwt,
  Auml: zwt,
  auml: Ywt,
  brvbar: Wwt,
  Ccedil: Jwt,
  ccedil: Xwt,
  cedil: Zwt,
  cent: Qwt,
  copy: Kwt,
  COPY: t0t,
  curren: e0t,
  deg: n0t,
  divide: r0t,
  Eacute: o0t,
  eacute: s0t,
  Ecirc: c0t,
  ecirc: i0t,
  Egrave: a0t,
  egrave: l0t,
  ETH: u0t,
  eth: p0t,
  Euml: f0t,
  euml: d0t,
  frac12: h0t,
  frac14: g0t,
  frac34: $0t,
  gt: m0t,
  GT: b0t,
  Iacute: y0t,
  iacute: v0t,
  Icirc: w0t,
  icirc: _0t,
  iexcl: E0t,
  Igrave: x0t,
  igrave: q0t,
  iquest: S0t,
  Iuml: T0t,
  iuml: A0t,
  laquo: k0t,
  lt: D0t,
  LT: L0t,
  macr: C0t,
  micro: N0t,
  middot: R0t,
  nbsp: I0t,
  not: B0t,
  Ntilde: O0t,
  ntilde: U0t,
  Oacute: P0t,
  oacute: F0t,
  Ocirc: V0t,
  ocirc: M0t,
  Ograve: H0t,
  ograve: G0t,
  ordf: j0t,
  ordm: z0t,
  Oslash: Y0t,
  oslash: W0t,
  Otilde: J0t,
  otilde: X0t,
  Ouml: Z0t,
  ouml: Q0t,
  para: K0t,
  plusmn: t_t,
  pound: e_t,
  quot: n_t,
  QUOT: r_t,
  raquo: o_t,
  reg: s_t,
  REG: c_t,
  sect: i_t,
  shy: a_t,
  sup1: l_t,
  sup2: u_t,
  sup3: p_t,
  szlig: f_t,
  THORN: d_t,
  thorn: h_t,
  times: g_t,
  Uacute: $_t,
  uacute: m_t,
  Ucirc: b_t,
  ucirc: y_t,
  Ugrave: v_t,
  ugrave: w_t,
  uml: __t,
  Uuml: E_t,
  uuml: x_t,
  Yacute: q_t,
  yacute: S_t,
  yen: T_t,
  yuml: A_t
}, D_t = "&", L_t = "'", C_t = ">", N_t = "<", R_t = '"', Fo = {
  amp: D_t,
  apos: L_t,
  gt: C_t,
  lt: N_t,
  quot: R_t
};
var ye = {};
const I_t = {
  0: 65533,
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
};
var or;
function B_t() {
  if (or)
    return ye;
  or = 1;
  var t = Wt && Wt.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(ye, "__esModule", { value: !0 });
  var e = t(I_t), n = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(c) {
      var l = "";
      return c > 65535 && (c -= 65536, l += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | c & 1023), l += String.fromCharCode(c), l;
    }
  );
  function s(c) {
    return c >= 55296 && c <= 57343 || c > 1114111 ? "�" : (c in e.default && (c = e.default[c]), n(c));
  }
  return ye.default = s, ye;
}
var sr;
function cr() {
  if (sr)
    return qt;
  sr = 1;
  var t = Wt && Wt.__importDefault || function(h) {
    return h && h.__esModule ? h : { default: h };
  };
  Object.defineProperty(qt, "__esModule", { value: !0 }), qt.decodeHTML = qt.decodeHTMLStrict = qt.decodeXML = void 0;
  var e = t(Po), n = t(k_t), s = t(Fo), c = t(B_t()), l = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  qt.decodeXML = u(s.default), qt.decodeHTMLStrict = u(e.default);
  function u(h) {
    var b = d(h);
    return function(m) {
      return String(m).replace(l, b);
    };
  }
  var a = function(h, b) {
    return h < b ? 1 : -1;
  };
  qt.decodeHTML = function() {
    for (var h = Object.keys(n.default).sort(a), b = Object.keys(e.default).sort(a), m = 0, E = 0; m < b.length; m++)
      h[E] === b[m] ? (b[m] += ";?", E++) : b[m] += ";";
    var $ = new RegExp("&(?:" + b.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), v = d(e.default);
    function S(A) {
      return A.substr(-1) !== ";" && (A += ";"), v(A);
    }
    return function(A) {
      return String(A).replace($, S);
    };
  }();
  function d(h) {
    return function(m) {
      if (m.charAt(1) === "#") {
        var E = m.charAt(2);
        return E === "X" || E === "x" ? c.default(parseInt(m.substr(3), 16)) : c.default(parseInt(m.substr(2), 10));
      }
      return h[m.slice(1, -1)] || m;
    };
  }
  return qt;
}
var pt = {}, ir;
function ar() {
  if (ir)
    return pt;
  ir = 1;
  var t = Wt && Wt.__importDefault || function(f) {
    return f && f.__esModule ? f : { default: f };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.escapeUTF8 = pt.escape = pt.encodeNonAsciiHTML = pt.encodeHTML = pt.encodeXML = void 0;
  var e = t(Fo), n = a(e.default), s = d(n);
  pt.encodeXML = A(n);
  var c = t(Po), l = a(c.default), u = d(l);
  pt.encodeHTML = E(l, u), pt.encodeNonAsciiHTML = A(l);
  function a(f) {
    return Object.keys(f).sort().reduce(function(y, q) {
      return y[f[q]] = "&" + q + ";", y;
    }, {});
  }
  function d(f) {
    for (var y = [], q = [], k = 0, _ = Object.keys(f); k < _.length; k++) {
      var N = _[k];
      N.length === 1 ? y.push("\\" + N) : q.push(N);
    }
    y.sort();
    for (var D = 0; D < y.length - 1; D++) {
      for (var z = D; z < y.length - 1 && y[z].charCodeAt(1) + 1 === y[z + 1].charCodeAt(1); )
        z += 1;
      var nt = 1 + z - D;
      nt < 3 || y.splice(D, nt, y[D] + "-" + y[z]);
    }
    return q.unshift("[" + y.join("") + "]"), new RegExp(q.join("|"), "g");
  }
  var h = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, b = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      function(f) {
        return f.codePointAt(0);
      }
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(f) {
        return (f.charCodeAt(0) - 55296) * 1024 + f.charCodeAt(1) - 56320 + 65536;
      }
    )
  );
  function m(f) {
    return "&#x" + (f.length > 1 ? b(f) : f.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  function E(f, y) {
    return function(q) {
      return q.replace(y, function(k) {
        return f[k];
      }).replace(h, m);
    };
  }
  var $ = new RegExp(s.source + "|" + h.source, "g");
  function v(f) {
    return f.replace($, m);
  }
  pt.escape = v;
  function S(f) {
    return f.replace(s, m);
  }
  pt.escapeUTF8 = S;
  function A(f) {
    return function(y) {
      return y.replace($, function(q) {
        return f[q] || m(q);
      });
    };
  }
  return pt;
}
var lr;
function O_t() {
  return lr || (lr = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.encodeHTML5 = t.encodeHTML4 = t.escapeUTF8 = t.escape = t.encodeNonAsciiHTML = t.encodeHTML = t.encodeXML = t.encode = t.decodeStrict = t.decode = void 0;
    var e = cr(), n = ar();
    function s(d, h) {
      return (!h || h <= 0 ? e.decodeXML : e.decodeHTML)(d);
    }
    t.decode = s;
    function c(d, h) {
      return (!h || h <= 0 ? e.decodeXML : e.decodeHTMLStrict)(d);
    }
    t.decodeStrict = c;
    function l(d, h) {
      return (!h || h <= 0 ? n.encodeXML : n.encodeHTML)(d);
    }
    t.encode = l;
    var u = ar();
    Object.defineProperty(t, "encodeXML", { enumerable: !0, get: function() {
      return u.encodeXML;
    } }), Object.defineProperty(t, "encodeHTML", { enumerable: !0, get: function() {
      return u.encodeHTML;
    } }), Object.defineProperty(t, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
      return u.encodeNonAsciiHTML;
    } }), Object.defineProperty(t, "escape", { enumerable: !0, get: function() {
      return u.escape;
    } }), Object.defineProperty(t, "escapeUTF8", { enumerable: !0, get: function() {
      return u.escapeUTF8;
    } }), Object.defineProperty(t, "encodeHTML4", { enumerable: !0, get: function() {
      return u.encodeHTML;
    } }), Object.defineProperty(t, "encodeHTML5", { enumerable: !0, get: function() {
      return u.encodeHTML;
    } });
    var a = cr();
    Object.defineProperty(t, "decodeXML", { enumerable: !0, get: function() {
      return a.decodeXML;
    } }), Object.defineProperty(t, "decodeHTML", { enumerable: !0, get: function() {
      return a.decodeHTML;
    } }), Object.defineProperty(t, "decodeHTMLStrict", { enumerable: !0, get: function() {
      return a.decodeHTMLStrict;
    } }), Object.defineProperty(t, "decodeHTML4", { enumerable: !0, get: function() {
      return a.decodeHTML;
    } }), Object.defineProperty(t, "decodeHTML5", { enumerable: !0, get: function() {
      return a.decodeHTML;
    } }), Object.defineProperty(t, "decodeHTML4Strict", { enumerable: !0, get: function() {
      return a.decodeHTMLStrict;
    } }), Object.defineProperty(t, "decodeHTML5Strict", { enumerable: !0, get: function() {
      return a.decodeHTMLStrict;
    } }), Object.defineProperty(t, "decodeXMLStrict", { enumerable: !0, get: function() {
      return a.decodeXML;
    } });
  }(je)), je;
}
const U_t = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  fedropshadow: "feDropShadow",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, P_t = {
  definitionurl: "definitionURL",
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, F_t = {
  elementNames: U_t,
  attributeNames: P_t
};
var ur;
function V_t() {
  if (ur)
    return He.exports;
  ur = 1;
  var t = pH(), e = O_t(), n = F_t;
  n.elementNames.__proto__ = null, n.attributeNames.__proto__ = null;
  var s = {
    __proto__: null,
    style: !0,
    script: !0,
    xmp: !0,
    iframe: !0,
    noembed: !0,
    noframes: !0,
    plaintext: !0,
    noscript: !0
  };
  function c($, v) {
    if ($) {
      var S = "", A;
      for (var f in $)
        A = $[f], S && (S += " "), v.xmlMode === "foreign" && (f = n.attributeNames[f] || f), S += f, (A !== null && A !== "" || v.xmlMode) && (S += '="' + (v.decodeEntities ? e.encodeXML(A) : A.replace(/\"/g, "&quot;")) + '"');
      return S;
    }
  }
  var l = {
    __proto__: null,
    area: !0,
    base: !0,
    basefont: !0,
    br: !0,
    col: !0,
    command: !0,
    embed: !0,
    frame: !0,
    hr: !0,
    img: !0,
    input: !0,
    isindex: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }, u = He.exports = function($, v) {
    !Array.isArray($) && !$.cheerio && ($ = [$]), v = v || {};
    for (var S = "", A = 0; A < $.length; A++) {
      var f = $[A];
      f.type === "root" ? S += u(f.children, v) : t.isTag(f) ? S += d(f, v) : f.type === t.Directive ? S += h(f) : f.type === t.Comment ? S += E(f) : f.type === t.CDATA ? S += m(f) : S += b(f, v);
    }
    return S;
  }, a = [
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
  ];
  function d($, v) {
    v.xmlMode === "foreign" && ($.name = n.elementNames[$.name] || $.name, $.parent && a.indexOf($.parent.name) >= 0 && (v = Object.assign({}, v, { xmlMode: !1 }))), !v.xmlMode && ["svg", "math"].indexOf($.name) >= 0 && (v = Object.assign({}, v, { xmlMode: "foreign" }));
    var S = "<" + $.name, A = c($.attribs, v);
    return A && (S += " " + A), v.xmlMode && (!$.children || $.children.length === 0) ? S += "/>" : (S += ">", $.children && (S += u($.children, v)), (!l[$.name] || v.xmlMode) && (S += "</" + $.name + ">")), S;
  }
  function h($) {
    return "<" + $.data + ">";
  }
  function b($, v) {
    var S = $.data || "";
    return v.decodeEntities && !($.parent && $.parent.name in s) && (S = e.encodeXML(S)), S;
  }
  function m($) {
    return "<![CDATA[" + $.children[0].data + "]]>";
  }
  function E($) {
    return "<!--" + $.data + "-->";
  }
  return He.exports;
}
var ze, pr;
function M_t() {
  if (pr)
    return ze;
  pr = 1;
  var t = ge, e = V_t(), n = t.isTag;
  ze = {
    getInnerHTML: s,
    getOuterHTML: e,
    getText: c
  };
  function s(l, u) {
    return l.children ? l.children.map(function(a) {
      return e(a, u);
    }).join("") : "";
  }
  function c(l) {
    return Array.isArray(l) ? l.map(c).join("") : n(l) ? l.name === "br" ? `
` : c(l.children) : l.type === t.CDATA ? c(l.children) : l.type === t.Text ? l.data : "";
  }
  return ze;
}
var Lt = {}, fr;
function H_t() {
  if (fr)
    return Lt;
  fr = 1;
  var t = Lt.getChildren = function(n) {
    return n.children;
  }, e = Lt.getParent = function(n) {
    return n.parent;
  };
  return Lt.getSiblings = function(n) {
    var s = e(n);
    return s ? t(s) : [n];
  }, Lt.getAttributeValue = function(n, s) {
    return n.attribs && n.attribs[s];
  }, Lt.hasAttrib = function(n, s) {
    return !!n.attribs && hasOwnProperty.call(n.attribs, s);
  }, Lt.getName = function(n) {
    return n.name;
  }, Lt;
}
var Bt = {}, dr;
function G_t() {
  return dr || (dr = 1, Bt.removeElement = function(t) {
    if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
      var e = t.parent.children;
      e.splice(e.lastIndexOf(t), 1);
    }
  }, Bt.replaceElement = function(t, e) {
    var n = e.prev = t.prev;
    n && (n.next = e);
    var s = e.next = t.next;
    s && (s.prev = e);
    var c = e.parent = t.parent;
    if (c) {
      var l = c.children;
      l[l.lastIndexOf(t)] = e;
    }
  }, Bt.appendChild = function(t, e) {
    if (e.parent = t, t.children.push(e) !== 1) {
      var n = t.children[t.children.length - 2];
      n.next = e, e.prev = n, e.next = null;
    }
  }, Bt.append = function(t, e) {
    var n = t.parent, s = t.next;
    if (e.next = s, e.prev = t, t.next = e, e.parent = n, s) {
      if (s.prev = e, n) {
        var c = n.children;
        c.splice(c.lastIndexOf(s), 0, e);
      }
    } else
      n && n.children.push(e);
  }, Bt.prepend = function(t, e) {
    var n = t.parent;
    if (n) {
      var s = n.children;
      s.splice(s.lastIndexOf(t), 0, e);
    }
    t.prev && (t.prev.next = e), e.parent = n, e.prev = t.prev, e.next = t, t.prev = e;
  }), Bt;
}
var Ye, hr;
function j_t() {
  if (hr)
    return Ye;
  hr = 1;
  var t = ge.isTag;
  Ye = {
    filter: e,
    find: n,
    findOneChild: s,
    findOne: c,
    existsOne: l,
    findAll: u
  };
  function e(a, d, h, b) {
    return Array.isArray(d) || (d = [d]), (typeof b != "number" || !isFinite(b)) && (b = 1 / 0), n(a, d, h !== !1, b);
  }
  function n(a, d, h, b) {
    for (var m = [], E, $ = 0, v = d.length; $ < v && !(a(d[$]) && (m.push(d[$]), --b <= 0) || (E = d[$].children, h && E && E.length > 0 && (E = n(a, E, h, b), m = m.concat(E), b -= E.length, b <= 0))); $++)
      ;
    return m;
  }
  function s(a, d) {
    for (var h = 0, b = d.length; h < b; h++)
      if (a(d[h]))
        return d[h];
    return null;
  }
  function c(a, d) {
    for (var h = null, b = 0, m = d.length; b < m && !h; b++)
      if (t(d[b]))
        a(d[b]) ? h = d[b] : d[b].children.length > 0 && (h = c(a, d[b].children));
      else
        continue;
    return h;
  }
  function l(a, d) {
    for (var h = 0, b = d.length; h < b; h++)
      if (t(d[h]) && (a(d[h]) || d[h].children.length > 0 && l(a, d[h].children)))
        return !0;
    return !1;
  }
  function u(a, d) {
    for (var h = [], b = d.slice(); b.length; ) {
      var m = b.shift();
      t(m) && (m.children && m.children.length > 0 && b.unshift.apply(b, m.children), a(m) && h.push(m));
    }
    return h;
  }
  return Ye;
}
var Ct = {}, gr;
function z_t() {
  if (gr)
    return Ct;
  gr = 1;
  var t = ge, e = Ct.isTag = t.isTag;
  Ct.testElement = function(l, u) {
    for (var a in l)
      if (l.hasOwnProperty(a)) {
        if (a === "tag_name") {
          if (!e(u) || !l.tag_name(u.name))
            return !1;
        } else if (a === "tag_type") {
          if (!l.tag_type(u.type))
            return !1;
        } else if (a === "tag_contains") {
          if (e(u) || !l.tag_contains(u.data))
            return !1;
        } else if (!u.attribs || !l[a](u.attribs[a]))
          return !1;
      }
    return !0;
  };
  var n = {
    tag_name: function(l) {
      return typeof l == "function" ? function(u) {
        return e(u) && l(u.name);
      } : l === "*" ? e : function(u) {
        return e(u) && u.name === l;
      };
    },
    tag_type: function(l) {
      return typeof l == "function" ? function(u) {
        return l(u.type);
      } : function(u) {
        return u.type === l;
      };
    },
    tag_contains: function(l) {
      return typeof l == "function" ? function(u) {
        return !e(u) && l(u.data);
      } : function(u) {
        return !e(u) && u.data === l;
      };
    }
  };
  function s(l, u) {
    return typeof u == "function" ? function(a) {
      return a.attribs && u(a.attribs[l]);
    } : function(a) {
      return a.attribs && a.attribs[l] === u;
    };
  }
  function c(l, u) {
    return function(a) {
      return l(a) || u(a);
    };
  }
  return Ct.getElements = function(l, u, a, d) {
    var h = Object.keys(l).map(function(b) {
      var m = l[b];
      return b in n ? n[b](m) : s(b, m);
    });
    return h.length === 0 ? [] : this.filter(
      h.reduce(c),
      u,
      a,
      d
    );
  }, Ct.getElementById = function(l, u, a) {
    return Array.isArray(u) || (u = [u]), this.findOne(s("id", l), u, a !== !1);
  }, Ct.getElementsByTagName = function(l, u, a, d) {
    return this.filter(n.tag_name(l), u, a, d);
  }, Ct.getElementsByTagType = function(l, u, a, d) {
    return this.filter(n.tag_type(l), u, a, d);
  }, Ct;
}
var ce = {}, $r;
function Y_t() {
  if ($r)
    return ce;
  $r = 1, ce.removeSubsets = function(n) {
    for (var s = n.length, c, l, u; --s > -1; ) {
      for (c = l = n[s], n[s] = null, u = !0; l; ) {
        if (n.indexOf(l) > -1) {
          u = !1, n.splice(s, 1);
          break;
        }
        l = l.parent;
      }
      u && (n[s] = c);
    }
    return n;
  };
  var t = {
    DISCONNECTED: 1,
    PRECEDING: 2,
    FOLLOWING: 4,
    CONTAINS: 8,
    CONTAINED_BY: 16
  }, e = ce.compareDocumentPosition = function(n, s) {
    var c = [], l = [], u, a, d, h, b, m;
    if (n === s)
      return 0;
    for (u = n; u; )
      c.unshift(u), u = u.parent;
    for (u = s; u; )
      l.unshift(u), u = u.parent;
    for (m = 0; c[m] === l[m]; )
      m++;
    return m === 0 ? t.DISCONNECTED : (a = c[m - 1], d = a.children, h = c[m], b = l[m], d.indexOf(h) > d.indexOf(b) ? a === s ? t.FOLLOWING | t.CONTAINED_BY : t.FOLLOWING : a === n ? t.PRECEDING | t.CONTAINS : t.PRECEDING);
  };
  return ce.uniqueSort = function(n) {
    var s = n.length, c, l;
    for (n = n.slice(); --s > -1; )
      c = n[s], l = n.indexOf(c), l > -1 && l < s && n.splice(s, 1);
    return n.sort(function(u, a) {
      var d = e(u, a);
      return d & t.PRECEDING ? -1 : d & t.FOLLOWING ? 1 : 0;
    }), n;
  }, ce;
}
var mr;
function Vo() {
  return mr || (mr = 1, function(t) {
    var e = t.exports;
    [
      M_t(),
      H_t(),
      G_t(),
      j_t(),
      z_t(),
      Y_t()
    ].forEach(function(n) {
      Object.keys(n).forEach(function(s) {
        e[s] = n[s].bind(e);
      });
    });
  }(Me)), Me.exports;
}
var We, br;
function W_t() {
  if (br)
    return We;
  br = 1;
  var t = Uo, e = Vo();
  function n(d, h) {
    this.init(d, h);
  }
  Ne(n, t), n.prototype.init = t;
  function s(d, h) {
    return e.getElementsByTagName(d, h, !0);
  }
  function c(d, h) {
    return e.getElementsByTagName(d, h, !0, 1)[0];
  }
  function l(d, h, b) {
    return e.getText(
      e.getElementsByTagName(d, h, b, 1)
    ).trim();
  }
  function u(d, h, b, m, E) {
    var $ = l(b, m, E);
    $ && (d[h] = $);
  }
  var a = function(d) {
    return d === "rss" || d === "feed" || d === "rdf:RDF";
  };
  return n.prototype.onend = function() {
    var d = {}, h = c(a, this.dom), b, m;
    h && (h.name === "feed" ? (m = h.children, d.type = "atom", u(d, "id", "id", m), u(d, "title", "title", m), (b = c("link", m)) && (b = b.attribs) && (b = b.href) && (d.link = b), u(d, "description", "subtitle", m), (b = l("updated", m)) && (d.updated = new Date(b)), u(d, "author", "email", m, !0), d.items = s("entry", m).map(function(E) {
      var $ = {}, v;
      return E = E.children, u($, "id", "id", E), u($, "title", "title", E), (v = c("link", E)) && (v = v.attribs) && (v = v.href) && ($.link = v), (v = l("summary", E) || l("content", E)) && ($.description = v), (v = l("updated", E)) && ($.pubDate = new Date(v)), $;
    })) : (m = c("channel", h.children).children, d.type = h.name.substr(0, 3), d.id = "", u(d, "title", "title", m), u(d, "link", "link", m), u(d, "description", "description", m), (b = l("lastBuildDate", m)) && (d.updated = new Date(b)), u(d, "author", "managingEditor", m, !0), d.items = s("item", h.children).map(function(E) {
      var $ = {}, v;
      return E = E.children, u($, "id", "guid", E), u($, "title", "title", E), u($, "link", "link", E), u($, "description", "description", E), (v = l("pubDate", E)) && ($.pubDate = new Date(v)), $;
    }))), this.dom = d, t.prototype._handleCallback.call(
      this,
      h ? null : Error("couldn't find root of feed")
    );
  }, We = n, We;
}
var Je = {}, ve = { exports: {} }, Xe = {}, ie = {}, yr;
function J_t() {
  if (yr)
    return ie;
  yr = 1, ie.byteLength = a, ie.toByteArray = h, ie.fromByteArray = E;
  for (var t = [], e = [], n = typeof Uint8Array < "u" ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, l = s.length; c < l; ++c)
    t[c] = s[c], e[s.charCodeAt(c)] = c;
  e["-".charCodeAt(0)] = 62, e["_".charCodeAt(0)] = 63;
  function u($) {
    var v = $.length;
    if (v % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var S = $.indexOf("=");
    S === -1 && (S = v);
    var A = S === v ? 0 : 4 - S % 4;
    return [S, A];
  }
  function a($) {
    var v = u($), S = v[0], A = v[1];
    return (S + A) * 3 / 4 - A;
  }
  function d($, v, S) {
    return (v + S) * 3 / 4 - S;
  }
  function h($) {
    var v, S = u($), A = S[0], f = S[1], y = new n(d($, A, f)), q = 0, k = f > 0 ? A - 4 : A, _;
    for (_ = 0; _ < k; _ += 4)
      v = e[$.charCodeAt(_)] << 18 | e[$.charCodeAt(_ + 1)] << 12 | e[$.charCodeAt(_ + 2)] << 6 | e[$.charCodeAt(_ + 3)], y[q++] = v >> 16 & 255, y[q++] = v >> 8 & 255, y[q++] = v & 255;
    return f === 2 && (v = e[$.charCodeAt(_)] << 2 | e[$.charCodeAt(_ + 1)] >> 4, y[q++] = v & 255), f === 1 && (v = e[$.charCodeAt(_)] << 10 | e[$.charCodeAt(_ + 1)] << 4 | e[$.charCodeAt(_ + 2)] >> 2, y[q++] = v >> 8 & 255, y[q++] = v & 255), y;
  }
  function b($) {
    return t[$ >> 18 & 63] + t[$ >> 12 & 63] + t[$ >> 6 & 63] + t[$ & 63];
  }
  function m($, v, S) {
    for (var A, f = [], y = v; y < S; y += 3)
      A = ($[y] << 16 & 16711680) + ($[y + 1] << 8 & 65280) + ($[y + 2] & 255), f.push(b(A));
    return f.join("");
  }
  function E($) {
    for (var v, S = $.length, A = S % 3, f = [], y = 16383, q = 0, k = S - A; q < k; q += y)
      f.push(m($, q, q + y > k ? k : q + y));
    return A === 1 ? (v = $[S - 1], f.push(
      t[v >> 2] + t[v << 4 & 63] + "=="
    )) : A === 2 && (v = ($[S - 2] << 8) + $[S - 1], f.push(
      t[v >> 10] + t[v >> 4 & 63] + t[v << 2 & 63] + "="
    )), f.join("");
  }
  return ie;
}
var we = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var vr;
function X_t() {
  return vr || (vr = 1, we.read = function(t, e, n, s, c) {
    var l, u, a = c * 8 - s - 1, d = (1 << a) - 1, h = d >> 1, b = -7, m = n ? c - 1 : 0, E = n ? -1 : 1, $ = t[e + m];
    for (m += E, l = $ & (1 << -b) - 1, $ >>= -b, b += a; b > 0; l = l * 256 + t[e + m], m += E, b -= 8)
      ;
    for (u = l & (1 << -b) - 1, l >>= -b, b += s; b > 0; u = u * 256 + t[e + m], m += E, b -= 8)
      ;
    if (l === 0)
      l = 1 - h;
    else {
      if (l === d)
        return u ? NaN : ($ ? -1 : 1) * (1 / 0);
      u = u + Math.pow(2, s), l = l - h;
    }
    return ($ ? -1 : 1) * u * Math.pow(2, l - s);
  }, we.write = function(t, e, n, s, c, l) {
    var u, a, d, h = l * 8 - c - 1, b = (1 << h) - 1, m = b >> 1, E = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, $ = s ? 0 : l - 1, v = s ? 1 : -1, S = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, u = b) : (u = Math.floor(Math.log(e) / Math.LN2), e * (d = Math.pow(2, -u)) < 1 && (u--, d *= 2), u + m >= 1 ? e += E / d : e += E * Math.pow(2, 1 - m), e * d >= 2 && (u++, d /= 2), u + m >= b ? (a = 0, u = b) : u + m >= 1 ? (a = (e * d - 1) * Math.pow(2, c), u = u + m) : (a = e * Math.pow(2, m - 1) * Math.pow(2, c), u = 0)); c >= 8; t[n + $] = a & 255, $ += v, a /= 256, c -= 8)
      ;
    for (u = u << c | a, h += c; h > 0; t[n + $] = u & 255, $ += v, u /= 256, h -= 8)
      ;
    t[n + $ - v] |= S * 128;
  }), we;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var wr;
function Mo() {
  return wr || (wr = 1, function(t) {
    var e = J_t(), n = X_t(), s = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    t.Buffer = a, t.SlowBuffer = y, t.INSPECT_MAX_BYTES = 50;
    var c = 2147483647;
    t.kMaxLength = c, a.TYPED_ARRAY_SUPPORT = l(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function l() {
      try {
        var i = new Uint8Array(1), r = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(r, Uint8Array.prototype), Object.setPrototypeOf(i, r), i.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function u(i) {
      if (i > c)
        throw new RangeError('The value "' + i + '" is invalid for option "size"');
      var r = new Uint8Array(i);
      return Object.setPrototypeOf(r, a.prototype), r;
    }
    function a(i, r, o) {
      if (typeof i == "number") {
        if (typeof r == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return m(i);
      }
      return d(i, r, o);
    }
    a.poolSize = 8192;
    function d(i, r, o) {
      if (typeof i == "string")
        return E(i, r);
      if (ArrayBuffer.isView(i))
        return v(i);
      if (i == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof i
        );
      if (ut(i, ArrayBuffer) || i && ut(i.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (ut(i, SharedArrayBuffer) || i && ut(i.buffer, SharedArrayBuffer)))
        return S(i, r, o);
      if (typeof i == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var p = i.valueOf && i.valueOf();
      if (p != null && p !== i)
        return a.from(p, r, o);
      var g = A(i);
      if (g)
        return g;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof i[Symbol.toPrimitive] == "function")
        return a.from(
          i[Symbol.toPrimitive]("string"),
          r,
          o
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof i
      );
    }
    a.from = function(i, r, o) {
      return d(i, r, o);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function h(i) {
      if (typeof i != "number")
        throw new TypeError('"size" argument must be of type number');
      if (i < 0)
        throw new RangeError('The value "' + i + '" is invalid for option "size"');
    }
    function b(i, r, o) {
      return h(i), i <= 0 ? u(i) : r !== void 0 ? typeof o == "string" ? u(i).fill(r, o) : u(i).fill(r) : u(i);
    }
    a.alloc = function(i, r, o) {
      return b(i, r, o);
    };
    function m(i) {
      return h(i), u(i < 0 ? 0 : f(i) | 0);
    }
    a.allocUnsafe = function(i) {
      return m(i);
    }, a.allocUnsafeSlow = function(i) {
      return m(i);
    };
    function E(i, r) {
      if ((typeof r != "string" || r === "") && (r = "utf8"), !a.isEncoding(r))
        throw new TypeError("Unknown encoding: " + r);
      var o = q(i, r) | 0, p = u(o), g = p.write(i, r);
      return g !== o && (p = p.slice(0, g)), p;
    }
    function $(i) {
      for (var r = i.length < 0 ? 0 : f(i.length) | 0, o = u(r), p = 0; p < r; p += 1)
        o[p] = i[p] & 255;
      return o;
    }
    function v(i) {
      if (ut(i, Uint8Array)) {
        var r = new Uint8Array(i);
        return S(r.buffer, r.byteOffset, r.byteLength);
      }
      return $(i);
    }
    function S(i, r, o) {
      if (r < 0 || i.byteLength < r)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (i.byteLength < r + (o || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var p;
      return r === void 0 && o === void 0 ? p = new Uint8Array(i) : o === void 0 ? p = new Uint8Array(i, r) : p = new Uint8Array(i, r, o), Object.setPrototypeOf(p, a.prototype), p;
    }
    function A(i) {
      if (a.isBuffer(i)) {
        var r = f(i.length) | 0, o = u(r);
        return o.length === 0 || i.copy(o, 0, 0, r), o;
      }
      if (i.length !== void 0)
        return typeof i.length != "number" || Gt(i.length) ? u(0) : $(i);
      if (i.type === "Buffer" && Array.isArray(i.data))
        return $(i.data);
    }
    function f(i) {
      if (i >= c)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + c.toString(16) + " bytes");
      return i | 0;
    }
    function y(i) {
      return +i != i && (i = 0), a.alloc(+i);
    }
    a.isBuffer = function(r) {
      return r != null && r._isBuffer === !0 && r !== a.prototype;
    }, a.compare = function(r, o) {
      if (ut(r, Uint8Array) && (r = a.from(r, r.offset, r.byteLength)), ut(o, Uint8Array) && (o = a.from(o, o.offset, o.byteLength)), !a.isBuffer(r) || !a.isBuffer(o))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (r === o)
        return 0;
      for (var p = r.length, g = o.length, w = 0, x = Math.min(p, g); w < x; ++w)
        if (r[w] !== o[w]) {
          p = r[w], g = o[w];
          break;
        }
      return p < g ? -1 : g < p ? 1 : 0;
    }, a.isEncoding = function(r) {
      switch (String(r).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(r, o) {
      if (!Array.isArray(r))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (r.length === 0)
        return a.alloc(0);
      var p;
      if (o === void 0)
        for (o = 0, p = 0; p < r.length; ++p)
          o += r[p].length;
      var g = a.allocUnsafe(o), w = 0;
      for (p = 0; p < r.length; ++p) {
        var x = r[p];
        if (ut(x, Uint8Array))
          w + x.length > g.length ? a.from(x).copy(g, w) : Uint8Array.prototype.set.call(
            g,
            x,
            w
          );
        else if (a.isBuffer(x))
          x.copy(g, w);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        w += x.length;
      }
      return g;
    };
    function q(i, r) {
      if (a.isBuffer(i))
        return i.length;
      if (ArrayBuffer.isView(i) || ut(i, ArrayBuffer))
        return i.byteLength;
      if (typeof i != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof i
        );
      var o = i.length, p = arguments.length > 2 && arguments[2] === !0;
      if (!p && o === 0)
        return 0;
      for (var g = !1; ; )
        switch (r) {
          case "ascii":
          case "latin1":
          case "binary":
            return o;
          case "utf8":
          case "utf-8":
            return st(i).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return o * 2;
          case "hex":
            return o >>> 1;
          case "base64":
            return ct(i).length;
          default:
            if (g)
              return p ? -1 : st(i).length;
            r = ("" + r).toLowerCase(), g = !0;
        }
    }
    a.byteLength = q;
    function k(i, r, o) {
      var p = !1;
      if ((r === void 0 || r < 0) && (r = 0), r > this.length || ((o === void 0 || o > this.length) && (o = this.length), o <= 0) || (o >>>= 0, r >>>= 0, o <= r))
        return "";
      for (i || (i = "utf8"); ; )
        switch (i) {
          case "hex":
            return tt(this, r, o);
          case "utf8":
          case "utf-8":
            return R(this, r, o);
          case "ascii":
            return C(this, r, o);
          case "latin1":
          case "binary":
            return U(this, r, o);
          case "base64":
            return bt(this, r, o);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Q(this, r, o);
          default:
            if (p)
              throw new TypeError("Unknown encoding: " + i);
            i = (i + "").toLowerCase(), p = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function _(i, r, o) {
      var p = i[r];
      i[r] = i[o], i[o] = p;
    }
    a.prototype.swap16 = function() {
      var r = this.length;
      if (r % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var o = 0; o < r; o += 2)
        _(this, o, o + 1);
      return this;
    }, a.prototype.swap32 = function() {
      var r = this.length;
      if (r % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var o = 0; o < r; o += 4)
        _(this, o, o + 3), _(this, o + 1, o + 2);
      return this;
    }, a.prototype.swap64 = function() {
      var r = this.length;
      if (r % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var o = 0; o < r; o += 8)
        _(this, o, o + 7), _(this, o + 1, o + 6), _(this, o + 2, o + 5), _(this, o + 3, o + 4);
      return this;
    }, a.prototype.toString = function() {
      var r = this.length;
      return r === 0 ? "" : arguments.length === 0 ? R(this, 0, r) : k.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(r) {
      if (!a.isBuffer(r))
        throw new TypeError("Argument must be a Buffer");
      return this === r ? !0 : a.compare(this, r) === 0;
    }, a.prototype.inspect = function() {
      var r = "", o = t.INSPECT_MAX_BYTES;
      return r = this.toString("hex", 0, o).replace(/(.{2})/g, "$1 ").trim(), this.length > o && (r += " ... "), "<Buffer " + r + ">";
    }, s && (a.prototype[s] = a.prototype.inspect), a.prototype.compare = function(r, o, p, g, w) {
      if (ut(r, Uint8Array) && (r = a.from(r, r.offset, r.byteLength)), !a.isBuffer(r))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof r
        );
      if (o === void 0 && (o = 0), p === void 0 && (p = r ? r.length : 0), g === void 0 && (g = 0), w === void 0 && (w = this.length), o < 0 || p > r.length || g < 0 || w > this.length)
        throw new RangeError("out of range index");
      if (g >= w && o >= p)
        return 0;
      if (g >= w)
        return -1;
      if (o >= p)
        return 1;
      if (o >>>= 0, p >>>= 0, g >>>= 0, w >>>= 0, this === r)
        return 0;
      for (var x = w - g, P = p - o, M = Math.min(x, P), j = this.slice(g, w), rt = r.slice(o, p), J = 0; J < M; ++J)
        if (j[J] !== rt[J]) {
          x = j[J], P = rt[J];
          break;
        }
      return x < P ? -1 : P < x ? 1 : 0;
    };
    function N(i, r, o, p, g) {
      if (i.length === 0)
        return -1;
      if (typeof o == "string" ? (p = o, o = 0) : o > 2147483647 ? o = 2147483647 : o < -2147483648 && (o = -2147483648), o = +o, Gt(o) && (o = g ? 0 : i.length - 1), o < 0 && (o = i.length + o), o >= i.length) {
        if (g)
          return -1;
        o = i.length - 1;
      } else if (o < 0)
        if (g)
          o = 0;
        else
          return -1;
      if (typeof r == "string" && (r = a.from(r, p)), a.isBuffer(r))
        return r.length === 0 ? -1 : D(i, r, o, p, g);
      if (typeof r == "number")
        return r = r & 255, typeof Uint8Array.prototype.indexOf == "function" ? g ? Uint8Array.prototype.indexOf.call(i, r, o) : Uint8Array.prototype.lastIndexOf.call(i, r, o) : D(i, [r], o, p, g);
      throw new TypeError("val must be string, number or Buffer");
    }
    function D(i, r, o, p, g) {
      var w = 1, x = i.length, P = r.length;
      if (p !== void 0 && (p = String(p).toLowerCase(), p === "ucs2" || p === "ucs-2" || p === "utf16le" || p === "utf-16le")) {
        if (i.length < 2 || r.length < 2)
          return -1;
        w = 2, x /= 2, P /= 2, o /= 2;
      }
      function M(Hn, Gn) {
        return w === 1 ? Hn[Gn] : Hn.readUInt16BE(Gn * w);
      }
      var j;
      if (g) {
        var rt = -1;
        for (j = o; j < x; j++)
          if (M(i, j) === M(r, rt === -1 ? 0 : j - rt)) {
            if (rt === -1 && (rt = j), j - rt + 1 === P)
              return rt * w;
          } else
            rt !== -1 && (j -= j - rt), rt = -1;
      } else
        for (o + P > x && (o = x - P), j = o; j >= 0; j--) {
          for (var J = !0, be = 0; be < P; be++)
            if (M(i, j + be) !== M(r, be)) {
              J = !1;
              break;
            }
          if (J)
            return j;
        }
      return -1;
    }
    a.prototype.includes = function(r, o, p) {
      return this.indexOf(r, o, p) !== -1;
    }, a.prototype.indexOf = function(r, o, p) {
      return N(this, r, o, p, !0);
    }, a.prototype.lastIndexOf = function(r, o, p) {
      return N(this, r, o, p, !1);
    };
    function z(i, r, o, p) {
      o = Number(o) || 0;
      var g = i.length - o;
      p ? (p = Number(p), p > g && (p = g)) : p = g;
      var w = r.length;
      p > w / 2 && (p = w / 2);
      for (var x = 0; x < p; ++x) {
        var P = parseInt(r.substr(x * 2, 2), 16);
        if (Gt(P))
          return x;
        i[o + x] = P;
      }
      return x;
    }
    function nt(i, r, o, p) {
      return It(st(r, i.length - o), i, o, p);
    }
    function Et(i, r, o, p) {
      return It(wt(r), i, o, p);
    }
    function kt(i, r, o, p) {
      return It(ct(r), i, o, p);
    }
    function Dt(i, r, o, p) {
      return It(xt(r, i.length - o), i, o, p);
    }
    a.prototype.write = function(r, o, p, g) {
      if (o === void 0)
        g = "utf8", p = this.length, o = 0;
      else if (p === void 0 && typeof o == "string")
        g = o, p = this.length, o = 0;
      else if (isFinite(o))
        o = o >>> 0, isFinite(p) ? (p = p >>> 0, g === void 0 && (g = "utf8")) : (g = p, p = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var w = this.length - o;
      if ((p === void 0 || p > w) && (p = w), r.length > 0 && (p < 0 || o < 0) || o > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      g || (g = "utf8");
      for (var x = !1; ; )
        switch (g) {
          case "hex":
            return z(this, r, o, p);
          case "utf8":
          case "utf-8":
            return nt(this, r, o, p);
          case "ascii":
          case "latin1":
          case "binary":
            return Et(this, r, o, p);
          case "base64":
            return kt(this, r, o, p);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return Dt(this, r, o, p);
          default:
            if (x)
              throw new TypeError("Unknown encoding: " + g);
            g = ("" + g).toLowerCase(), x = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function bt(i, r, o) {
      return r === 0 && o === i.length ? e.fromByteArray(i) : e.fromByteArray(i.slice(r, o));
    }
    function R(i, r, o) {
      o = Math.min(i.length, o);
      for (var p = [], g = r; g < o; ) {
        var w = i[g], x = null, P = w > 239 ? 4 : w > 223 ? 3 : w > 191 ? 2 : 1;
        if (g + P <= o) {
          var M, j, rt, J;
          switch (P) {
            case 1:
              w < 128 && (x = w);
              break;
            case 2:
              M = i[g + 1], (M & 192) === 128 && (J = (w & 31) << 6 | M & 63, J > 127 && (x = J));
              break;
            case 3:
              M = i[g + 1], j = i[g + 2], (M & 192) === 128 && (j & 192) === 128 && (J = (w & 15) << 12 | (M & 63) << 6 | j & 63, J > 2047 && (J < 55296 || J > 57343) && (x = J));
              break;
            case 4:
              M = i[g + 1], j = i[g + 2], rt = i[g + 3], (M & 192) === 128 && (j & 192) === 128 && (rt & 192) === 128 && (J = (w & 15) << 18 | (M & 63) << 12 | (j & 63) << 6 | rt & 63, J > 65535 && J < 1114112 && (x = J));
          }
        }
        x === null ? (x = 65533, P = 1) : x > 65535 && (x -= 65536, p.push(x >>> 10 & 1023 | 55296), x = 56320 | x & 1023), p.push(x), g += P;
      }
      return X(p);
    }
    var W = 4096;
    function X(i) {
      var r = i.length;
      if (r <= W)
        return String.fromCharCode.apply(String, i);
      for (var o = "", p = 0; p < r; )
        o += String.fromCharCode.apply(
          String,
          i.slice(p, p += W)
        );
      return o;
    }
    function C(i, r, o) {
      var p = "";
      o = Math.min(i.length, o);
      for (var g = r; g < o; ++g)
        p += String.fromCharCode(i[g] & 127);
      return p;
    }
    function U(i, r, o) {
      var p = "";
      o = Math.min(i.length, o);
      for (var g = r; g < o; ++g)
        p += String.fromCharCode(i[g]);
      return p;
    }
    function tt(i, r, o) {
      var p = i.length;
      (!r || r < 0) && (r = 0), (!o || o < 0 || o > p) && (o = p);
      for (var g = "", w = r; w < o; ++w)
        g += me[i[w]];
      return g;
    }
    function Q(i, r, o) {
      for (var p = i.slice(r, o), g = "", w = 0; w < p.length - 1; w += 2)
        g += String.fromCharCode(p[w] + p[w + 1] * 256);
      return g;
    }
    a.prototype.slice = function(r, o) {
      var p = this.length;
      r = ~~r, o = o === void 0 ? p : ~~o, r < 0 ? (r += p, r < 0 && (r = 0)) : r > p && (r = p), o < 0 ? (o += p, o < 0 && (o = 0)) : o > p && (o = p), o < r && (o = r);
      var g = this.subarray(r, o);
      return Object.setPrototypeOf(g, a.prototype), g;
    };
    function O(i, r, o) {
      if (i % 1 !== 0 || i < 0)
        throw new RangeError("offset is not uint");
      if (i + r > o)
        throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(r, o, p) {
      r = r >>> 0, o = o >>> 0, p || O(r, o, this.length);
      for (var g = this[r], w = 1, x = 0; ++x < o && (w *= 256); )
        g += this[r + x] * w;
      return g;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(r, o, p) {
      r = r >>> 0, o = o >>> 0, p || O(r, o, this.length);
      for (var g = this[r + --o], w = 1; o > 0 && (w *= 256); )
        g += this[r + --o] * w;
      return g;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(r, o) {
      return r = r >>> 0, o || O(r, 1, this.length), this[r];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(r, o) {
      return r = r >>> 0, o || O(r, 2, this.length), this[r] | this[r + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(r, o) {
      return r = r >>> 0, o || O(r, 2, this.length), this[r] << 8 | this[r + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), (this[r] | this[r + 1] << 8 | this[r + 2] << 16) + this[r + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), this[r] * 16777216 + (this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3]);
    }, a.prototype.readIntLE = function(r, o, p) {
      r = r >>> 0, o = o >>> 0, p || O(r, o, this.length);
      for (var g = this[r], w = 1, x = 0; ++x < o && (w *= 256); )
        g += this[r + x] * w;
      return w *= 128, g >= w && (g -= Math.pow(2, 8 * o)), g;
    }, a.prototype.readIntBE = function(r, o, p) {
      r = r >>> 0, o = o >>> 0, p || O(r, o, this.length);
      for (var g = o, w = 1, x = this[r + --g]; g > 0 && (w *= 256); )
        x += this[r + --g] * w;
      return w *= 128, x >= w && (x -= Math.pow(2, 8 * o)), x;
    }, a.prototype.readInt8 = function(r, o) {
      return r = r >>> 0, o || O(r, 1, this.length), this[r] & 128 ? (255 - this[r] + 1) * -1 : this[r];
    }, a.prototype.readInt16LE = function(r, o) {
      r = r >>> 0, o || O(r, 2, this.length);
      var p = this[r] | this[r + 1] << 8;
      return p & 32768 ? p | 4294901760 : p;
    }, a.prototype.readInt16BE = function(r, o) {
      r = r >>> 0, o || O(r, 2, this.length);
      var p = this[r + 1] | this[r] << 8;
      return p & 32768 ? p | 4294901760 : p;
    }, a.prototype.readInt32LE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), this[r] | this[r + 1] << 8 | this[r + 2] << 16 | this[r + 3] << 24;
    }, a.prototype.readInt32BE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), this[r] << 24 | this[r + 1] << 16 | this[r + 2] << 8 | this[r + 3];
    }, a.prototype.readFloatLE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), n.read(this, r, !0, 23, 4);
    }, a.prototype.readFloatBE = function(r, o) {
      return r = r >>> 0, o || O(r, 4, this.length), n.read(this, r, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(r, o) {
      return r = r >>> 0, o || O(r, 8, this.length), n.read(this, r, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(r, o) {
      return r = r >>> 0, o || O(r, 8, this.length), n.read(this, r, !1, 52, 8);
    };
    function Y(i, r, o, p, g, w) {
      if (!a.isBuffer(i))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (r > g || r < w)
        throw new RangeError('"value" argument is out of bounds');
      if (o + p > i.length)
        throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(r, o, p, g) {
      if (r = +r, o = o >>> 0, p = p >>> 0, !g) {
        var w = Math.pow(2, 8 * p) - 1;
        Y(this, r, o, p, w, 0);
      }
      var x = 1, P = 0;
      for (this[o] = r & 255; ++P < p && (x *= 256); )
        this[o + P] = r / x & 255;
      return o + p;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(r, o, p, g) {
      if (r = +r, o = o >>> 0, p = p >>> 0, !g) {
        var w = Math.pow(2, 8 * p) - 1;
        Y(this, r, o, p, w, 0);
      }
      var x = p - 1, P = 1;
      for (this[o + x] = r & 255; --x >= 0 && (P *= 256); )
        this[o + x] = r / P & 255;
      return o + p;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 1, 255, 0), this[o] = r & 255, o + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 2, 65535, 0), this[o] = r & 255, this[o + 1] = r >>> 8, o + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 2, 65535, 0), this[o] = r >>> 8, this[o + 1] = r & 255, o + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 4, 4294967295, 0), this[o + 3] = r >>> 24, this[o + 2] = r >>> 16, this[o + 1] = r >>> 8, this[o] = r & 255, o + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 4, 4294967295, 0), this[o] = r >>> 24, this[o + 1] = r >>> 16, this[o + 2] = r >>> 8, this[o + 3] = r & 255, o + 4;
    }, a.prototype.writeIntLE = function(r, o, p, g) {
      if (r = +r, o = o >>> 0, !g) {
        var w = Math.pow(2, 8 * p - 1);
        Y(this, r, o, p, w - 1, -w);
      }
      var x = 0, P = 1, M = 0;
      for (this[o] = r & 255; ++x < p && (P *= 256); )
        r < 0 && M === 0 && this[o + x - 1] !== 0 && (M = 1), this[o + x] = (r / P >> 0) - M & 255;
      return o + p;
    }, a.prototype.writeIntBE = function(r, o, p, g) {
      if (r = +r, o = o >>> 0, !g) {
        var w = Math.pow(2, 8 * p - 1);
        Y(this, r, o, p, w - 1, -w);
      }
      var x = p - 1, P = 1, M = 0;
      for (this[o + x] = r & 255; --x >= 0 && (P *= 256); )
        r < 0 && M === 0 && this[o + x + 1] !== 0 && (M = 1), this[o + x] = (r / P >> 0) - M & 255;
      return o + p;
    }, a.prototype.writeInt8 = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 1, 127, -128), r < 0 && (r = 255 + r + 1), this[o] = r & 255, o + 1;
    }, a.prototype.writeInt16LE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 2, 32767, -32768), this[o] = r & 255, this[o + 1] = r >>> 8, o + 2;
    }, a.prototype.writeInt16BE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 2, 32767, -32768), this[o] = r >>> 8, this[o + 1] = r & 255, o + 2;
    }, a.prototype.writeInt32LE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 4, 2147483647, -2147483648), this[o] = r & 255, this[o + 1] = r >>> 8, this[o + 2] = r >>> 16, this[o + 3] = r >>> 24, o + 4;
    }, a.prototype.writeInt32BE = function(r, o, p) {
      return r = +r, o = o >>> 0, p || Y(this, r, o, 4, 2147483647, -2147483648), r < 0 && (r = 4294967295 + r + 1), this[o] = r >>> 24, this[o + 1] = r >>> 16, this[o + 2] = r >>> 8, this[o + 3] = r & 255, o + 4;
    };
    function ft(i, r, o, p, g, w) {
      if (o + p > i.length)
        throw new RangeError("Index out of range");
      if (o < 0)
        throw new RangeError("Index out of range");
    }
    function yt(i, r, o, p, g) {
      return r = +r, o = o >>> 0, g || ft(i, r, o, 4), n.write(i, r, o, p, 23, 4), o + 4;
    }
    a.prototype.writeFloatLE = function(r, o, p) {
      return yt(this, r, o, !0, p);
    }, a.prototype.writeFloatBE = function(r, o, p) {
      return yt(this, r, o, !1, p);
    };
    function gt(i, r, o, p, g) {
      return r = +r, o = o >>> 0, g || ft(i, r, o, 8), n.write(i, r, o, p, 52, 8), o + 8;
    }
    a.prototype.writeDoubleLE = function(r, o, p) {
      return gt(this, r, o, !0, p);
    }, a.prototype.writeDoubleBE = function(r, o, p) {
      return gt(this, r, o, !1, p);
    }, a.prototype.copy = function(r, o, p, g) {
      if (!a.isBuffer(r))
        throw new TypeError("argument should be a Buffer");
      if (p || (p = 0), !g && g !== 0 && (g = this.length), o >= r.length && (o = r.length), o || (o = 0), g > 0 && g < p && (g = p), g === p || r.length === 0 || this.length === 0)
        return 0;
      if (o < 0)
        throw new RangeError("targetStart out of bounds");
      if (p < 0 || p >= this.length)
        throw new RangeError("Index out of range");
      if (g < 0)
        throw new RangeError("sourceEnd out of bounds");
      g > this.length && (g = this.length), r.length - o < g - p && (g = r.length - o + p);
      var w = g - p;
      return this === r && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(o, p, g) : Uint8Array.prototype.set.call(
        r,
        this.subarray(p, g),
        o
      ), w;
    }, a.prototype.fill = function(r, o, p, g) {
      if (typeof r == "string") {
        if (typeof o == "string" ? (g = o, o = 0, p = this.length) : typeof p == "string" && (g = p, p = this.length), g !== void 0 && typeof g != "string")
          throw new TypeError("encoding must be a string");
        if (typeof g == "string" && !a.isEncoding(g))
          throw new TypeError("Unknown encoding: " + g);
        if (r.length === 1) {
          var w = r.charCodeAt(0);
          (g === "utf8" && w < 128 || g === "latin1") && (r = w);
        }
      } else
        typeof r == "number" ? r = r & 255 : typeof r == "boolean" && (r = Number(r));
      if (o < 0 || this.length < o || this.length < p)
        throw new RangeError("Out of range index");
      if (p <= o)
        return this;
      o = o >>> 0, p = p === void 0 ? this.length : p >>> 0, r || (r = 0);
      var x;
      if (typeof r == "number")
        for (x = o; x < p; ++x)
          this[x] = r;
      else {
        var P = a.isBuffer(r) ? r : a.from(r, g), M = P.length;
        if (M === 0)
          throw new TypeError('The value "' + r + '" is invalid for argument "value"');
        for (x = 0; x < p - o; ++x)
          this[x + o] = P[x % M];
      }
      return this;
    };
    var B = /[^+/0-9A-Za-z-_]/g;
    function vt(i) {
      if (i = i.split("=")[0], i = i.trim().replace(B, ""), i.length < 2)
        return "";
      for (; i.length % 4 !== 0; )
        i = i + "=";
      return i;
    }
    function st(i, r) {
      r = r || 1 / 0;
      for (var o, p = i.length, g = null, w = [], x = 0; x < p; ++x) {
        if (o = i.charCodeAt(x), o > 55295 && o < 57344) {
          if (!g) {
            if (o > 56319) {
              (r -= 3) > -1 && w.push(239, 191, 189);
              continue;
            } else if (x + 1 === p) {
              (r -= 3) > -1 && w.push(239, 191, 189);
              continue;
            }
            g = o;
            continue;
          }
          if (o < 56320) {
            (r -= 3) > -1 && w.push(239, 191, 189), g = o;
            continue;
          }
          o = (g - 55296 << 10 | o - 56320) + 65536;
        } else
          g && (r -= 3) > -1 && w.push(239, 191, 189);
        if (g = null, o < 128) {
          if ((r -= 1) < 0)
            break;
          w.push(o);
        } else if (o < 2048) {
          if ((r -= 2) < 0)
            break;
          w.push(
            o >> 6 | 192,
            o & 63 | 128
          );
        } else if (o < 65536) {
          if ((r -= 3) < 0)
            break;
          w.push(
            o >> 12 | 224,
            o >> 6 & 63 | 128,
            o & 63 | 128
          );
        } else if (o < 1114112) {
          if ((r -= 4) < 0)
            break;
          w.push(
            o >> 18 | 240,
            o >> 12 & 63 | 128,
            o >> 6 & 63 | 128,
            o & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return w;
    }
    function wt(i) {
      for (var r = [], o = 0; o < i.length; ++o)
        r.push(i.charCodeAt(o) & 255);
      return r;
    }
    function xt(i, r) {
      for (var o, p, g, w = [], x = 0; x < i.length && !((r -= 2) < 0); ++x)
        o = i.charCodeAt(x), p = o >> 8, g = o % 256, w.push(g), w.push(p);
      return w;
    }
    function ct(i) {
      return e.toByteArray(vt(i));
    }
    function It(i, r, o, p) {
      for (var g = 0; g < p && !(g + o >= r.length || g >= i.length); ++g)
        r[g + o] = i[g];
      return g;
    }
    function ut(i, r) {
      return i instanceof r || i != null && i.constructor != null && i.constructor.name != null && i.constructor.name === r.name;
    }
    function Gt(i) {
      return i !== i;
    }
    var me = function() {
      for (var i = "0123456789abcdef", r = new Array(256), o = 0; o < 16; ++o)
        for (var p = o * 16, g = 0; g < 16; ++g)
          r[p + g] = i[o] + i[g];
      return r;
    }();
  }(Xe)), Xe;
}
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var _r;
function Z_t() {
  return _r || (_r = 1, function(t, e) {
    var n = Mo(), s = n.Buffer;
    function c(u, a) {
      for (var d in u)
        a[d] = u[d];
    }
    s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? t.exports = n : (c(n, e), e.Buffer = l);
    function l(u, a, d) {
      return s(u, a, d);
    }
    l.prototype = Object.create(s.prototype), c(s, l), l.from = function(u, a, d) {
      if (typeof u == "number")
        throw new TypeError("Argument must not be a number");
      return s(u, a, d);
    }, l.alloc = function(u, a, d) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      var h = s(u);
      return a !== void 0 ? typeof d == "string" ? h.fill(a, d) : h.fill(a) : h.fill(0), h;
    }, l.allocUnsafe = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return s(u);
    }, l.allocUnsafeSlow = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return n.SlowBuffer(u);
    };
  }(ve, ve.exports)), ve.exports;
}
var Er;
function Q_t() {
  if (Er)
    return Je;
  Er = 1;
  var t = Z_t().Buffer, e = t.isEncoding || function(f) {
    switch (f = "" + f, f && f.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function n(f) {
    if (!f)
      return "utf8";
    for (var y; ; )
      switch (f) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return f;
        default:
          if (y)
            return;
          f = ("" + f).toLowerCase(), y = !0;
      }
  }
  function s(f) {
    var y = n(f);
    if (typeof y != "string" && (t.isEncoding === e || !e(f)))
      throw new Error("Unknown encoding: " + f);
    return y || f;
  }
  Je.StringDecoder = c;
  function c(f) {
    this.encoding = s(f);
    var y;
    switch (this.encoding) {
      case "utf16le":
        this.text = m, this.end = E, y = 4;
        break;
      case "utf8":
        this.fillLast = d, y = 4;
        break;
      case "base64":
        this.text = $, this.end = v, y = 3;
        break;
      default:
        this.write = S, this.end = A;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(y);
  }
  c.prototype.write = function(f) {
    if (f.length === 0)
      return "";
    var y, q;
    if (this.lastNeed) {
      if (y = this.fillLast(f), y === void 0)
        return "";
      q = this.lastNeed, this.lastNeed = 0;
    } else
      q = 0;
    return q < f.length ? y ? y + this.text(f, q) : this.text(f, q) : y || "";
  }, c.prototype.end = b, c.prototype.text = h, c.prototype.fillLast = function(f) {
    if (this.lastNeed <= f.length)
      return f.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    f.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, f.length), this.lastNeed -= f.length;
  };
  function l(f) {
    return f <= 127 ? 0 : f >> 5 === 6 ? 2 : f >> 4 === 14 ? 3 : f >> 3 === 30 ? 4 : f >> 6 === 2 ? -1 : -2;
  }
  function u(f, y, q) {
    var k = y.length - 1;
    if (k < q)
      return 0;
    var _ = l(y[k]);
    return _ >= 0 ? (_ > 0 && (f.lastNeed = _ - 1), _) : --k < q || _ === -2 ? 0 : (_ = l(y[k]), _ >= 0 ? (_ > 0 && (f.lastNeed = _ - 2), _) : --k < q || _ === -2 ? 0 : (_ = l(y[k]), _ >= 0 ? (_ > 0 && (_ === 2 ? _ = 0 : f.lastNeed = _ - 3), _) : 0));
  }
  function a(f, y, q) {
    if ((y[0] & 192) !== 128)
      return f.lastNeed = 0, "�";
    if (f.lastNeed > 1 && y.length > 1) {
      if ((y[1] & 192) !== 128)
        return f.lastNeed = 1, "�";
      if (f.lastNeed > 2 && y.length > 2 && (y[2] & 192) !== 128)
        return f.lastNeed = 2, "�";
    }
  }
  function d(f) {
    var y = this.lastTotal - this.lastNeed, q = a(this, f);
    if (q !== void 0)
      return q;
    if (this.lastNeed <= f.length)
      return f.copy(this.lastChar, y, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    f.copy(this.lastChar, y, 0, f.length), this.lastNeed -= f.length;
  }
  function h(f, y) {
    var q = u(this, f, y);
    if (!this.lastNeed)
      return f.toString("utf8", y);
    this.lastTotal = q;
    var k = f.length - (q - this.lastNeed);
    return f.copy(this.lastChar, 0, k), f.toString("utf8", y, k);
  }
  function b(f) {
    var y = f && f.length ? this.write(f) : "";
    return this.lastNeed ? y + "�" : y;
  }
  function m(f, y) {
    if ((f.length - y) % 2 === 0) {
      var q = f.toString("utf16le", y);
      if (q) {
        var k = q.charCodeAt(q.length - 1);
        if (k >= 55296 && k <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = f[f.length - 2], this.lastChar[1] = f[f.length - 1], q.slice(0, -1);
      }
      return q;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = f[f.length - 1], f.toString("utf16le", y, f.length - 1);
  }
  function E(f) {
    var y = f && f.length ? this.write(f) : "";
    if (this.lastNeed) {
      var q = this.lastTotal - this.lastNeed;
      return y + this.lastChar.toString("utf16le", 0, q);
    }
    return y;
  }
  function $(f, y) {
    var q = (f.length - y) % 3;
    return q === 0 ? f.toString("base64", y) : (this.lastNeed = 3 - q, this.lastTotal = 3, q === 1 ? this.lastChar[0] = f[f.length - 1] : (this.lastChar[0] = f[f.length - 2], this.lastChar[1] = f[f.length - 1]), f.toString("base64", y, f.length - q));
  }
  function v(f) {
    var y = f && f.length ? this.write(f) : "";
    return this.lastNeed ? y + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : y;
  }
  function S(f) {
    return f.toString(this.encoding);
  }
  function A(f) {
    return f && f.length ? this.write(f) : "";
  }
  return Je;
}
var Ze, xr;
function Ho() {
  if (xr)
    return Ze;
  xr = 1, Ze = c;
  var t = Ro, e = Lo.Writable, n = Q_t().StringDecoder, s = Mo().Buffer;
  function c(l, u) {
    var a = this._parser = new t(l, u), d = this._decoder = new n();
    e.call(this, { decodeStrings: !1 }), this.once("finish", function() {
      a.end(d.end());
    });
  }
  return Ne(c, e), c.prototype._write = function(l, u, a) {
    l instanceof s && (l = this._decoder.write(l)), this._parser.write(l), a();
  }, Ze;
}
var Qe, qr;
function K_t() {
  if (qr)
    return Qe;
  qr = 1, Qe = e;
  var t = Ho();
  function e(c) {
    t.call(this, new n(this), c);
  }
  Ne(e, t), e.prototype.readable = !0;
  function n(c) {
    this.scope = c;
  }
  var s = Re().EVENTS;
  return Object.keys(s).forEach(function(c) {
    if (s[c] === 0)
      n.prototype["on" + c] = function() {
        this.scope.emit(c);
      };
    else if (s[c] === 1)
      n.prototype["on" + c] = function(l) {
        this.scope.emit(c, l);
      };
    else if (s[c] === 2)
      n.prototype["on" + c] = function(l, u) {
        this.scope.emit(c, l, u);
      };
    else
      throw Error("wrong number of arguments!");
  }), Qe;
}
var Ke, Sr;
function tEt() {
  if (Sr)
    return Ke;
  Sr = 1, Ke = t;
  function t(n) {
    this._cbs = n || {};
  }
  var e = Re().EVENTS;
  return Object.keys(e).forEach(function(n) {
    if (e[n] === 0)
      n = "on" + n, t.prototype[n] = function() {
        this._cbs[n] && this._cbs[n]();
      };
    else if (e[n] === 1)
      n = "on" + n, t.prototype[n] = function(s) {
        this._cbs[n] && this._cbs[n](s);
      };
    else if (e[n] === 2)
      n = "on" + n, t.prototype[n] = function(s, c) {
        this._cbs[n] && this._cbs[n](s, c);
      };
    else
      throw Error("wrong number of arguments");
  }), Ke;
}
var tn, Tr;
function eEt() {
  if (Tr)
    return tn;
  Tr = 1, tn = t;
  function t(n) {
    this._cbs = n || {}, this.events = [];
  }
  var e = Re().EVENTS;
  return Object.keys(e).forEach(function(n) {
    if (e[n] === 0)
      n = "on" + n, t.prototype[n] = function() {
        this.events.push([n]), this._cbs[n] && this._cbs[n]();
      };
    else if (e[n] === 1)
      n = "on" + n, t.prototype[n] = function(s) {
        this.events.push([n, s]), this._cbs[n] && this._cbs[n](s);
      };
    else if (e[n] === 2)
      n = "on" + n, t.prototype[n] = function(s, c) {
        this.events.push([n, s, c]), this._cbs[n] && this._cbs[n](s, c);
      };
    else
      throw Error("wrong number of arguments");
  }), t.prototype.onreset = function() {
    this.events = [], this._cbs.onreset && this._cbs.onreset();
  }, t.prototype.restart = function() {
    this._cbs.onreset && this._cbs.onreset();
    for (var n = 0, s = this.events.length; n < s; n++)
      if (this._cbs[this.events[n][0]]) {
        var c = this.events[n].length;
        c === 1 ? this._cbs[this.events[n][0]]() : c === 2 ? this._cbs[this.events[n][0]](this.events[n][1]) : this._cbs[this.events[n][0]](
          this.events[n][1],
          this.events[n][2]
        );
      }
  }, tn;
}
var Ar;
function Re() {
  return Ar || (Ar = 1, function(t) {
    var e = Ro, n = Uo;
    function s(c, l) {
      return delete t.exports[c], t.exports[c] = l, l;
    }
    t.exports = {
      Parser: e,
      Tokenizer: Yr,
      ElementType: ge,
      DomHandler: n,
      get FeedHandler() {
        return s("FeedHandler", W_t());
      },
      get Stream() {
        return s("Stream", K_t());
      },
      get WritableStream() {
        return s("WritableStream", Ho());
      },
      get ProxyHandler() {
        return s("ProxyHandler", tEt());
      },
      get DomUtils() {
        return s("DomUtils", Vo());
      },
      get CollectingHandler() {
        return s(
          "CollectingHandler",
          eEt()
        );
      },
      // For legacy support
      DefaultHandler: n,
      get RssHandler() {
        return s("RssHandler", this.FeedHandler);
      },
      //helper methods
      parseDOM: function(c, l) {
        var u = new n(l);
        return new e(u, l).end(c), u.dom;
      },
      parseFeed: function(c, l) {
        var u = new t.exports.FeedHandler(l);
        return new e(u, l).end(c), u.dom;
      },
      createDomStream: function(c, l, u) {
        var a = new n(c, l, u);
        return new e(a, l);
      },
      // List of all events that the parser emits
      EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
      }
    };
  }(Fe)), Fe.exports;
}
var St = Re();
const nEt = /* @__PURE__ */ _n(St);
function rEt(t) {
  return t.type === "text" && /\r?\n/.test(t.data) && t.data.trim() === "";
}
function oEt(t) {
  return t.data;
}
const sEt = [
  "allowfullScreen",
  "async",
  "autoplay",
  "capture",
  "checked",
  "controls",
  "default",
  "defer",
  "disabled",
  "formnovalidate",
  "hidden",
  "loop",
  "multiple",
  "muted",
  "novalidate",
  "open",
  "playsinline",
  "readonly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  "selected",
  "itemscope"
], cEt = {
  /**
   * Standard Properties
   */
  accept: "accept",
  "accept-charset": "acceptCharset",
  accesskey: "accessKey",
  action: "action",
  allowfullscreen: "allowFullScreen",
  allowtransparency: "allowTransparency",
  alt: "alt",
  as: "as",
  async: "async",
  autocomplete: "autoComplete",
  autoplay: "autoPlay",
  capture: "capture",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  challenge: "challenge",
  checked: "checked",
  cite: "cite",
  classid: "classID",
  class: "className",
  cols: "cols",
  colspan: "colSpan",
  content: "content",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controls: "controls",
  controlsList: "controlsList",
  coords: "coords",
  crossorigin: "crossOrigin",
  data: "data",
  datetime: "dateTime",
  default: "default",
  defer: "defer",
  dir: "dir",
  disabled: "disabled",
  download: "download",
  draggable: "draggable",
  enctype: "encType",
  form: "form",
  formaction: "formAction",
  formenctype: "formEncType",
  formmethod: "formMethod",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  headers: "headers",
  height: "height",
  hidden: "hidden",
  high: "high",
  href: "href",
  hreflang: "hrefLang",
  for: "htmlFor",
  "http-equiv": "httpEquiv",
  icon: "icon",
  id: "id",
  inputmode: "inputMode",
  integrity: "integrity",
  is: "is",
  keyparams: "keyParams",
  keytype: "keyType",
  kind: "kind",
  label: "label",
  lang: "lang",
  list: "list",
  loop: "loop",
  low: "low",
  manifest: "manifest",
  marginheight: "marginHeight",
  marginwidth: "marginWidth",
  max: "max",
  maxlength: "maxLength",
  media: "media",
  mediagroup: "mediaGroup",
  method: "method",
  min: "min",
  minlength: "minLength",
  multiple: "multiple",
  muted: "muted",
  name: "name",
  nonce: "nonce",
  novalidate: "noValidate",
  open: "open",
  optimum: "optimum",
  pattern: "pattern",
  placeholder: "placeholder",
  playsinline: "playsInline",
  poster: "poster",
  preload: "preload",
  profile: "profile",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rel: "rel",
  required: "required",
  reversed: "reversed",
  role: "role",
  rows: "rows",
  rowspan: "rowSpan",
  sandbox: "sandbox",
  scope: "scope",
  scoped: "scoped",
  scrolling: "scrolling",
  seamless: "seamless",
  selected: "selected",
  shape: "shape",
  size: "size",
  sizes: "sizes",
  slot: "slot",
  span: "span",
  spellcheck: "spellCheck",
  src: "src",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  start: "start",
  step: "step",
  style: "style",
  summary: "summary",
  tabindex: "tabIndex",
  target: "target",
  title: "title",
  type: "type",
  usemap: "useMap",
  value: "value",
  width: "width",
  wmode: "wmode",
  wrap: "wrap",
  /**
   * RDFa Properties
   */
  about: "about",
  datatype: "datatype",
  inlist: "inlist",
  prefix: "prefix",
  property: "property",
  resource: "resource",
  typeof: "typeof",
  vocab: "vocab",
  /**
   * Non-standard Properties
   */
  autocapitalize: "autoCapitalize",
  autocorrect: "autoCorrect",
  autosave: "autoSave",
  color: "color",
  itemprop: "itemProp",
  itemscope: "itemScope",
  itemtype: "itemType",
  itemid: "itemID",
  itemref: "itemRef",
  results: "results",
  security: "security",
  unselectable: "unselectable"
}, iEt = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, en = {};
function Go(t) {
  return en.hasOwnProperty(t) || (en[t] = iEt.test(t)), en[t];
}
const aEt = function(t, e) {
  return sEt.map((s) => s.toLowerCase()).indexOf(t.toLowerCase()) >= 0 && (e = t), e;
};
function lEt(t) {
  return Object.keys(t).filter((e) => Go(e)).reduce(
    (e, n) => {
      const s = n.toLowerCase(), c = cEt[s] || s;
      return e[c] = aEt(c, t[n]), e;
    },
    {}
  );
}
function uEt(t = "") {
  return t === "" ? {} : t.split(";").reduce(
    (e, n) => {
      let [s, c] = n.split(/^([^:]+):/).filter((l, u) => u > 0).map((l) => l.trim().toLowerCase());
      return c === void 0 || (s = s.replace(/^-ms-/, "ms-").replace(/-(.)/g, (l, u) => u.toUpperCase()), e[s] = c), e;
    },
    {}
  );
}
function jo(t, e) {
  const n = Object.assign({}, lEt(t), { key: e });
  return typeof n.style == "string" || n.style instanceof String ? n.style = uEt(n.style) : delete n.style, n;
}
const pEt = [
  "area",
  "base",
  "br",
  "col",
  "command",
  "embed",
  "hr",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
function fEt(t, e, n) {
  const s = t.name;
  if (!Go(s))
    return null;
  const c = jo(t.attribs, e);
  let l = null;
  return pEt.indexOf(s) === -1 && (l = zo(t.children, n)), dt.createElement(s, c, l);
}
function dEt(t, e) {
  let n;
  t.children.length > 0 && (n = t.children[0].data);
  const s = jo(t.attribs, e);
  return dt.createElement("style", s, n);
}
function ae() {
  return null;
}
const hEt = {
  [St.ElementType.Text]: oEt,
  [St.ElementType.Tag]: fEt,
  [St.ElementType.Style]: dEt,
  [St.ElementType.Directive]: ae,
  [St.ElementType.Comment]: ae,
  [St.ElementType.Script]: ae,
  [St.ElementType.CDATA]: ae,
  [St.ElementType.Doctype]: ae
};
function gEt(t, e, n) {
  return hEt[t.type](t, e, n);
}
function zo(t, e) {
  return t.filter((n) => !rEt(n)).map((n, s) => {
    let c;
    return typeof e == "function" && (c = e(n, s), c === null || c) ? c : gEt(n, s, e);
  });
}
function $Et(t, {
  decodeEntities: e = !0,
  transform: n,
  preprocessNodes: s = (c) => c
} = {}) {
  const c = s(nEt.parseDOM(t, { decodeEntities: e }));
  return zo(c, n);
}
const mEt = (t) => /* @__PURE__ */ ot("div", { ...t, children: t.value && $Et(t.value) });
var it = function() {
  return it = Object.assign || function(e) {
    for (var n, s = 1, c = arguments.length; s < c; s++) {
      n = arguments[s];
      for (var l in n)
        Object.prototype.hasOwnProperty.call(n, l) && (e[l] = n[l]);
    }
    return e;
  }, it.apply(this, arguments);
};
function Jt(t, e, n) {
  if (n || arguments.length === 2)
    for (var s = 0, c = e.length, l; s < c; s++)
      (l || !(s in e)) && (l || (l = Array.prototype.slice.call(e, 0, s)), l[s] = e[s]);
  return t.concat(l || Array.prototype.slice.call(e));
}
function bEt(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var yEt = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, vEt = /* @__PURE__ */ bEt(
  function(t) {
    return yEt.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), wEt = function(e, n, s, c) {
  var l = s ? s.call(c, e, n) : void 0;
  if (l !== void 0)
    return !!l;
  if (e === n)
    return !0;
  if (typeof e != "object" || !e || typeof n != "object" || !n)
    return !1;
  var u = Object.keys(e), a = Object.keys(n);
  if (u.length !== a.length)
    return !1;
  for (var d = Object.prototype.hasOwnProperty.bind(n), h = 0; h < u.length; h++) {
    var b = u[h];
    if (!d(b))
      return !1;
    var m = e[b], E = n[b];
    if (l = s ? s.call(c, m, E, b) : void 0, l === !1 || l === void 0 && m !== E)
      return !1;
  }
  return !0;
};
const _Et = /* @__PURE__ */ _n(wEt);
var G = "-ms-", ue = "-moz-", F = "-webkit-", Yo = "comm", Ie = "rule", On = "decl", EEt = "@import", Wo = "@keyframes", xEt = "@layer", qEt = Math.abs, Un = String.fromCharCode, dn = Object.assign;
function SEt(t, e) {
  return K(t, 0) ^ 45 ? (((e << 2 ^ K(t, 0)) << 2 ^ K(t, 1)) << 2 ^ K(t, 2)) << 2 ^ K(t, 3) : 0;
}
function Jo(t) {
  return t.trim();
}
function Tt(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function I(t, e, n) {
  return t.replace(e, n);
}
function qe(t, e) {
  return t.indexOf(e);
}
function K(t, e) {
  return t.charCodeAt(e) | 0;
}
function Xt(t, e, n) {
  return t.slice(e, n);
}
function _t(t) {
  return t.length;
}
function Xo(t) {
  return t.length;
}
function le(t, e) {
  return e.push(t), t;
}
function TEt(t, e) {
  return t.map(e).join("");
}
function kr(t, e) {
  return t.filter(function(n) {
    return !Tt(n, e);
  });
}
var Be = 1, Zt = 1, Zo = 0, ht = 0, Z = 0, ne = "";
function Oe(t, e, n, s, c, l, u, a) {
  return { value: t, root: e, parent: n, type: s, props: c, children: l, line: Be, column: Zt, length: u, return: "", siblings: a };
}
function Nt(t, e) {
  return dn(Oe("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, e);
}
function zt(t) {
  for (; t.root; )
    t = Nt(t.root, { children: [t] });
  le(t, t.siblings);
}
function AEt() {
  return Z;
}
function kEt() {
  return Z = ht > 0 ? K(ne, --ht) : 0, Zt--, Z === 10 && (Zt = 1, Be--), Z;
}
function mt() {
  return Z = ht < Zo ? K(ne, ht++) : 0, Zt++, Z === 10 && (Zt = 1, Be++), Z;
}
function Pt() {
  return K(ne, ht);
}
function Se() {
  return ht;
}
function Ue(t, e) {
  return Xt(ne, t, e);
}
function hn(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function DEt(t) {
  return Be = Zt = 1, Zo = _t(ne = t), ht = 0, [];
}
function LEt(t) {
  return ne = "", t;
}
function nn(t) {
  return Jo(Ue(ht - 1, gn(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function CEt(t) {
  for (; (Z = Pt()) && Z < 33; )
    mt();
  return hn(t) > 2 || hn(Z) > 3 ? "" : " ";
}
function NEt(t, e) {
  for (; --e && mt() && !(Z < 48 || Z > 102 || Z > 57 && Z < 65 || Z > 70 && Z < 97); )
    ;
  return Ue(t, Se() + (e < 6 && Pt() == 32 && mt() == 32));
}
function gn(t) {
  for (; mt(); )
    switch (Z) {
      case t:
        return ht;
      case 34:
      case 39:
        t !== 34 && t !== 39 && gn(Z);
        break;
      case 40:
        t === 41 && gn(t);
        break;
      case 92:
        mt();
        break;
    }
  return ht;
}
function REt(t, e) {
  for (; mt() && t + Z !== 47 + 10; )
    if (t + Z === 42 + 42 && Pt() === 47)
      break;
  return "/*" + Ue(e, ht - 1) + "*" + Un(t === 47 ? t : mt());
}
function IEt(t) {
  for (; !hn(Pt()); )
    mt();
  return Ue(t, ht);
}
function BEt(t) {
  return LEt(Te("", null, null, null, [""], t = DEt(t), 0, [0], t));
}
function Te(t, e, n, s, c, l, u, a, d) {
  for (var h = 0, b = 0, m = u, E = 0, $ = 0, v = 0, S = 1, A = 1, f = 1, y = 0, q = "", k = c, _ = l, N = s, D = q; A; )
    switch (v = y, y = mt()) {
      case 40:
        if (v != 108 && K(D, m - 1) == 58) {
          qe(D += I(nn(y), "&", "&\f"), "&\f") != -1 && (f = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        D += nn(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        D += CEt(v);
        break;
      case 92:
        D += NEt(Se() - 1, 7);
        continue;
      case 47:
        switch (Pt()) {
          case 42:
          case 47:
            le(OEt(REt(mt(), Se()), e, n, d), d);
            break;
          default:
            D += "/";
        }
        break;
      case 123 * S:
        a[h++] = _t(D) * f;
      case 125 * S:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            A = 0;
          case 59 + b:
            f == -1 && (D = I(D, /\f/g, "")), $ > 0 && _t(D) - m && le($ > 32 ? Lr(D + ";", s, n, m - 1, d) : Lr(I(D, " ", "") + ";", s, n, m - 2, d), d);
            break;
          case 59:
            D += ";";
          default:
            if (le(N = Dr(D, e, n, h, b, c, a, q, k = [], _ = [], m, l), l), y === 123)
              if (b === 0)
                Te(D, e, N, N, k, l, m, a, _);
              else
                switch (E === 99 && K(D, 3) === 110 ? 100 : E) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Te(t, N, N, s && le(Dr(t, N, N, 0, 0, c, a, q, c, k = [], m, _), _), c, _, m, a, s ? k : _);
                    break;
                  default:
                    Te(D, N, N, N, [""], _, 0, a, _);
                }
        }
        h = b = $ = 0, S = f = 1, q = D = "", m = u;
        break;
      case 58:
        m = 1 + _t(D), $ = v;
      default:
        if (S < 1) {
          if (y == 123)
            --S;
          else if (y == 125 && S++ == 0 && kEt() == 125)
            continue;
        }
        switch (D += Un(y), y * S) {
          case 38:
            f = b > 0 ? 1 : (D += "\f", -1);
            break;
          case 44:
            a[h++] = (_t(D) - 1) * f, f = 1;
            break;
          case 64:
            Pt() === 45 && (D += nn(mt())), E = Pt(), b = m = _t(q = D += IEt(Se())), y++;
            break;
          case 45:
            v === 45 && _t(D) == 2 && (S = 0);
        }
    }
  return l;
}
function Dr(t, e, n, s, c, l, u, a, d, h, b, m) {
  for (var E = c - 1, $ = c === 0 ? l : [""], v = Xo($), S = 0, A = 0, f = 0; S < s; ++S)
    for (var y = 0, q = Xt(t, E + 1, E = qEt(A = u[S])), k = t; y < v; ++y)
      (k = Jo(A > 0 ? $[y] + " " + q : I(q, /&\f/g, $[y]))) && (d[f++] = k);
  return Oe(t, e, n, c === 0 ? Ie : a, d, h, b, m);
}
function OEt(t, e, n, s) {
  return Oe(t, e, n, Yo, Un(AEt()), Xt(t, 2, -2), 0, s);
}
function Lr(t, e, n, s, c) {
  return Oe(t, e, n, On, Xt(t, 0, s), Xt(t, s + 1, -1), s, c);
}
function Qo(t, e, n) {
  switch (SEt(t, e)) {
    case 5103:
      return F + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return F + t + t;
    case 4789:
      return ue + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return F + t + ue + t + G + t + t;
    case 5936:
      switch (K(t, e + 11)) {
        case 114:
          return F + t + G + I(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return F + t + G + I(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return F + t + G + I(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    case 6828:
    case 4268:
    case 2903:
      return F + t + G + t + t;
    case 6165:
      return F + t + G + "flex-" + t + t;
    case 5187:
      return F + t + I(t, /(\w+).+(:[^]+)/, F + "box-$1$2" + G + "flex-$1$2") + t;
    case 5443:
      return F + t + G + "flex-item-" + I(t, /flex-|-self/g, "") + (Tt(t, /flex-|baseline/) ? "" : G + "grid-row-" + I(t, /flex-|-self/g, "")) + t;
    case 4675:
      return F + t + G + "flex-line-pack" + I(t, /align-content|flex-|-self/g, "") + t;
    case 5548:
      return F + t + G + I(t, "shrink", "negative") + t;
    case 5292:
      return F + t + G + I(t, "basis", "preferred-size") + t;
    case 6060:
      return F + "box-" + I(t, "-grow", "") + F + t + G + I(t, "grow", "positive") + t;
    case 4554:
      return F + I(t, /([^-])(transform)/g, "$1" + F + "$2") + t;
    case 6187:
      return I(I(I(t, /(zoom-|grab)/, F + "$1"), /(image-set)/, F + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return I(t, /(image-set\([^]*)/, F + "$1$`$1");
    case 4968:
      return I(I(t, /(.+:)(flex-)?(.*)/, F + "box-pack:$3" + G + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + F + t + t;
    case 4200:
      if (!Tt(t, /flex-|baseline/))
        return G + "grid-column-align" + Xt(t, e) + t;
      break;
    case 2592:
    case 3360:
      return G + I(t, "template-", "") + t;
    case 4384:
    case 3616:
      return n && n.some(function(s, c) {
        return e = c, Tt(s.props, /grid-\w+-end/);
      }) ? ~qe(t + (n = n[e].value), "span") ? t : G + I(t, "-start", "") + t + G + "grid-row-span:" + (~qe(n, "span") ? Tt(n, /\d+/) : +Tt(n, /\d+/) - +Tt(t, /\d+/)) + ";" : G + I(t, "-start", "") + t;
    case 4896:
    case 4128:
      return n && n.some(function(s) {
        return Tt(s.props, /grid-\w+-start/);
      }) ? t : G + I(I(t, "-end", "-span"), "span ", "") + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return I(t, /(.+)-inline(.+)/, F + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (_t(t) - 1 - e > 6)
        switch (K(t, e + 1)) {
          case 109:
            if (K(t, e + 4) !== 45)
              break;
          case 102:
            return I(t, /(.+:)(.+)-([^]+)/, "$1" + F + "$2-$3$1" + ue + (K(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~qe(t, "stretch") ? Qo(I(t, "stretch", "fill-available"), e, n) + t : t;
        }
      break;
    case 5152:
    case 5920:
      return I(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(s, c, l, u, a, d, h) {
        return G + c + ":" + l + h + (u ? G + c + "-span:" + (a ? d : +d - +l) + h : "") + t;
      });
    case 4949:
      if (K(t, e + 6) === 121)
        return I(t, ":", ":" + F) + t;
      break;
    case 6444:
      switch (K(t, K(t, 14) === 45 ? 18 : 11)) {
        case 120:
          return I(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + F + (K(t, 14) === 45 ? "inline-" : "") + "box$3$1" + F + "$2$3$1" + G + "$2box$3") + t;
        case 100:
          return I(t, ":", ":" + G) + t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return I(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function ke(t, e) {
  for (var n = "", s = 0; s < t.length; s++)
    n += e(t[s], s, t, e) || "";
  return n;
}
function UEt(t, e, n, s) {
  switch (t.type) {
    case xEt:
      if (t.children.length)
        break;
    case EEt:
    case On:
      return t.return = t.return || t.value;
    case Yo:
      return "";
    case Wo:
      return t.return = t.value + "{" + ke(t.children, s) + "}";
    case Ie:
      if (!_t(t.value = t.props.join(",")))
        return "";
  }
  return _t(n = ke(t.children, s)) ? t.return = t.value + "{" + n + "}" : "";
}
function PEt(t) {
  var e = Xo(t);
  return function(n, s, c, l) {
    for (var u = "", a = 0; a < e; a++)
      u += t[a](n, s, c, l) || "";
    return u;
  };
}
function FEt(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function VEt(t, e, n, s) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case On:
        t.return = Qo(t.value, t.length, n);
        return;
      case Wo:
        return ke([Nt(t, { value: I(t.value, "@", "@" + F) })], s);
      case Ie:
        if (t.length)
          return TEt(n = t.props, function(c) {
            switch (Tt(c, s = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                zt(Nt(t, { props: [I(c, /:(read-\w+)/, ":" + ue + "$1")] })), zt(Nt(t, { props: [c] })), dn(t, { props: kr(n, s) });
                break;
              case "::placeholder":
                zt(Nt(t, { props: [I(c, /:(plac\w+)/, ":" + F + "input-$1")] })), zt(Nt(t, { props: [I(c, /:(plac\w+)/, ":" + ue + "$1")] })), zt(Nt(t, { props: [I(c, /:(plac\w+)/, G + "input-$1")] })), zt(Nt(t, { props: [c] })), dn(t, { props: kr(n, s) });
                break;
            }
            return "";
          });
    }
}
var MEt = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Vt = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Pn = typeof window < "u" && "HTMLElement" in window, HEt = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), Cr = /invalid hook call/i, _e = /* @__PURE__ */ new Set(), GEt = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var n = e ? ' with the id of "'.concat(e, '"') : "", s = "The component ".concat(t).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, c = console.error;
    try {
      var l = !0;
      console.error = function(u) {
        for (var a = [], d = 1; d < arguments.length; d++)
          a[d - 1] = arguments[d];
        Cr.test(u) ? (l = !1, _e.delete(s)) : c.apply(void 0, Jt([u], a, !1));
      }, un(), l && !_e.has(s) && (console.warn(s), _e.add(s));
    } catch (u) {
      Cr.test(u.message) && _e.delete(s);
    } finally {
      console.error = c;
    }
  }
}, Pe = Object.freeze([]), Qt = Object.freeze({});
function jEt(t, e, n) {
  return n === void 0 && (n = Qt), t.theme !== n.theme && t.theme || e || n.theme;
}
var $n = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), zEt = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, YEt = /(^-|-$)/g;
function Nr(t) {
  return t.replace(zEt, "-").replace(YEt, "");
}
var WEt = /(a)(d)/gi, Rr = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function mn(t) {
  var e, n = "";
  for (e = Math.abs(t); e > 52; e = e / 52 | 0)
    n = Rr(e % 52) + n;
  return (Rr(e % 52) + n).replace(WEt, "$1-$2");
}
var rn, Ot = function(t, e) {
  for (var n = e.length; n; )
    t = 33 * t ^ e.charCodeAt(--n);
  return t;
}, Ko = function(t) {
  return Ot(5381, t);
};
function JEt(t) {
  return mn(Ko(t) >>> 0);
}
function ts(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function on(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var es = typeof Symbol == "function" && Symbol.for, ns = es ? Symbol.for("react.memo") : 60115, XEt = es ? Symbol.for("react.forward_ref") : 60112, ZEt = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, QEt = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, rs = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, KEt = ((rn = {})[XEt] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, rn[ns] = rs, rn);
function Ir(t) {
  return ("type" in (e = t) && e.type.$$typeof) === ns ? rs : "$$typeof" in t ? KEt[t.$$typeof] : ZEt;
  var e;
}
var txt = Object.defineProperty, ext = Object.getOwnPropertyNames, Br = Object.getOwnPropertySymbols, nxt = Object.getOwnPropertyDescriptor, rxt = Object.getPrototypeOf, Or = Object.prototype;
function os(t, e, n) {
  if (typeof e != "string") {
    if (Or) {
      var s = rxt(e);
      s && s !== Or && os(t, s, n);
    }
    var c = ext(e);
    Br && (c = c.concat(Br(e)));
    for (var l = Ir(t), u = Ir(e), a = 0; a < c.length; ++a) {
      var d = c[a];
      if (!(d in QEt || n && n[d] || u && d in u || l && d in l)) {
        var h = nxt(e, d);
        try {
          txt(t, d, h);
        } catch {
        }
      }
    }
  }
  return t;
}
function Kt(t) {
  return typeof t == "function";
}
function Fn(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function Ut(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function Ur(t, e) {
  if (t.length === 0)
    return "";
  for (var n = t[0], s = 1; s < t.length; s++)
    n += e ? e + t[s] : t[s];
  return n;
}
function te(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function bn(t, e, n) {
  if (n === void 0 && (n = !1), !n && !te(t) && !Array.isArray(t))
    return e;
  if (Array.isArray(e))
    for (var s = 0; s < e.length; s++)
      t[s] = bn(t[s], e[s]);
  else if (te(e))
    for (var s in e)
      t[s] = bn(t[s], e[s]);
  return t;
}
function Vn(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var oxt = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function sxt() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var n = t[0], s = [], c = 1, l = t.length; c < l; c += 1)
    s.push(t[c]);
  return s.forEach(function(u) {
    n = n.replace(/%[a-z]/, u);
  }), n;
}
function re(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(sxt.apply(void 0, Jt([oxt[t]], e, !1)).trim());
}
var cxt = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var n = 0, s = 0; s < e; s++)
      n += this.groupSizes[s];
    return n;
  }, t.prototype.insertRules = function(e, n) {
    if (e >= this.groupSizes.length) {
      for (var s = this.groupSizes, c = s.length, l = c; e >= l; )
        if ((l <<= 1) < 0)
          throw re(16, "".concat(e));
      this.groupSizes = new Uint32Array(l), this.groupSizes.set(s), this.length = l;
      for (var u = c; u < l; u++)
        this.groupSizes[u] = 0;
    }
    for (var a = this.indexOfGroup(e + 1), d = (u = 0, n.length); u < d; u++)
      this.tag.insertRule(a, n[u]) && (this.groupSizes[e]++, a++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var n = this.groupSizes[e], s = this.indexOfGroup(e), c = s + n;
      this.groupSizes[e] = 0;
      for (var l = s; l < c; l++)
        this.tag.deleteRule(s);
    }
  }, t.prototype.getGroup = function(e) {
    var n = "";
    if (e >= this.length || this.groupSizes[e] === 0)
      return n;
    for (var s = this.groupSizes[e], c = this.indexOfGroup(e), l = c + s, u = c; u < l; u++)
      n += "".concat(this.tag.getRule(u)).concat(`/*!sc*/
`);
    return n;
  }, t;
}(), Ae = /* @__PURE__ */ new Map(), De = /* @__PURE__ */ new Map(), sn = 1, Ee = function(t) {
  if (Ae.has(t))
    return Ae.get(t);
  for (; De.has(sn); )
    sn++;
  var e = sn++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > 1073741824))
    throw re(16, "".concat(e));
  return Ae.set(t, e), De.set(e, t), e;
}, ixt = function(t, e) {
  Ae.set(t, e), De.set(e, t);
}, axt = "style[".concat(Vt, "][").concat("data-styled-version", '="').concat("6.0.7", '"]'), lxt = new RegExp("^".concat(Vt, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), uxt = function(t, e, n) {
  for (var s, c = n.split(","), l = 0, u = c.length; l < u; l++)
    (s = c[l]) && t.registerName(e, s);
}, pxt = function(t, e) {
  for (var n, s = ((n = e.textContent) !== null && n !== void 0 ? n : "").split(`/*!sc*/
`), c = [], l = 0, u = s.length; l < u; l++) {
    var a = s[l].trim();
    if (a) {
      var d = a.match(lxt);
      if (d) {
        var h = 0 | parseInt(d[1], 10), b = d[2];
        h !== 0 && (ixt(b, h), uxt(t, b, d[3]), t.getTag().insertRules(h, c)), c.length = 0;
      } else
        c.push(a);
    }
  }
};
function fxt() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var ss = function(t) {
  var e = document.head, n = t || e, s = document.createElement("style"), c = function(a) {
    var d = Array.from(a.querySelectorAll("style[".concat(Vt, "]")));
    return d[d.length - 1];
  }(n), l = c !== void 0 ? c.nextSibling : null;
  s.setAttribute(Vt, "active"), s.setAttribute("data-styled-version", "6.0.7");
  var u = fxt();
  return u && s.setAttribute("nonce", u), n.insertBefore(s, l), s;
}, dxt = function() {
  function t(e) {
    this.element = ss(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var s = document.styleSheets, c = 0, l = s.length; c < l; c++) {
        var u = s[c];
        if (u.ownerNode === n)
          return u;
      }
      throw re(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    try {
      return this.sheet.insertRule(n, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var n = this.sheet.cssRules[e];
    return n && n.cssText ? n.cssText : "";
  }, t;
}(), hxt = function() {
  function t(e) {
    this.element = ss(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    if (e <= this.length && e >= 0) {
      var s = document.createTextNode(n);
      return this.element.insertBefore(s, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), gxt = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    return e <= this.length && (this.rules.splice(e, 0, n), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), Pr = Pn, $xt = { isServer: !Pn, useCSSOMInjection: !HEt }, cs = function() {
  function t(e, n, s) {
    e === void 0 && (e = Qt), n === void 0 && (n = {});
    var c = this;
    this.options = it(it({}, $xt), e), this.gs = n, this.names = new Map(s), this.server = !!e.isServer, !this.server && Pn && Pr && (Pr = !1, function(l) {
      for (var u = document.querySelectorAll(axt), a = 0, d = u.length; a < d; a++) {
        var h = u[a];
        h && h.getAttribute(Vt) !== "active" && (pxt(l, h), h.parentNode && h.parentNode.removeChild(h));
      }
    }(this)), Vn(this, function() {
      return function(l) {
        for (var u = l.getTag(), a = u.length, d = "", h = function(m) {
          var E = function(f) {
            return De.get(f);
          }(m);
          if (E === void 0)
            return "continue";
          var $ = l.names.get(E), v = u.getGroup(m);
          if ($ === void 0 || v.length === 0)
            return "continue";
          var S = "".concat(Vt, ".g").concat(m, '[id="').concat(E, '"]'), A = "";
          $ !== void 0 && $.forEach(function(f) {
            f.length > 0 && (A += "".concat(f, ","));
          }), d += "".concat(v).concat(S, '{content:"').concat(A, '"}').concat(`/*!sc*/
`);
        }, b = 0; b < a; b++)
          h(b);
        return d;
      }(c);
    });
  }
  return t.registerId = function(e) {
    return Ee(e);
  }, t.prototype.reconstructWithOptions = function(e, n) {
    return n === void 0 && (n = !0), new t(it(it({}, this.options), e), this.gs, n && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = function(n) {
      var s = n.useCSSOMInjection, c = n.target;
      return n.isServer ? new gxt(c) : s ? new dxt(c) : new hxt(c);
    }(this.options), new cxt(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, n) {
    return this.names.has(e) && this.names.get(e).has(n);
  }, t.prototype.registerName = function(e, n) {
    if (Ee(e), this.names.has(e))
      this.names.get(e).add(n);
    else {
      var s = /* @__PURE__ */ new Set();
      s.add(n), this.names.set(e, s);
    }
  }, t.prototype.insertRules = function(e, n, s) {
    this.registerName(e, n), this.getTag().insertRules(Ee(e), s);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup(Ee(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}(), mxt = /&/g, bxt = /^\s*\/\/.*$/gm;
function is(t, e) {
  return t.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(e, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(e, " ")), n.props = n.props.map(function(s) {
      return "".concat(e, " ").concat(s);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = is(n.children, e)), n;
  });
}
function as(t) {
  var e, n, s, c = t === void 0 ? Qt : t, l = c.options, u = l === void 0 ? Qt : l, a = c.plugins, d = a === void 0 ? Pe : a, h = function(E, $, v) {
    return v === n || v.startsWith(n) && v.endsWith(n) && v.replaceAll(n, "").length > 0 ? ".".concat(e) : E;
  }, b = d.slice();
  b.push(function(E) {
    E.type === Ie && E.value.includes("&") && (E.props[0] = E.props[0].replace(mxt, n).replace(s, h));
  }), u.prefix && b.push(VEt), b.push(UEt);
  var m = function(E, $, v, S) {
    $ === void 0 && ($ = ""), v === void 0 && (v = ""), S === void 0 && (S = "&"), e = S, n = $, s = new RegExp("\\".concat(n, "\\b"), "g");
    var A = E.replace(bxt, ""), f = BEt(v || $ ? "".concat(v, " ").concat($, " { ").concat(A, " }") : A);
    u.namespace && (f = is(f, u.namespace));
    var y = [];
    return ke(f, PEt(b.concat(FEt(function(q) {
      return y.push(q);
    })))), y;
  };
  return m.hash = d.length ? d.reduce(function(E, $) {
    return $.name || re(15), Ot(E, $.name);
  }, 5381).toString() : "", m;
}
var yxt = new cs(), yn = as(), Mn = dt.createContext({ shouldForwardProp: void 0, styleSheet: yxt, stylis: yn });
Mn.Consumer;
var vxt = dt.createContext(void 0);
function vn() {
  return hs(Mn);
}
function wxt(t) {
  var e = ln(t.stylisPlugins), n = e[0], s = e[1], c = vn().styleSheet, l = Yt(function() {
    var a = c;
    return t.sheet ? a = t.sheet : t.target && (a = a.reconstructWithOptions({ target: t.target }, !1)), t.disableCSSOMInjection && (a = a.reconstructWithOptions({ useCSSOMInjection: !1 })), a;
  }, [t.disableCSSOMInjection, t.sheet, t.target, c]), u = Yt(function() {
    return as({ options: { namespace: t.namespace, prefix: t.enableVendorPrefixes }, plugins: n });
  }, [t.enableVendorPrefixes, t.namespace, n]);
  return ds(function() {
    _Et(n, t.stylisPlugins) || s(t.stylisPlugins);
  }, [t.stylisPlugins]), dt.createElement(Mn.Provider, { value: { shouldForwardProp: t.shouldForwardProp, styleSheet: l, stylis: u } }, dt.createElement(vxt.Provider, { value: u }, t.children));
}
var Fr = function() {
  function t(e, n) {
    var s = this;
    this.inject = function(c, l) {
      l === void 0 && (l = yn);
      var u = s.name + l.hash;
      c.hasNameForId(s.id, u) || c.insertRules(s.id, u, l(s.rules, u, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = n, Vn(this, function() {
      throw re(12, String(s.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = yn), this.name + e.hash;
  }, t;
}(), _xt = function(t) {
  return t >= "A" && t <= "Z";
};
function Vr(t) {
  for (var e = "", n = 0; n < t.length; n++) {
    var s = t[n];
    if (n === 1 && s === "-" && t[0] === "-")
      return t;
    _xt(s) ? e += "-" + s.toLowerCase() : e += s;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var ls = function(t) {
  return t == null || t === !1 || t === "";
}, us = function(t) {
  var e, n, s = [];
  for (var c in t) {
    var l = t[c];
    t.hasOwnProperty(c) && !ls(l) && (Array.isArray(l) && l.isCss || Kt(l) ? s.push("".concat(Vr(c), ":"), l, ";") : te(l) ? s.push.apply(s, Jt(Jt(["".concat(c, " {")], us(l), !1), ["}"], !1)) : s.push("".concat(Vr(c), ": ").concat((e = c, (n = l) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || e in MEt || e.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return s;
};
function Ft(t, e, n, s) {
  if (ls(t))
    return [];
  if (Fn(t))
    return [".".concat(t.styledComponentId)];
  if (Kt(t)) {
    if (!Kt(l = t) || l.prototype && l.prototype.isReactComponent || !e)
      return [t];
    var c = t(e);
    return process.env.NODE_ENV === "production" || typeof c != "object" || Array.isArray(c) || c instanceof Fr || te(c) || c === null || console.error("".concat(ts(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Ft(c, e, n, s);
  }
  var l;
  return t instanceof Fr ? n ? (t.inject(n, s), [t.getName(s)]) : [t] : te(t) ? us(t) : Array.isArray(t) ? Array.prototype.concat.apply(Pe, t.map(function(u) {
    return Ft(u, e, n, s);
  })) : [t.toString()];
}
function Ext(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (Kt(n) && !Fn(n))
      return !1;
  }
  return !0;
}
var xxt = Ko("6.0.7"), qxt = function() {
  function t(e, n, s) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (s === void 0 || s.isStatic) && Ext(e), this.componentId = n, this.baseHash = Ot(xxt, n), this.baseStyle = s, cs.registerId(n);
  }
  return t.prototype.generateAndInjectStyles = function(e, n, s) {
    var c = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, n, s) : "";
    if (this.isStatic && !s.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        c = Ut(c, this.staticRulesId);
      else {
        var l = Ur(Ft(this.rules, e, n, s)), u = mn(Ot(this.baseHash, l) >>> 0);
        if (!n.hasNameForId(this.componentId, u)) {
          var a = s(l, ".".concat(u), void 0, this.componentId);
          n.insertRules(this.componentId, u, a);
        }
        c = Ut(c, u), this.staticRulesId = u;
      }
    else {
      for (var d = Ot(this.baseHash, s.hash), h = "", b = 0; b < this.rules.length; b++) {
        var m = this.rules[b];
        if (typeof m == "string")
          h += m, process.env.NODE_ENV !== "production" && (d = Ot(d, m));
        else if (m) {
          var E = Ur(Ft(m, e, n, s));
          d = Ot(d, E), h += E;
        }
      }
      if (h) {
        var $ = mn(d >>> 0);
        n.hasNameForId(this.componentId, $) || n.insertRules(this.componentId, $, s(h, ".".concat($), void 0, this.componentId)), c = Ut(c, $);
      }
    }
    return c;
  }, t;
}(), ps = dt.createContext(void 0);
ps.Consumer;
var cn = {}, Mr = /* @__PURE__ */ new Set();
function Sxt(t, e, n) {
  var s = Fn(t), c = t, l = !on(t), u = e.attrs, a = u === void 0 ? Pe : u, d = e.componentId, h = d === void 0 ? function(k, _) {
    var N = typeof k != "string" ? "sc" : Nr(k);
    cn[N] = (cn[N] || 0) + 1;
    var D = "".concat(N, "-").concat(JEt("6.0.7" + N + cn[N]));
    return _ ? "".concat(_, "-").concat(D) : D;
  }(e.displayName, e.parentComponentId) : d, b = e.displayName, m = b === void 0 ? function(k) {
    return on(k) ? "styled.".concat(k) : "Styled(".concat(ts(k), ")");
  }(t) : b, E = e.displayName && e.componentId ? "".concat(Nr(e.displayName), "-").concat(e.componentId) : e.componentId || h, $ = s && c.attrs ? c.attrs.concat(a).filter(Boolean) : a, v = e.shouldForwardProp;
  if (s && c.shouldForwardProp) {
    var S = c.shouldForwardProp;
    if (e.shouldForwardProp) {
      var A = e.shouldForwardProp;
      v = function(k, _) {
        return S(k, _) && A(k, _);
      };
    } else
      v = S;
  }
  var f = new qxt(n, E, s ? c.componentStyle : void 0);
  function y(k, _) {
    return function(N, D, z) {
      var nt = N.attrs, Et = N.componentStyle, kt = N.defaultProps, Dt = N.foldedComponentIds, bt = N.styledComponentId, R = N.target, W = dt.useContext(ps), X = vn(), C = N.shouldForwardProp || X.shouldForwardProp;
      process.env.NODE_ENV !== "production" && jn(bt);
      var U = function(yt, gt, B) {
        for (var vt, st = it(it({}, gt), { className: void 0, theme: B }), wt = 0; wt < yt.length; wt += 1) {
          var xt = Kt(vt = yt[wt]) ? vt(st) : vt;
          for (var ct in xt)
            st[ct] = ct === "className" ? Ut(st[ct], xt[ct]) : ct === "style" ? it(it({}, st[ct]), xt[ct]) : xt[ct];
        }
        return gt.className && (st.className = Ut(st.className, gt.className)), st;
      }(nt, D, jEt(D, W, kt) || Qt), tt = U.as || R, Q = {};
      for (var O in U)
        U[O] === void 0 || O[0] === "$" || O === "as" || O === "theme" || (O === "forwardedAs" ? Q.as = U.forwardedAs : C && !C(O, tt) || (Q[O] = U[O], C || process.env.NODE_ENV !== "development" || vEt(O) || Mr.has(O) || !$n.has(tt) || (Mr.add(O), console.warn('styled-components: it looks like an unknown prop "'.concat(O, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var Y = function(yt, gt) {
        var B = vn(), vt = yt.generateAndInjectStyles(gt, B.styleSheet, B.stylis);
        return process.env.NODE_ENV !== "production" && jn(vt), vt;
      }(Et, U);
      process.env.NODE_ENV !== "production" && N.warnTooManyClasses && N.warnTooManyClasses(Y);
      var ft = Ut(Dt, bt);
      return Y && (ft += " " + Y), U.className && (ft += " " + U.className), Q[on(tt) && !$n.has(tt) ? "class" : "className"] = ft, Q.ref = z, gs(tt, Q);
    }(q, k, _);
  }
  process.env.NODE_ENV !== "production" && (y.displayName = m);
  var q = dt.forwardRef(y);
  return q.attrs = $, q.componentStyle = f, q.shouldForwardProp = v, process.env.NODE_ENV !== "production" && (q.displayName = m), q.foldedComponentIds = s ? Ut(c.foldedComponentIds, c.styledComponentId) : "", q.styledComponentId = E, q.target = s ? c.target : t, Object.defineProperty(q, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(k) {
    this._foldedDefaultProps = s ? function(_) {
      for (var N = [], D = 1; D < arguments.length; D++)
        N[D - 1] = arguments[D];
      for (var z = 0, nt = N; z < nt.length; z++)
        bn(_, nt[z], !0);
      return _;
    }({}, c.defaultProps, k) : k;
  } }), process.env.NODE_ENV !== "production" && (GEt(m, E), q.warnTooManyClasses = function(k, _) {
    var N = {}, D = !1;
    return function(z) {
      if (!D && (N[z] = !0, Object.keys(N).length >= 200)) {
        var nt = _ ? ' with the id of "'.concat(_, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(k).concat(nt, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), D = !0, N = {};
      }
    };
  }(m, E)), Vn(q, function() {
    return ".".concat(q.styledComponentId);
  }), l && os(q, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), q;
}
function Hr(t, e) {
  for (var n = [t[0]], s = 0, c = e.length; s < c; s += 1)
    n.push(e[s], t[s + 1]);
  return n;
}
var Gr = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function Txt(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  if (Kt(t) || te(t)) {
    var s = t;
    return Gr(Ft(Hr(Pe, Jt([s], e, !0))));
  }
  var c = t;
  return e.length === 0 && c.length === 1 && typeof c[0] == "string" ? Ft(c) : Gr(Ft(Hr(c, e)));
}
function wn(t, e, n) {
  if (n === void 0 && (n = Qt), !e)
    throw re(1, e);
  var s = function(c) {
    for (var l = [], u = 1; u < arguments.length; u++)
      l[u - 1] = arguments[u];
    return t(e, n, Txt.apply(void 0, Jt([c], l, !1)));
  };
  return s.attrs = function(c) {
    return wn(t, e, it(it({}, n), { attrs: Array.prototype.concat(n.attrs, c).filter(Boolean) }));
  }, s.withConfig = function(c) {
    return wn(t, e, it(it({}, n), c));
  }, s;
}
var fs = function(t) {
  return wn(Sxt, t);
}, $e = fs;
$n.forEach(function(t) {
  $e[t] = fs(t);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var xe = "__sc-".concat(Vt, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[xe] || (window[xe] = 0), window[xe] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[xe] += 1);
const { useToken: Axt } = Le, kxt = $e.div`
  .templateEditor {
    position: relative;
    min-height: 100px;
    height: auto;
  }
  .templateEditorOverlay {
    /*background-color: red;*/
    position: absolute !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .templateEditorOverlay:not(:hover) {
    border-color: ${({ $token: t }) => t.colorBorder} !important;
  }
  .emailEditor {
    width: 100%;
    min-height: calc(100vh - 300px);
  }

  .templateEditorDisplay {
    position: relative;
    width: 100%;
  }

  .template-click-here {
    background-color: white;
    color: ${({ $token: t }) => t.colorText};
    border: 1px solid ${({ $token: t }) => t.colorBorder};
    padding: 8px 16px;
    width: min-content;
  }
`, Dxt = qs, Lxt = ({
  editorProps: t,
  value: e,
  onChange: n,
  mergeTags: s
}) => {
  const [c, l] = ln(!1), [u, a] = ln(!1), d = un(null), h = un(), b = zn(() => {
    d.current !== void 0 && d.current !== null && h.current && n && (a(!0), d.current.exportHtml((v) => {
      n({
        design: JSON.stringify(v.design),
        html: v.html,
        mergeTags: e?.mergeTags
      }), a(!1), l(!1);
    }));
  }, [n, e?.mergeTags]), m = zn(() => {
    d.current !== void 0 && d.current !== null && h.current && e?.design !== void 0 && d.current?.loadDesign?.(JSON.parse(e.design));
  }, [e]), E = Yt(() => {
    try {
      return s ? e?.mergeTags ? JSON.parse(e?.mergeTags) : void 0 : t?.options?.mergeTags;
    } catch {
      return;
    }
  }, [t?.options?.mergeTags, s, e?.mergeTags]), { token: $ } = Axt();
  return /* @__PURE__ */ an(kxt, { $token: $, children: [
    s && /* @__PURE__ */ ot(
      zr.TextArea,
      {
        placeholder: "Merge Tags. (Enter merge tags as a valid JSON)",
        value: e?.mergeTags,
        onChange: (v) => n?.({
          ...e ?? { design: "", html: "" },
          mergeTags: v.target.value
        })
      }
    ),
    /* @__PURE__ */ an("div", { className: "templateEditorDisplay", children: [
      e && /* @__PURE__ */ ot(mEt, { value: e.html }),
      /* @__PURE__ */ ot(
        ms,
        {
          className: "templateEditorOverlay",
          ghost: !0,
          onClick: () => l(!0),
          children: /* @__PURE__ */ ot("div", { className: "template-click-here", children: "Click here to edit template" })
        }
      )
    ] }),
    /* @__PURE__ */ ot(
      bs,
      {
        style: { top: 16 },
        title: "Template",
        open: c,
        onOk: b,
        onCancel: () => l(!1),
        okText: "Save",
        confirmLoading: u,
        cancelText: "Cancel",
        destroyOnClose: !0,
        width: "100%",
        closable: !0,
        children: /* @__PURE__ */ ot(
          Dxt,
          {
            style: { width: "100%", minHeight: "calc(100vh - 176px)" },
            ref: (v) => {
              d.current = v, m();
            },
            projectId: 3657,
            onLoad: () => {
              h.current = !0, m();
            },
            ...t,
            options: {
              ...t?.options,
              mergeTags: E
            }
          }
        )
      }
    )
  ] });
};
const { useToken: Cxt } = Le, Nxt = dt.lazy(() => import("react-quill")), Rxt = (t, ...e) => Yt(() => {
  const n = { ...t };
  return e.forEach((s) => delete n[s]), n;
}, [t, e]), jr = /(<([^>]+)>)/gi, Ixt = $e.div`
  .richText {
    display: flex;
    flex-direction: column;
    justify-content: right;
  }

  .richTextCount {
    width: 100%;
    text-align: right;
    padding: 4px;
    margin-bottom: -26px;
  }

  .ql-toolbar {
    transition: all 0.3s;
    border: 1px solid ${({ $token: t }) => t.colorBorder};
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .ql-container {
    min-height: 100px;
    transition: all 0.3s;
    font-family: ${({ $token: t }) => t.fontFamily};
    font-size: ${({ $token: t }) => t.fontSize}px;
    border: 1px solid ${({ $token: t }) => t.colorBorder};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .quill:hover {
    .ql-toolbar {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-inline-end-width: 1px;
    }
    .ql-container {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-inline-end-width: 1px;
    }
  }

  .quill:focus-within {
    .ql-toolbar {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(3, 73, 104, 0.2);
    }
    .ql-container {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(3, 73, 104, 0.2);
    }
  }

  .rich-text-char-count {
    display: flex;
    width: 100%;
    justify-content: right;
    margin-top: 8px;
  }
`, Bxt = (t) => {
  const e = Yt(
    () => [
      // 'header',
      "bold",
      "italic",
      "underline",
      // 'strike',
      "list",
      "bullet",
      "indent",
      "link"
      // 'color',
      // 'background',
    ],
    []
  ), n = Yt(
    () => ({
      toolbar: [
        // [{ header: [3, 4, 5, 6, false] }],
        ["bold", "italic", "underline"],
        // [{ color: [] }, { background: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link"],
        ["clean"]
      ],
      clipboard: {
        matchVisual: !1
      }
    }),
    []
  ), s = Rxt(t, "value", "onChange"), c = (u) => {
    t.value?.length > (t.maxLength ?? 1e6) && u.key !== "Backspace" && u.preventDefault();
  }, { token: l } = Cxt();
  return typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? /* @__PURE__ */ ot(zr.TextArea, {}) : /* @__PURE__ */ an(Ixt, { $token: l, children: [
    /* @__PURE__ */ ot(
      Nxt,
      {
        onKeyDown: c,
        modules: n,
        theme: "snow",
        preserveWhitespace: !0,
        value: t.value ? t.value : "",
        onChange: (u) => t.onChange && t.onChange(u),
        formats: e,
        ...s
      }
    ),
    t.showCount && /* @__PURE__ */ ot("div", { className: "rich-text-char-count", children: t.maxLength ? `${t.maxLength - (t.value?.replace(jr, "").length ?? 0)}` : `${t.value?.replace(jr, "").length ?? 0}` })
  ] });
}, Oxt = (t) => /* @__PURE__ */ ot($s, { children: /* @__PURE__ */ ot(Bxt, { ...t }) });
const { useToken: Uxt } = Le, Pxt = $e.div`
  position: relative;
  .PhoneInput {
    height: ${({ $token: t }) => t.Input?.controlHeight ?? t.controlHeight}px;
    width: 100%;

    .PhoneInputInput {
      box-sizing: border-box;
      margin: 0;
      height: ${({ $token: t }) => t.Input?.controlHeight ?? t.controlHeight}px;
      font-variant: tabular-nums;
      list-style: none;
      font-feature-settings: 'tnum', 'tnum';
      position: relative;
      display: inline-block;
      width: 100%;
      min-width: 0;
      padding: 4px 11px 4px 60px;
      color: ${({ $token: t }) => t.colorText};
      font-size: ${({ $token: t }) => t.fontSize}px;
      line-height: 1.5715;
      background-color: #fff;
      background-image: none;
      border: 1px solid ${({ $token: t }) => t.colorBorder};
      border-radius: ${({ $token: t }) => t.borderRadius}px;
      transition: all 0.3s;
      margin-left: -43px;
    }

    .PhoneInputInput:hover {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-inline-end-width: 1px;
    }

    .PhoneInputInput:focus {
      border-color: ${({ $token: t }) => t.colorPrimary};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px rgba(3, 73, 104, 0.2);
    }

    .PhoneInputCountrySelect {
      z-index: 2;
      width: 60px;
    }

    .PhoneInputCountryIcon {
      width: 28px;
      height: 20px;
      z-index: 1;
      transform: translateX(18px);
    }

    .PhoneInputCountryIcon--border {
      border: none;
    }
  }
`, Fxt = (t) => {
  const { token: e } = Uxt();
  return /* @__PURE__ */ ot(Pxt, { $token: e, children: /* @__PURE__ */ ot(ys, { ...t, value: t.value ?? "" }) });
}, Vxt = {
  name: "phone",
  message: "Should be valid phone number",
  validator: async (t, e) => {
    if (!(e === void 0 || e === "") && !(!e || vs(e)))
      throw Error("Invalid phone number");
  }
}, Jxt = {
  phone: Yn(Fxt, {
    encode: (t) => t === "" ? void 0 : t,
    decode: (t) => t ?? "",
    className: ""
  }),
  richText: Yn(Oxt, {
    encode: (t) => {
      if (!(t && t.replace(/<[^>]+>/g, "").trim() === ""))
        return t;
    }
  }),
  template: Lxt
}, Xxt = [
  Vxt
], { useToken: Mxt } = Le, Hxt = $e.div`
  .ant-form-item-has-error .PhoneInputInput {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
  }

  .ant-form-item-has-error .PhoneInputInput:focus {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
    box-shadow: 0 0 0 2px rgba(255, 38, 5, 0.06) !important;
  }

  .ant-form-item-has-error .ql-toolbar {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
  }
  .ant-form-item-has-error .ql-container {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
  }

  .ant-form-item-has-error .quill:focus-within .ql-toolbar {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
    box-shadow: 0 0 0 2px rgba(255, 38, 5, 0.06) !important;
  }
  .ant-form-item-has-error .quill:focus-within .ql-container {
    border-color: ${({ $token: t }) => t.colorErrorBorder} !important;
    box-shadow: 0 0 0 2px rgba(255, 38, 5, 0.06) !important;
  }


  .templateEditor {
    position: relative;
    min-height: 100px;
    height: auto;
  }

  .templateEditorOverlay {
    /*background-color: red;*/
    position: absolute !important;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-height: 100px;
  }

  .emailEditor {
    width: 100%;
    min-height: calc(100vh - 300px);
  }

  .templateEditorDisplay {
    position: relative;
    width: 100%;
  }

`, Zxt = (t) => {
  const { token: e } = Mxt();
  return /* @__PURE__ */ ot(wxt, { sheet: t.sheet, children: /* @__PURE__ */ ot(Hxt, { $token: e, children: t.children }) });
};
export {
  Zxt as AntdSchemaFormAdapterProvider,
  Jxt as AntdSchemaFormAdapters,
  Xxt as AntdSchemaFormValidationAdapters,
  Lxt as HtmlTemplateInput,
  mEt as HtmlView,
  Fxt as PhoneInput,
  Vxt as PhoneValidationAdapter,
  Oxt as RichTextInput,
  Bxt as RichTextInputInt,
  Ixt as RichTextWrapper
};
